var _defs, _defs2, _defs3, _defs4, _defs5, _defs6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBookWorldM(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "32.2942 66.5242 448.4307 402.3586",
    width: "448.431px",
    height: "402.359px",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "object-10",
    transform: "matrix(1, 0, 0, 1, -3.0203320980071737, -1.455070972442627)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.25707, 0, 0, 0.16546, 1214.72998, 12753)",
    id: "object-2"
  }, /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#F7AAB5"
    },
    cx: -3783.019,
    cy: -74570.352,
    rx: 555.897,
    ry: 188.609
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.435453, 0, 0, 0.435453, 3288.800049, 11496)",
    id: "object-3"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FEEAED"
    },
    d: "M6923.943-25513.424c-0.834-0.176-1.301-0.031-2.068-0.439 c-1.171-0.625-1.927-1.859-2.894-2.842c-10.326-10.518-21.859-23.738-34.462-38.998c-38.821-47.012-87.46-113.742-136.225-186.41 c-15.895-23.68-31.726-48.047-47.191-72.594c-37.471-59.482-72.8-120.027-101.82-174.52c-6.103-11.471-15.94-30.813-19.758-49.256 c-2.815-13.605-2.304-26.732,4.584-36.309c5.859-8.143,14.114-9.709,24.171-5.871c8.337,3.182,18.09,10.348,28.615,20.277 c49.636,46.844,118.053,156.08,141.733,176.715c1.853,1.611,7.484,6.91,12.908,10.328c3.248,2.049,6.209,3.963,7.864,2.463 c3.813-3.5,4.698-9.074,3.658-16.236c-2.394-16.484-15.174-40.744-32.063-69.176c-35.498-59.768-89.469-137.459-109.675-198.098 c-11.166-33.518-11.805-62.029,5.155-80.189c11.28-12.07,23.745-11.984,37.03-2.795c11.334,7.838,23.395,22.844,35.729,42.564 c36.332,58.074,75.977,157.4,110.659,229.273c15.783,32.709,30.43,59.723,43.528,74.236c5.726,6.344,10.951,10.291,15.911,10.734 c0.913,0.084,0.97-1.131,1.386-2.396c0.793-2.41,1.201-5.68,1.397-9.221c0.563-10.25-0.729-22.682-1.092-24.512 c-3.639-18.252-28.802-101.795-26.199-131.645c0.663-7.602,3.356-11.92,7.72-12.1c3.808-0.154,9.571,3.158,17.452,11.566 c3.948,4.209,7.348,8.793,10.399,13.6c4.541,7.164,8.305,14.832,11.878,22.537c0.296,0.631,0.022,1.383-0.609,1.68 c-0.63,0.295-1.383,0.021-1.679-0.609c-3.579-7.574-7.321-15.123-11.87-22.145c-3-4.631-6.356-9.025-10.231-13.055 c-7.027-7.299-11.845-10.572-15.188-10.395c-2.174,0.117-3.269,2.096-3.957,5.121c-1.073,4.725-0.84,11.871,0.207,20.453 c4.454,36.576,23.9,98.557,27.19,113.934c0.538,2.506,2.986,23.83,0.533,34.691c-1.266,5.604-4.247,8.572-7.821,8.301 c-6.073-0.465-12.837-4.746-19.927-12.432c-13.541-14.672-29-41.986-45.286-75.305c-34.941-71.49-74.143-170.68-110.331-228.607 c-11.707-18.734-22.992-33.117-33.742-40.586c-10.06-6.982-19.525-7.35-28.098,1.781c-15.574,16.576-13.995,42.729-3.886,73.443 c19.862,60.354,73.54,137.59,108.235,197.344c17.009,29.287,29.397,54.486,31.604,71.402c1.157,8.879-0.47,15.639-5.245,19.9 c-2.209,1.986-6.041,1.613-10.239-0.574c-6.313-3.287-13.824-10.172-16.06-12.09c-23.848-20.416-93.146-129.039-143.211-175.375 c-9.861-9.125-18.913-15.791-26.688-18.66c-6.788-2.508-12.438-1.846-16.315,3.672c-5.755,8.178-5.623,19.357-3.109,30.869 c3.859,17.672,13.574,36.117,19.558,47.068c35.128,64.406,79.912,136.881,125.141,206.816 c19.133,29.584,38.199,58.813,56.976,86.58c39.669,58.66,77.773,110.92,108.056,149.115c9.633,12.152,18.397,22.928,26.28,31.967 c0.611,0.703,1.429,1.254,1.81,2.08c0.383,0.838,0.185,1.33,0.318,2.223c0.193,0.205,0.182,0.531-0.021,0.723 C6924.459-25513.209,6924.136-25513.219,6923.943-25513.424z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1.89787, -5.7701, -5.215, 1.54965, 4086.25, 14590)",
    id: "object-4"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#EDB14D"
    },
    d: "M2421.417-156.502c-0.967-0.742-2.085-1.213-2.997-2.033 c-0.97-0.871-1.934-1.922-2.495-3.116c-0.287-0.611-0.461-1.679,0.596-1.324c0.858,0.288,1.494,1.186,2.011,1.879 c1.109,1.488,2.03,3.075,2.915,4.703"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#EDB14D"
    },
    d: "M2421.295-159.933c-0.769-0.782-1.498-1.597-2.219-2.423 c-0.784-0.899-1.572-1.93-1.969-3.069c-0.154-0.44-0.495-1.555,0.432-1.098c0.772,0.38,1.242,1.148,1.659,1.87 c0.773,1.336,1.524,2.815,2.001,4.294"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#EDB14D"
    },
    d: "M2421.896-163.379c-0.713-0.694-1.371-1.47-1.982-2.254 c-0.37-0.474-0.704-0.976-1.017-1.489c-0.388-0.638-0.832-1.377-0.885-2.142c-0.077-1.108,1.31-0.175,1.608,0.206 c1.035,1.32,1.872,3.501,2.201,5.186"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#EDB14D"
    },
    d: "M2422.866-167.532c-0.625-0.875-1.344-1.673-1.93-2.579 c-0.584-0.904-1.073-1.92-1.283-2.983c-0.114-0.577-0.155-1.223,0.64-0.743c0.077,0.046,0.188,0.141,0.249,0.198 c0.485,0.464,0.753,1.172,1.011,1.779c0.548,1.289,1.146,2.722,1.319,4.13"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#EDB14D"
    },
    d: "M2423.5-170.972c-1.077-1.294-2.124-2.803-2.62-4.429 c-0.127-0.417-0.223-0.864-0.256-1.301c-0.001-0.019-0.018-0.346,0.014-0.346c0.732,0.009,1.227,1.065,1.493,1.614 c0.767,1.582,1,3.41,1.551,5.074"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#EDB14D"
    },
    d: "M2424.905-174.371c-0.497-0.832-1.07-1.618-1.548-2.461 c-0.521-0.918-0.99-1.869-1.116-2.928c-0.057-0.48-0.233-1.208,0.475-0.745c0.061,0.04,0.195,0.153,0.247,0.204 c1.31,1.294,1.695,3.751,1.971,5.519"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#EDB14D"
    },
    d: "M2426.221-178.475c-0.251-0.909-0.679-1.755-1.034-2.625 c-0.367-0.9-0.676-1.798-0.736-2.777c-0.004-0.07-0.046-0.976,0.082-0.992c0.492-0.063,0.916,1.068,1.034,1.389 c0.528,1.441,0.653,3.11,0.769,4.636"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#EDB14D"
    },
    d: "M2427.8-181.915c-0.25-1.53-0.358-3.172-0.201-4.717 c0.01-0.104,0.152-1.228,0.313-1.246c0.408-0.044,0.52,1.101,0.536,1.33c0.095,1.38-0.084,2.877-0.37,4.23 c-0.021,0.101,0.066-0.195,0.099-0.293c0.024-0.073,0.075-0.225,0.101-0.313c0.12-0.403,0.24-0.804,0.388-1.198 c0.451-1.197,0.855-2.548,1.679-3.552c0.103-0.125,0.728-0.787,0.93-0.646c0.534,0.375-0.011,1.529-0.197,1.923 c-0.798,1.689-2.378,3.279-3.555,4.712"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#EDB14D"
    },
    d: "M2426.151-178.054c0.584-1.492,2.617-3.282,3.945-4.136 c0.323-0.208,1.528-0.983,1.624-0.172c0.081,0.695-0.594,1.224-1.092,1.574C2429.275-179.834,2427.366-179.214,2426.151-178.054z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#EDB14D"
    },
    d: "M2424.756-174.15c0.889-1.458,2.42-2.685,3.899-3.513 c0.299-0.167,1.505-0.9,1.729-0.266c0.217,0.615-0.514,1.253-0.935,1.569c-1.286,0.968-3.471,1.66-4.893,2.358"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#EDB14D"
    },
    d: "M2423.176-169.963c1.159-1.371,3.11-3.066,4.791-3.739 c0.471-0.189,2.048-0.622,1.704,0.457c-0.227,0.713-0.993,1.161-1.625,1.472c-1.452,0.715-3.074,0.978-4.489,1.783"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#EDB14D"
    },
    d: "M2422.312-165.622c0.693-1.221,1.919-2.28,3.069-3.052 c0.335-0.225,0.685-0.43,1.052-0.6c0.38-0.176,2.26-0.761,1.716,0.4c-0.059,0.124-0.132,0.238-0.22,0.343 c-0.517,0.618-1.344,0.889-2.061,1.197c-0.952,0.409-2.073,0.605-2.946,1.183"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#EDB14D"
    },
    d: "M2421.6-161.808c0.835-1.635,2.393-2.974,4.05-3.736 c0.29-0.133,1.937-0.893,2.002-0.123c0.062,0.731-0.755,1.394-1.267,1.784c-1.431,1.088-3.303,1.524-4.666,2.667"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#EDB14D"
    },
    d: "M2421.236-158.124c1.05-1.493,2.486-2.661,4.125-3.455 c0.172-0.083,0.155-0.074,0.322-0.147c0.163-0.071,1.872-0.854,1.631-0.036c-0.249,0.844-1.1,1.368-1.804,1.809 c-1.414,0.886-3.18,1.57-4.399,2.729"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.0601466,-0.0416544,-0.0390637,0.0683874,636.779,125.571)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#201F1D"
    },
    d: "M-19324.91-15930.039c0.846-0.41,1.467-0.445,2.172-1.068 c1.217-1.073,1.773-2.712,2.645-4.076c4.508-7.095,8.684-14.302,12.482-21.652c5.764-11.158,10.703-22.62,15.176-34.253 c12.32-32.031,20.701-65.569,29.221-99.562c3.182-12.751,5.801-23.841,8.016-35.021c2.213-11.171,4.023-22.432,5.594-35.527 c1.676-14.446,4.088-38.425,5.568-65.632c1.145-20.998,1.664-43.911,1.365-65.821c0-0.177-0.145-0.321-0.32-0.321 s-0.318,0.145-0.318,0.318c-0.305,17.386-1.246,35.378-2.426,52.539c-0.75,10.951-1.635,21.555-2.486,31.451 c-1.666,19.381-3.328,36.022-4.697,47.063c-1.59,12.997-3.414,24.175-5.629,35.262c-2.227,11.125-4.846,22.158-8.029,34.846 c-8.475,33.859-16.809,67.262-29.064,99.17c-4.428,11.525-9.424,22.824-15.012,33.936c-3.676,7.315-7.586,14.563-11.896,21.68 c-0.826,1.37-2.051,2.561-2.525,4.096c-0.273,0.894-0.049,1.473-0.086,2.407c-0.047,0.071-0.027,0.166,0.043,0.212 C-19325.049-15929.949-19324.955-15929.969-19324.91-15930.039z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.0601466,-0.0416544,-0.0390637,0.0683874,636.779,125.571)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#201F1D"
    },
    d: "M-19245.504-16219.9c0.473-0.334,0.938-0.582,1.361-0.971 c0.398-0.363,0.711-0.813,1.057-1.226c6.412-7.69,11.945-15.517,16.91-23.68c5.484-9.017,10.156-18.524,14.385-28.913 c0.031-0.076-0.004-0.166-0.082-0.198c-0.076-0.033-0.166,0.002-0.201,0.081c-4.484,10.236-9.49,19.52-15.084,28.425 c-5.055,8.046-10.684,15.712-16.887,23.503c-0.334,0.419-0.713,0.81-0.992,1.27c-0.299,0.488-0.457,0.991-0.699,1.514 c-0.055,0.064-0.045,0.16,0.02,0.214C-19245.654-16219.827-19245.557-16219.835-19245.504-16219.9z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.0601466,-0.0416544,-0.0390637,0.0683874,636.779,125.571)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#201F1D"
    },
    d: "M-19247.26-16170.96c0.537-0.351,1.078-0.613,1.58-1.016 c0.713-0.573,1.299-1.288,1.947-1.933c9.738-9.657,20.314-18.517,30.309-27.94c4.781-4.506,9.381-9.183,13.732-14.093 c0.104-0.111,0.096-0.288-0.02-0.392c-0.113-0.104-0.287-0.095-0.391,0.017c-5.957,6.364-12.428,12.21-18.947,18.02 c-6.518,5.813-13.1,11.576-19.445,17.565c-2.547,2.405-5.082,4.82-7.48,7.367c-0.242,0.255-0.504,0.494-0.709,0.777 c-0.33,0.453-0.525,0.929-0.797,1.418c-0.061,0.06-0.057,0.155,0.002,0.215 C-19247.416-16170.896-19247.32-16170.899-19247.26-16170.96z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.0601466,-0.0416544,-0.0390637,0.0683874,636.779,125.571)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#201F1D"
    },
    d: "M-19248.684-16170.44c-1.846-3.674-3.547-7.394-5.283-11.087 c-4.088-8.685-8.039-17.373-12.443-25.843c-4.176-8.024-8.85-15.805-14.43-23.204c-0.041-0.057-0.119-0.068-0.174-0.027 c-0.057,0.041-0.068,0.119-0.027,0.174c3.996,5.642,7.395,11.517,10.596,17.471c5.283,9.82,9.811,19.962,14.77,29.981 c2.113,4.271,4.371,8.483,6.723,12.677c0.041,0.073,0.133,0.103,0.207,0.063 C-19248.674-16170.274-19248.646-16170.367-19248.684-16170.44z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.0601466,-0.0416544,-0.0390637,0.0683874,636.779,125.571)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#201F1D"
    },
    d: "M-19256.707-16120.179c0.143-0.019,0.254-0.008,0.389-0.055 c0.457-0.151,0.844-0.462,1.258-0.703c4.645-2.698,9.188-5.628,13.729-8.576c7.531-4.889,15.02-9.892,22.691-14.492 c5.512-3.308,11.084-6.46,16.873-9.164c0.16-0.07,0.23-0.258,0.16-0.418c-0.074-0.16-0.262-0.234-0.422-0.161 c-7.84,3.405-15.395,7.501-22.742,12.009c-6.563,4.022-12.979,8.335-19.373,12.623c-3.848,2.581-7.705,5.122-11.527,7.685 c-0.342,0.229-0.729,0.402-1.014,0.701c-0.086,0.093-0.113,0.185-0.178,0.294c-0.074,0.043-0.096,0.136-0.053,0.209 C-19256.873-16120.157-19256.777-16120.135-19256.707-16120.179z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.0601466,-0.0416544,-0.0390637,0.0683874,636.779,125.571)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#201F1D"
    },
    d: "M-19258.924-16113.801c-0.127-0.44-0.229-0.875-0.391-1.305 c-0.637-1.679-1.525-3.253-2.34-4.851c-4.072-7.967-8.848-15.563-12.686-23.644c-2.826-5.887-5.133-12.245-8.049-18.237 c-1.965-4.035-4.221-7.892-6.963-11.383c-0.084-0.111-0.246-0.136-0.361-0.05c-0.113,0.088-0.135,0.25-0.051,0.362 c1.945,2.665,3.57,5.54,5.07,8.505c3.494,6.905,6.18,14.359,9.451,21.234c0.979,2.021,2.014,4.017,3.08,5.989 c3.4,6.296,7.098,12.438,10.404,18.788c0.656,1.267,1.211,2.587,1.938,3.821c0.184,0.317,0.41,0.589,0.619,0.894 c0.035,0.076,0.125,0.108,0.201,0.073C-19258.924-16113.635-19258.889-16113.725-19258.924-16113.801z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.0601466,-0.0416544,-0.0390637,0.0683874,636.779,125.571)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#201F1D"
    },
    d: "M-19268.986-16069.966c0.398-0.174,0.795-0.305,1.18-0.514 c3.334-1.807,6.355-4.133,9.543-6.18c8.279-5.31,16.652-10.459,24.867-15.864c7.814-5.142,15.453-10.552,22.922-16.277 c0.076-0.058,0.092-0.166,0.035-0.245c-0.057-0.076-0.166-0.092-0.242-0.035c-7.631,5.481-15.514,10.498-23.381,15.53 c-7.891,5.049-15.789,10.073-23.609,15.229c-3.516,2.321-7.201,4.433-10.461,7.112c-0.373,0.307-0.68,0.657-1.025,0.994 c-0.07,0.046-0.086,0.142-0.041,0.209C-19269.152-16069.936-19269.057-16069.92-19268.986-16069.966z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.0601466,-0.0416544,-0.0390637,0.0683874,636.779,125.571)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#201F1D"
    },
    d: "M-19272.941-16062.897c0.107-0.239,0.213-0.229,0.215-0.492 c0.014-1.079-0.822-2.021-1.277-3.046c-4.049-9.134-9.65-19.272-15.969-28.864c-7.172-10.895-15.354-21.03-23.295-28.227 c-0.1-0.095-0.26-0.09-0.355,0.014c-0.092,0.101-0.086,0.261,0.014,0.356c7.75,7.314,15.568,17.63,22.598,28.532 c6.188,9.601,11.688,19.696,15.896,28.693c0.473,1.009,0.604,2.245,1.393,2.971c0.191,0.179,0.258,0.092,0.502,0.182 c0.035,0.076,0.123,0.114,0.201,0.079C-19272.943-16062.731-19272.908-16062.821-19272.941-16062.897z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.0601466,-0.0416544,-0.0390637,0.0683874,636.779,125.571)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#201F1D"
    },
    d: "M-19287.547-16006.19c0.217-0.247,0.201,0.052,0.246-0.279 c0.014-0.106-0.094-0.196-0.143-0.294c-0.525-1.073-1.145-2.343-1.865-3.767c-4.469-8.823-12.305-23.818-19.857-37.006 c-7.094-12.38-13.963-23.146-16.908-26.136c-0.076-0.079-0.199-0.082-0.275-0.009c-0.078,0.076-0.08,0.199-0.008,0.275 c1.721,1.877,4.699,6.728,8.348,13.027c2.949,5.084,6.307,11.119,9.744,17.328c5.059,9.134,10.268,18.647,14.305,26.181 c2.125,3.962,3.91,7.38,5.258,9.872c0.188,0.345,0.234,0.81,0.547,0.976c0.271,0.144,0.033-0.003,0.338-0.03 c0.037,0.073,0.127,0.104,0.203,0.065S-19287.51-16006.114-19287.547-16006.19z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.0601466,-0.0416544,-0.0390637,0.0683874,636.779,125.571)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#201F1D"
    },
    d: "M-19311.205-15979.76c-0.49-0.94-0.922-1.892-1.463-2.808 c-0.795-1.351-1.73-2.622-2.611-3.927c-5.83-8.633-11.752-17.343-17.209-26.256c-2.938-4.799-5.791-9.628-8.367-14.573 c-0.068-0.136-0.232-0.19-0.369-0.122c-0.137,0.067-0.189,0.233-0.123,0.366c4.061,8.373,8.723,16.547,13.801,24.479 c4.557,7.113,9.025,14.331,14.203,20.902c0.59,0.747,1.256,1.399,1.889,2.108c0.047,0.07,0.141,0.087,0.209,0.041 C-19311.176-15979.597-19311.158-15979.689-19311.205-15979.76z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.0601466,-0.0416544,-0.0390637,0.0683874,636.779,125.571)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#201F1D"
    },
    d: "M-19297.592-15978.988c0.229-0.06,0.43-0.073,0.645-0.169 c0.289-0.128,0.525-0.342,0.791-0.514c3.945-2.554,7.959-5.008,11.977-7.462c6.684-4.084,13.438-8.065,20.258-11.933 c11.383-6.456,22.908-12.669,34.521-18.604c0.213-0.106,0.299-0.367,0.193-0.579c-0.107-0.215-0.367-0.302-0.582-0.192 c-7.051,3.427-14.105,6.892-21.07,10.543c-6.959,3.65-13.846,7.449-20.619,11.431c-6.33,3.72-12.563,7.595-18.656,11.671 c-2.354,1.576-4.859,2.96-6.975,4.837c-0.25,0.221-0.43,0.474-0.652,0.721c-0.068,0.046-0.088,0.141-0.041,0.212 C-19297.754-15978.958-19297.658-15978.939-19297.592-15978.988z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.0655438,-0.0303753,-0.0291135,0.0740896,621.323,62.0369)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#201F1D"
    },
    d: "M-22070.893-12083.465c0.516-0.183,1.008-0.291,1.5-0.524 c0.465-0.223,0.875-0.535,1.313-0.808c7.857-4.904,15.904-9.456,23.834-14.23c5.875-3.538,11.641-7.267,17.271-11.242 c0.178-0.12,0.223-0.361,0.102-0.538s-0.361-0.223-0.539-0.104c-5.729,3.796-11.646,7.231-17.543,10.693 c-5.922,3.473-11.838,6.948-17.666,10.57c-2.332,1.451-4.783,2.75-6.93,4.471c-0.555,0.445-1,0.962-1.508,1.459 c-0.07,0.046-0.09,0.142-0.043,0.212C-22071.057-12083.438-22070.961-12083.419-22070.893-12083.465z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.0601466,-0.0416544,-0.0390637,0.0683874,636.779,125.571)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#201F1D"
    },
    d: "M-19276.559-16035.712c0.719-0.37,1.434-0.637,2.115-1.068 c5.854-3.69,11.242-8.111,17.141-11.826c9.844-6.193,20.027-11.954,29.838-17.974c0.195-0.117,0.258-0.372,0.143-0.568 c-0.117-0.195-0.373-0.258-0.568-0.141c-9.922,5.851-20.295,11.313-30.178,17.462c-5.959,3.71-12.199,7.158-17.174,12.036 c-0.582,0.567-1,1.212-1.508,1.845c-0.066,0.052-0.074,0.146-0.023,0.212 C-19276.719-16035.669-19276.623-16035.658-19276.559-16035.712z"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.2081, -0.260861, 0.341626, 1.58214, -729.91803, 11960.700195)",
    id: "object-5"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.30849,0.0413447,-0.0541452,0.999145,68.3973,-41.5673)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#46937B"
    },
    d: "M1818.644-6968.021c2.535,0,4.592,2.636,4.592,5.883 c0,3.245-3.207,16.196-3.571,16.253c-0.481,0.074-5.611-13.008-5.611-16.253 C1814.054-6965.384,1816.112-6968.02,1818.644-6968.021z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.30548,0.0793187,-0.103876,0.996849,179.022,-128.275)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#46937B"
    },
    d: "M1485.973-6946.672c2.535,0,4.593,2.636,4.592,5.883 c0,3.245-3.207,16.196-3.571,16.253c-0.481,0.073-5.611-13.008-5.611-16.253 C1481.383-6944.037,1483.44-6946.672,1485.973-6946.672z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.36208,-0.0874673,0.111712,1.01432,-79.2968,75.0179)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#46937B"
    },
    d: "M2703.255-6694.471c2.535,0,4.593,2.636,4.593,5.883 c0,3.245-3.207,16.196-3.571,16.253c-0.481,0.073-5.612-13.008-5.612-16.253 C2698.665-6691.835,2700.722-6694.471,2703.255-6694.471z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.49739,0.429118,-0.532085,1.08257,412.373,-907.212)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#46937B"
    },
    d: "M-300.384-5474.824c2.535,0,4.592,2.636,4.592,5.883 c0,3.244-3.207,16.196-3.571,16.253c-0.481,0.073-5.612-13.008-5.612-16.253 C-304.974-5472.188-302.917-5474.824-300.384-5474.824z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.512864,1.06096,-1.2362,0.348426,2815.67,-1149.34)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#46937B"
    },
    d: "M-4785.74-2041.897c2.536,0,4.593,2.636,4.593,5.883 c0,3.245-3.207,16.196-3.571,16.253c-0.481,0.073-5.612-13.008-5.612-16.253 C-4790.33-2039.261-4788.272-2041.897-4785.74-2041.897z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.304929,1.1067,-1.2895,0.207161,3156.66,-1018.53)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#46937B"
    },
    d: "M-5146.665-993.301c2.536,0,4.593,2.636,4.593,5.883 c0,3.245-3.207,16.196-3.571,16.253c-0.481,0.073-5.612-13.008-5.612-16.253 C-5151.255-990.665-5149.198-993.301-5146.665-993.301z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.13028,1.12655,-1.31262,-0.0885084,3863.72,-703.54)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#46937B"
    },
    d: "M-5402.95,1305.319c2.536,0,4.593,2.636,4.593,5.883 c0,3.245-3.207,16.196-3.571,16.253c-0.481,0.073-5.612-13.008-5.612-16.253 C-5407.54,1307.955-5405.483,1305.319-5402.95,1305.319z"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.30961,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#201F1D"
    },
    d: "M2194.005-6957.042c-0.182-0.319,0.253,0.148-0.212-0.027 c0.005-0.021-0.011-0.043-0.033-0.047c-0.021-0.004-0.041,0.01-0.046,0.032c-0.337,0.03-0.024-0.201-0.277,0.025 c-0.079,0.067-0.043,0.2-0.065,0.299c-0.245,1.137-0.508,2.253-0.785,3.351c-0.88,3.467-1.94,6.731-3.149,9.811 c-3.166,8.051-7.408,14.813-12.307,20.476c-4.34,5.021-9.201,9.155-14.196,12.623c-5.527,3.837-11.223,6.87-16.729,9.152 c-0.144,0.057-0.215,0.22-0.158,0.364c0.057,0.144,0.22,0.215,0.364,0.158c5.628-2.139,11.525-4.943,17.163-8.731 c5.13-3.446,10.035-7.699,14.427-12.813c4.954-5.766,9.25-12.658,12.343-20.878c1.179-3.131,2.174-6.458,2.965-9.987 c0.25-1.114,0.476-2.249,0.682-3.403c0.016-0.101,0.038-0.202,0.052-0.304c0.003-0.01,0.008-0.022,0.003-0.031L2194.005-6957.042 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.30961,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#201F1D"
    },
    d: "M2183.034-6930.672c-0.13-1.063-0.288-2.122-0.489-3.174 c-0.723-3.77-1.69-7.499-2.37-11.288c-0.076-0.421-0.168-0.837-0.245-1.258c-0.003-0.035-0.035-0.06-0.071-0.056 c-0.035,0.004-0.06,0.036-0.057,0.071c0.035,0.483,0.068,0.963,0.13,1.442c0.144,1.116,0.378,2.218,0.609,3.318 c0.465,2.197,1,4.38,1.503,6.566c0.334,1.459,0.666,2.916,0.91,4.389c0.003,0.024,0.022,0.038,0.043,0.035 S2183.037-6930.65,2183.034-6930.672z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.30961,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#201F1D"
    },
    d: "M2183.48-6929.892c0.082,0.089-0.052,0.049,0.068,0.076 c0.084,0.019,0.157-0.068,0.236-0.1c0.793-0.334,1.611-0.598,2.44-0.843c1.391-0.408,2.804-0.752,4.169-1.207 c2.079-0.709,4.147-1.489,6.226-2.226c1.386-0.489,2.772-0.964,4.188-1.348c0.024-0.005,0.038-0.03,0.033-0.054 s-0.03-0.038-0.054-0.033c-1.076,0.239-2.147,0.516-3.201,0.84c-2.459,0.75-4.867,1.69-7.302,2.486 c-1.587,0.533-3.25,0.899-4.848,1.432c-0.622,0.207-1.236,0.443-1.829,0.717c-0.054,0.024-0.13,0.024-0.16,0.076 c-0.046,0.076,0,0.016,0.003,0.108c-0.022,0.008-0.03,0.033-0.019,0.052C2183.437-6929.892,2183.461-6929.884,2183.48-6929.892z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.30961,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#201F1D"
    },
    d: "M2168.801-6914.881c-0.027-0.595-0.041-1.19-0.071-1.785 c-0.122-2.383-0.256-4.758-0.19-7.13c0.054-1.973,0.212-3.943,0.576-5.911c0.005-0.027-0.013-0.054-0.041-0.06 c-0.027-0.005-0.054,0.014-0.06,0.041c-0.416,1.965-0.647,3.94-0.728,5.921c-0.101,2.378-0.032,4.769,0.177,7.158 c0.052,0.595,0.128,1.185,0.196,1.777c0.003,0.041,0.038,0.068,0.076,0.065 C2168.773-6914.807,2168.803-6914.84,2168.801-6914.881z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.30961,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#201F1D"
    },
    d: "M2169.387-6915.106c0.033,0.011,0.054,0.025,0.087,0.03 c0.25,0.03,0.5-0.041,0.75-0.079c0.413-0.06,0.823-0.149,1.231-0.25c1.568-0.386,3.117-0.986,4.641-1.394 c2.503-0.685,5.057-1.307,7.532-2.136c1.658-0.554,3.275-1.209,4.832-1.995c0.03-0.014,0.043-0.052,0.03-0.082 c-0.016-0.033-0.054-0.043-0.084-0.03c-1.571,0.733-3.207,1.313-4.864,1.834c-2.486,0.786-5.03,1.427-7.53,2.101 c-1.304,0.361-2.631,0.843-3.965,1.245c-0.62,0.185-1.242,0.348-1.864,0.481c-0.242,0.052-0.497,0.057-0.728,0.144 c-0.03,0.014-0.049,0.033-0.076,0.049c-0.022,0.003-0.038,0.022-0.035,0.043 C2169.347-6915.12,2169.366-6915.104,2169.387-6915.106z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.30961,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#201F1D"
    },
    d: "M2157.79-6907.008c-0.027-0.666-0.024-1.329-0.046-1.992 c-0.03-0.995-0.087-1.989-0.111-2.987c-0.041-1.663-0.06-3.326-0.101-4.981c-0.043-1.774-0.138-3.595-0.174-5.402 c-0.024-1.209-0.027-2.41,0.057-3.592c0.005-0.052-0.03-0.095-0.082-0.098c-0.049-0.005-0.093,0.033-0.095,0.082 c-0.098,0.891-0.155,1.796-0.168,2.707c-0.032,2.108,0.122,4.239,0.171,6.313c0.054,2.318,0.06,4.652,0.174,6.976 c0.019,0.399,0.035,0.799,0.071,1.198c0.052,0.598,0.141,1.19,0.226,1.783c0,0.022,0.019,0.041,0.043,0.038 C2157.776-6906.967,2157.792-6906.986,2157.79-6907.008z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.30961,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#201F1D"
    },
    d: "M2158.45-6906.329c0.068,0.024,0.093,0.057,0.163,0.063 c0.033,0.003,0.063-0.011,0.093-0.019c0.72-0.138,1.418-0.144,2.117-0.081c1.188,0.106,2.369,0.388,3.595,0.483 c2.245,0.16,4.497,0.269,6.748,0.272c2.25,0,4.5-0.109,6.742-0.343c0.022,0,0.038-0.021,0.035-0.043 c0-0.021-0.022-0.041-0.043-0.038c-2.242,0.177-4.487,0.212-6.731,0.168c-2.245-0.046-4.487-0.171-6.723-0.361 c-1.438-0.111-2.81-0.5-4.207-0.514c-0.549-0.005-1.149-0.084-1.655,0.19c-0.071,0.038-0.098,0.087-0.155,0.144 c-0.022,0.005-0.032,0.03-0.027,0.052C2158.406-6906.337,2158.428-6906.324,2158.45-6906.329z"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1.06961, 0.307849, 0.398138, 1.38332, 3628.98999, 11157)",
    id: "object-6"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.30849,0.0413447,-0.0541452,0.999145,68.3973,-41.5673)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#46937B"
    },
    d: "M-130.914-7857.033c2.535,0,4.592,2.636,4.592,5.883 c0,3.245-3.207,16.196-3.571,16.253c-0.481,0.073-5.611-13.008-5.611-16.253 C-135.504-7854.397-133.447-7857.033-130.914-7857.033z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.30548,0.0793187,-0.103876,0.996849,179.022,-128.275)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#46937B"
    },
    d: "M-495.995-7760.888c2.535,0,4.592,2.636,4.592,5.883 c0,3.245-3.207,16.196-3.571,16.253c-0.481,0.073-5.611-13.008-5.612-16.253 C-500.584-7758.251-498.527-7760.888-495.995-7760.888z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.36208,-0.0874673,0.111712,1.01432,-79.2968,75.0179)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#46937B"
    },
    d: "M956.434-7800.282c2.535,0,4.592,2.636,4.592,5.883 c0,3.245-3.207,16.196-3.571,16.253c-0.481,0.073-5.612-13.008-5.612-16.253 C951.845-7797.646,953.902-7800.282,956.434-7800.282z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.49739,0.429118,-0.532085,1.08257,412.373,-907.212)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#46937B"
    },
    d: "M-2044.242-5678.54c2.535,0,4.592,2.636,4.592,5.883 c0,3.245-3.207,16.196-3.571,16.253c-0.481,0.073-5.611-13.008-5.611-16.253 C-2048.832-5675.904-2046.775-5678.54-2044.242-5678.54z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.512864,1.06096,-1.2362,0.348426,2815.67,-1149.34)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#46937B"
    },
    d: "M-6174.601-593.471c2.535,0,4.592,2.636,4.592,5.883 c0,3.245-3.207,16.196-3.571,16.253c-0.481,0.073-5.611-13.008-5.611-16.253 C-6179.191-590.835-6177.134-593.471-6174.601-593.471z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.304929,1.1067,-1.2895,0.207161,3156.66,-1018.53)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#46937B"
    },
    d: "M-6332.923,667.124c2.535,0,4.592,2.636,4.592,5.883 c0,3.245-3.207,16.196-3.571,16.253c-0.481,0.073-5.611-13.008-5.611-16.253 C-6337.513,669.76-6335.456,667.124-6332.923,667.124z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.13028,1.12655,-1.31262,-0.0885084,3863.72,-703.54)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#46937B"
    },
    d: "M-6107.671,3282.017c2.535,0,4.592,2.636,4.592,5.883 c0,3.244-3.207,16.196-3.57,16.253c-0.481,0.073-5.612-13.009-5.612-16.253 C-6112.261,3284.653-6110.204,3282.017-6107.671,3282.017z"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.30961,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#201F1D"
    },
    d: "M282.663-7925.925c0.375,0.18,0.087-0.24,0.277,0.133 c0.049,0.092-0.033,0.204-0.052,0.306c-0.204,1.162-0.429,2.303-0.679,3.423c-0.791,3.548-1.788,6.894-2.973,10.041 c-3.103,8.246-7.421,15.153-12.4,20.931c-4.394,5.104-9.302,9.354-14.432,12.786c-5.625,3.761-11.506,6.535-17.12,8.655 c-0.158,0.063-0.34-0.016-0.402-0.179c-0.062-0.16,0.016-0.342,0.177-0.408c5.478-2.283,11.139-5.315,16.636-9.133 c4.986-3.462,9.843-7.573,14.18-12.571c4.913-5.663,9.171-12.424,12.353-20.479c1.22-3.088,2.291-6.361,3.177-9.839 c0.283-1.102,0.549-2.222,0.796-3.364c0.022-0.101-0.011-0.234,0.065-0.301c0.315-0.273-0.106,0.007,0.31-0.018 c0.003-0.025,0.027-0.041,0.052-0.036C282.652-7925.973,282.666-7925.95,282.663-7925.925z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.30961,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#201F1D"
    },
    d: "M271.815-7899.516c-0.247-1.475-0.582-2.929-0.918-4.388 c-0.505-2.185-1.041-4.368-1.503-6.564c-0.234-1.101-0.47-2.203-0.611-3.32c-0.06-0.479-0.087-0.961-0.12-1.444 c-0.005-0.04,0.022-0.075,0.063-0.08c0.038-0.005,0.073,0.023,0.079,0.063c0.076,0.421,0.174,0.836,0.25,1.257 c0.69,3.786,1.652,7.516,2.367,11.288c0.201,1.052,0.353,2.111,0.481,3.177c0.005,0.024-0.011,0.046-0.035,0.051 C271.842-7899.475,271.818-7899.491,271.815-7899.516z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.30961,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#201F1D"
    },
    d: "M272.31-7898.828c-0.005-0.109-0.06-0.027-0.005-0.12 c0.03-0.052,0.106-0.052,0.158-0.076c0.595-0.277,1.209-0.514,1.832-0.723c1.598-0.532,3.261-0.899,4.848-1.432 c2.438-0.793,4.842-1.733,7.304-2.481c1.057-0.32,2.125-0.592,3.204-0.829c0.027-0.005,0.054,0.011,0.06,0.038 c0.005,0.027-0.011,0.052-0.038,0.06c-1.413,0.386-2.799,0.867-4.182,1.359c-2.079,0.739-4.147,1.519-6.226,2.229 c-2.041,0.674-4.201,1.101-6.209,1.889c-0.198,0.079-0.399,0.155-0.595,0.242c-0.014,0.005-0.027,0.019-0.041,0.016 c-0.144-0.035,0.024,0.027-0.071-0.089c-0.022,0.011-0.049,0-0.06-0.022C272.277-7898.79,272.288-7898.817,272.31-7898.828z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.30961,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#201F1D"
    },
    d: "M257.516-7883.724c-0.071-0.595-0.15-1.185-0.204-1.78 c-0.212-2.386-0.274-4.78-0.177-7.158c0.084-1.984,0.321-3.957,0.739-5.921c0.005-0.032,0.035-0.051,0.065-0.046 c0.033,0.005,0.052,0.035,0.046,0.068c-0.361,1.965-0.514,3.935-0.568,5.908c-0.063,2.372,0.073,4.745,0.19,7.13 c0.03,0.595,0.041,1.19,0.065,1.786c0.003,0.043-0.03,0.082-0.073,0.084C257.559-7883.648,257.521-7883.681,257.516-7883.724z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.30961,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#201F1D"
    },
    d: "M258.244-7884.05c0.027-0.019,0.044-0.038,0.076-0.052 c0.228-0.095,0.484-0.098,0.728-0.149c0.62-0.136,1.242-0.299,1.859-0.486c1.334-0.402,2.66-0.883,3.967-1.245 c2.5-0.674,5.038-1.315,7.527-2.098c1.658-0.519,3.294-1.095,4.867-1.823c0.035-0.019,0.076-0.003,0.092,0.033 c0.016,0.033,0.003,0.073-0.033,0.092c-1.557,0.788-3.174,1.446-4.832,2.003c-2.476,0.832-5.03,1.454-7.53,2.138 c-1.527,0.408-3.073,1.006-4.644,1.394c-0.408,0.098-0.818,0.188-1.231,0.248c-0.25,0.035-0.503,0.109-0.75,0.071 c-0.035-0.005-0.057-0.022-0.09-0.036c-0.024,0.003-0.046-0.014-0.049-0.038S258.22-7884.048,258.244-7884.05z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.30961,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#201F1D"
    },
    d: "M246.57-7875.86c-0.087-0.592-0.179-1.185-0.236-1.782 c-0.035-0.397-0.052-0.796-0.071-1.196c-0.114-2.326-0.117-4.661-0.174-6.979c-0.049-2.073-0.204-4.204-0.171-6.313 c0.016-0.91,0.076-1.815,0.174-2.709c0.005-0.054,0.054-0.095,0.109-0.089c0.054,0.005,0.095,0.054,0.09,0.108 c-0.084,1.182-0.079,2.386-0.052,3.59c0.038,1.81,0.13,3.63,0.174,5.405l0.247,9.957c0,0.027-0.016,0.049-0.041,0.051 C246.595-7875.817,246.573-7875.833,246.57-7875.86z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.30961,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#201F1D"
    },
    d: "M247.293-7875.268c0.057-0.065,0.076-0.117,0.152-0.158 c0.5-0.291,1.109-0.201,1.658-0.196c1.397,0.014,2.772,0.402,4.207,0.514c2.685,0.234,5.378,0.378,8.068,0.389 c1.796,0.008,3.592-0.041,5.386-0.179c0.025-0.003,0.046,0.016,0.049,0.043c0.003,0.024-0.016,0.046-0.041,0.049 c-2.242,0.239-4.492,0.351-6.742,0.353c-2.25,0-4.503-0.108-6.75-0.266c-1.226-0.095-2.405-0.375-3.592-0.484 c-0.698-0.063-1.394-0.06-2.114,0.079c-0.03,0.005-0.06,0.019-0.092,0.016c-0.073-0.008-0.095-0.043-0.166-0.073 c-0.024,0.005-0.046-0.008-0.054-0.033C247.255-7875.238,247.269-7875.262,247.293-7875.268z"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.02059, -0.555697, 0.555697, 1.02059, -7594.620117, 865.893005)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.374723,0,0,0.374723,950.741,11673.7)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#201F1D"
    },
    d: "M13655.568-23946.57c0.139,0.832,0.046,1.43,0.355,2.209 c0.979,2.469,2.911,4.42,4.34,6.629c2.158,3.336,4.261,6.68,6.277,10.055c4.761,7.969,8.992,16.119,12.598,24.523 c5.145,11.992,8.829,24.512,11.262,37.664c0.416,2.258,0.771,4.533,1.233,6.811c0.201,0.984,0.473,1.93,0.698,2.916 c0.027,0.32,0.313,0.559,0.634,0.529c0.323-0.027,0.56-0.313,0.532-0.633c0.052-1.021,0.133-2.012,0.119-3.027 c-0.032-2.355-0.279-4.688-0.56-7.002c-1.642-13.541-5.421-26.404-10.557-38.682c-3.599-8.6-7.957-16.906-12.987-24.92 c-2.119-3.381-4.364-6.707-6.755-9.957c-1.576-2.145-2.823-4.646-4.924-6.318c-0.661-0.527-1.262-0.615-2.025-0.979 c-0.049-0.068-0.146-0.082-0.212-0.029C13655.53-23946.732,13655.517-23946.639,13655.568-23946.57z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.374723,0,0,0.374723,950.741,11673.7)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#201F1D"
    },
    d: "M13703.688-23912.865c0.698-0.188,0.935-0.092,1.581-0.416 c0.101-0.049,0.174-0.119,0.253-0.199c0.832-0.863,1.433-1.918,2.136-2.877c9.405-12.797,19.275-24.23,30.278-34.508 c12.177-11.375,25.565-21.477,40.677-30.775c2.503-1.605,5.036-3.18,7.563-4.77c3.78-2.373,7.558-4.734,11.481-6.836 c4.367-2.338,8.856-4.398,13.555-6.016c0.267-0.08,0.418-0.363,0.337-0.629c-0.079-0.268-0.361-0.42-0.628-0.338 c-6.111,1.584-11.965,3.875-17.646,6.598c-5.652,2.707-11.109,5.84-16.525,8.963c-15.318,9.439-28.968,19.605-41.231,31.23 c-11.082,10.504-21.185,22.082-30.21,35.422c-0.674,0.996-1.462,1.938-1.97,3.039c-0.049,0.104-0.087,0.197-0.098,0.309 c-0.065,0.725,0.105,0.912,0.195,1.631c-0.046,0.068-0.029,0.164,0.041,0.213 C13703.547-23912.779,13703.64-23912.797,13703.688-23912.865z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.374723,0,0,0.374723,950.741,11673.7)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#201F1D"
    },
    d: "M13701.547-23809.162c0.471-0.523,0.739-0.395,1.011-1.049 c0.283-0.693,0.058-1.5,0.12-2.264c0.299-3.658,1.261-7.479,2.72-11.395c1.948-5.232,4.805-10.594,8.172-15.865 c4.459-6.98,9.817-13.787,15.307-19.777c6.468-7.057,13.055-13.021,18.487-16.764c2.514-1.813,5.239-3.336,8.029-4.787 c4.253-2.211,8.65-4.191,12.928-6.15c0.212-0.084,0.314-0.324,0.233-0.535c-0.084-0.213-0.323-0.316-0.533-0.234 c-4.514,1.473-9.189,2.844-13.668,4.68c-3.047,1.248-5.965,2.736-8.715,4.459c-5.688,3.729-12.688,9.646-19.457,16.83 c-5.726,6.076-11.321,13.027-15.832,20.246c-3.462,5.545-6.293,11.248-8.108,16.791c-1.399,4.268-2.212,8.443-2.231,12.385 c-0.005,0.836-0.261,1.746,0.109,2.475c0.326,0.646,0.567,0.525,1.127,0.979c0.006,0.084,0.079,0.146,0.163,0.139 C13701.49-23809.006,13701.556-23809.078,13701.547-23809.162z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.374723,0,0,0.374723,950.741,11673.7)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#201F1D"
    },
    d: "M13753.08-23739.422c-2.432-2.752-4.601-5.539-6.945-8.127 c-27.498-30.295-43.18-55.32-48.87-80.092c-5.87-25.553-2.517-49.434,3.592-72.869c6.259-24.025,15.373-47.568,20.55-71.803 c4.78-22.373,6.503-45.418-0.908-69.734c-2.736-8.988-6.866-18.068-12.342-27.402c-0.172-0.314-0.568-0.432-0.884-0.258 c-0.317,0.174-0.432,0.566-0.261,0.885c4.823,9.484,8.117,18.699,10.506,27.629c6.416,23.979,5.073,46.281,0.28,68.1 c-5.305,24.156-14.484,47.619-20.729,71.598c-6.252,24.018-9.605,48.555-3.38,74.689c6,25.186,19.614,53.27,50.731,80.99 c2.619,2.33,5.514,4.395,8.454,6.617c0.063,0.057,0.157,0.053,0.215-0.01 C13753.146-23739.268,13753.144-23739.365,13753.08-23739.422z"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.440637,0.16708,0.169923,0.448134,2335.81,12309.1)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2,0,0,2,-1230.28,-11.3452)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FA604B"
    },
    d: "M-6738.316-8024.508c0,0-3.454,10.094-3.231,15.984 c0.223,5.86,6.524,5.605,6.473-0.659C-6735.121-8014.85-6738.316-8024.508-6738.316-8024.508z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.22465e-16,2,-2,1.22465e-16,1564.7,-1734.77)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FA604B"
    },
    d: "M-7163.742,8136.855c0,0-3.454,10.094-3.231,15.984 c0.223,5.86,6.525,5.605,6.473-0.659C-7160.546,8146.513-7163.742,8136.855-7163.742,8136.855z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.88149,1.79526,-1.79526,-0.88149,2505.16,-1267.64)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FA604B"
    },
    d: "M-2846.971,10986.544c0,0-3.454,10.094-3.231,15.984 c0.223,5.859,6.525,5.605,6.473-0.659C-2843.775,10996.202-2846.971,10986.544-2846.971,10986.544z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1.71002,-1.03723,1.03723,-1.71002,2683.01,2156.42)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FA604B"
    },
    d: "M12158.402,3280.001c0,0-3.454,10.094-3.231,15.984 c0.223,5.86,6.524,5.606,6.473-0.659C12161.598,3289.66,12158.402,3280.001,12158.402,3280.001z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.97972,-1.7436,1.7436,-0.97972,1667.33,2760.64)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FA604B"
    },
    d: "M12215.172-2526.688c0,0-3.454,10.094-3.23,15.984 c0.223,5.86,6.524,5.606,6.473-0.659C12218.368-2517.03,12215.172-2526.688,12215.172-2526.688z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.71504,-1.0289,1.0289,1.71504,-1184.1,1232.54)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FA604B"
    },
    d: "M-1349.735-10892.189c0,0-3.454,10.094-3.231,15.984 c0.223,5.86,6.525,5.605,6.473-0.659C-1346.539-10882.531-1349.735-10892.189-1349.735-10892.189z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-2,-2.44929e-16,2.44929e-16,-2,3287.37,1064.5)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FA604B"
    },
    d: "M8997.347,8563.843c0,0-3.454,10.094-3.231,15.984 c0.223,5.86,6.524,5.605,6.474-0.659C9000.542,8573.501,8997.347,8563.843,8997.347,8563.843z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.22465e-16,-2,2,1.22465e-16,490.873,2787.93)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FA604B"
    },
    d: "M9424.611-7598.255c0,0-3.454,10.094-3.231,15.984 c0.223,5.86,6.524,5.605,6.473-0.659C9427.807-7588.597,9424.611-7598.255,9424.611-7598.255z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.991667,-1.73684,1.73684,0.991667,-556.942,2223.55)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FA604B"
    },
    d: "M4431.555-10676.3c0,0-3.454,10.094-3.231,15.984 c0.223,5.86,6.524,5.605,6.473-0.659C4434.75-10666.642,4431.555-10676.3,4431.555-10676.3z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.71002,1.03723,-1.03723,1.71002,-623.284,-1107.65)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FA604B"
    },
    d: "M-9898.628-2740.569c0,0-3.453,10.094-3.23,15.984 c0.223,5.86,6.524,5.606,6.473-0.659C-9895.432-2730.911-9898.628-2740.569-9898.628-2740.569z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.97972,1.7436,-1.7436,0.97972,389.931,-1707.99)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FA604B"
    },
    d: "M-9954.737,3065.849c0,0-3.454,10.094-3.231,15.984 c0.223,5.86,6.524,5.606,6.474-0.659C-9951.542,3075.507-9954.737,3065.849-9954.737,3065.849z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1.71504,1.0289,-1.0289,-1.71504,3242.83,-172.818)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FA604B"
    },
    d: "M3609.319,11430.237c0,0-3.454,10.094-3.231,15.984 c0.223,5.86,6.525,5.605,6.473-0.659C3612.514,11439.896,3609.319,11430.237,3609.319,11430.237z"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.746771,0.278422,0.283159,0.734277,2169.73,-2328.23)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#201F1D"
    },
    d: "M13544.101-23882.605c0.043,0.275,0.035,0.512,0.122,0.781 c0.685,2.084,2,3.951,3.027,5.957c1.679,3.279,3.354,6.611,4.785,9.998c1.041,2.459,2,4.918,2.72,7.42 c0.047,0.188,0.239,0.303,0.427,0.254s0.302-0.24,0.253-0.428c-0.97-4.264-2.435-8.541-4.358-12.627 c-1.721-3.646-3.791-7.131-5.802-10.492c-0.114-0.193-0.201-0.402-0.348-0.568c-0.172-0.195-0.359-0.285-0.563-0.445 c-0.041-0.074-0.134-0.098-0.207-0.057S13544.06-23882.68,13544.101-23882.605z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.746771,0.278422,0.283159,0.734277,2169.73,-2328.23)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#201F1D"
    },
    d: "M13526.435-23868.342c0.351,0.535,0.674,1.07,1.067,1.57 c1.573,1.988,3.436,3.695,5.315,5.359c3.503,3.1,7.326,5.816,11.049,8.732c0.174,0.139,0.43,0.111,0.568-0.063 s0.111-0.43-0.063-0.568c-3.639-2.994-7.277-5.912-10.799-8.965c-1.872-1.619-3.645-3.344-5.481-5.043 c-0.462-0.43-0.954-0.801-1.43-1.223c-0.054-0.063-0.149-0.07-0.214-0.016 C13526.386-23868.504,13526.377-23868.408,13526.435-23868.342z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.746771,0.278422,0.283159,0.734277,2169.73,-2328.23)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#201F1D"
    },
    d: "M13521.717-23849.707c3.274,0.375,6.538,0.699,9.815,0.799 c4.913,0.15,9.826-0.1,14.759-0.326c0.174-0.004,0.312-0.15,0.304-0.328c-0.005-0.174-0.152-0.313-0.328-0.307 c-3.277,0.078-6.547,0.111-9.813,0.1c-2.451-0.004-4.899-0.09-7.354-0.125c-2.448-0.035-4.896-0.014-7.358-0.113 c-0.084-0.008-0.155,0.055-0.163,0.139C13521.57-23849.787,13521.633-23849.715,13521.717-23849.707z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.746771,0.278422,0.283159,0.734277,2169.73,-2328.23)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#201F1D"
    },
    d: "M13521.287-23827.395c0.457-0.156,0.916-0.295,1.361-0.48 c3.957-1.621,7.707-3.805,11.514-5.859c4.207-2.268,8.422-4.525,12.718-6.545c2.163-1.018,4.326-2.008,6.555-2.846 c0.068-0.023,0.104-0.096,0.082-0.162c-0.022-0.068-0.096-0.104-0.163-0.08c-3.433,1.049-6.797,2.33-10.063,3.875 c-6.794,3.219-13.237,7.297-19.931,10.615c-0.674,0.334-1.439,0.516-2.024,0.982c-0.084,0.068-0.108,0.143-0.174,0.225 c-0.076,0.035-0.108,0.125-0.073,0.199C13521.122-23827.393,13521.211-23827.361,13521.287-23827.395z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.746771,0.278422,0.283159,0.734277,2169.73,-2328.23)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#201F1D"
    },
    d: "M13531.513-23813.896c0.236-0.002,0.321,0.074,0.547-0.006 c0.195-0.07,0.328-0.26,0.489-0.393c2.421-2,4.747-4.107,6.989-6.295c5.796-5.654,11.136-11.746,17.043-17.313 c0.112-0.1,0.12-0.273,0.02-0.385c-0.104-0.115-0.277-0.121-0.389-0.02c-4.37,3.82-8.56,7.814-12.669,11.895 c-3.685,3.656-7.32,7.357-11.177,10.855c-0.299,0.27-0.688,0.467-0.894,0.814c-0.134,0.221-0.093,0.365-0.158,0.615 c-0.063,0.055-0.07,0.148-0.016,0.215C13531.353-23813.85,13531.448-23813.842,13531.513-23813.896z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.746771,0.278422,0.283159,0.734277,2169.73,-2328.23)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#201F1D"
    },
    d: "M13550.695-23804.723l5.968-27.895 c0.029-0.127-0.052-0.254-0.183-0.285c-0.127-0.027-0.255,0.055-0.285,0.182c-1.31,5.547-2.817,11.068-4.008,16.656 c-0.796,3.734-1.41,7.498-1.954,11.266c-0.021,0.129,0.065,0.25,0.193,0.27 C13550.554-23804.508,13550.674-23804.594,13550.695-23804.723z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.746771,0.278422,0.283159,0.734277,2169.73,-2328.23)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#201F1D"
    },
    d: "M13570.084-23807.654c-0.04-0.734-0.06-1.461-0.154-2.189 c-0.372-2.889-1.134-5.719-1.902-8.539c-2.226-8.146-5.305-16.119-7.201-24.334c-0.027-0.115-0.142-0.188-0.256-0.164 c-0.116,0.025-0.189,0.139-0.163,0.256c1.69,8.262,4.424,16.352,6.59,24.52c0.742,2.799,1.326,5.623,1.976,8.432 c0.163,0.709,0.378,1.396,0.552,2.104c0.024,0.152,0.166,0.262,0.32,0.236 C13570-23807.355,13570.106-23807.5,13570.084-23807.654z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.746771,0.278422,0.283159,0.734277,2169.73,-2328.23)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#201F1D"
    },
    d: "M13592.277-23817.994c-0.063-0.207-0.04-0.336-0.154-0.52 c-0.19-0.295-0.52-0.473-0.78-0.705c-3.28-2.951-6.396-6.254-9.432-9.691c-5.058-5.723-9.9-11.791-14.563-17.359 c-0.081-0.1-0.229-0.113-0.326-0.035c-0.101,0.082-0.116,0.227-0.035,0.326c4.489,5.732,8.995,12.09,14.017,17.861 c3.043,3.5,6.27,6.791,9.707,9.631c0.274,0.229,0.508,0.531,0.834,0.664c0.204,0.08,0.326,0.037,0.544,0.063 c0.063,0.051,0.16,0.043,0.212-0.021C13592.354-23817.848,13592.343-23817.943,13592.277-23817.994z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.746771,0.278422,0.283159,0.734277,2169.73,-2328.23)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#201F1D"
    },
    d: "M13596.392-23837.861c-1.527-0.598-3.038-1.223-4.593-1.748 c-3.622-1.223-7.32-2.189-11.032-3.084c-5.299-1.277-10.666-2.242-16.068-3.063c-0.128-0.021-0.25,0.063-0.274,0.193 c-0.021,0.131,0.065,0.252,0.195,0.275c4.277,0.816,8.509,1.813,12.731,2.834c4.435,1.07,8.826,2.295,13.242,3.461 c1.896,0.504,3.808,0.922,5.707,1.42c0.081,0.025,0.165-0.02,0.189-0.1 C13596.517-23837.75,13596.474-23837.834,13596.392-23837.861z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.746771,0.278422,0.283159,0.734277,2169.73,-2328.23)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#201F1D"
    },
    d: "M13597.984-23861.146c-1.481,0.344-2.959,0.68-4.419,1.107 c-3.396,1-6.712,2.264-9.994,3.6c-7.024,2.855-13.826,6.281-20.495,9.834c-0.142,0.072-0.195,0.246-0.122,0.385 s0.244,0.193,0.386,0.123c5.595-2.848,11.307-5.533,17.108-7.998c3.476-1.479,7-2.82,10.53-4.148 c2.361-0.889,4.701-1.809,7.09-2.611c0.082-0.025,0.128-0.107,0.104-0.188 C13598.15-23861.125,13598.065-23861.172,13597.984-23861.146z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.746771,0.278422,0.283159,0.734277,2169.73,-2328.23)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#201F1D"
    },
    d: "M13589.337-23876.867c-0.79,0.611-1.601,1.182-2.372,1.818 c-1.785,1.475-3.48,3.051-5.201,4.604c-5.733,5.17-11.375,10.434-17.055,15.666c-0.157,0.143-0.171,0.389-0.027,0.545 c0.142,0.158,0.387,0.17,0.544,0.027c5.764-5.141,11.62-10.172,17.305-15.398c1.704-1.568,3.427-3.123,5.041-4.787 c0.698-0.719,1.331-1.48,1.997-2.227c0.067-0.063,0.073-0.172,0.008-0.24 C13589.514-23876.928,13589.408-23876.93,13589.337-23876.867z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.746771,0.278422,0.283159,0.734277,2169.73,-2328.23)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#201F1D"
    },
    d: "M13567.193-23884.719c-0.313,1.004-0.645,1.992-0.93,3.002 c-1.03,3.625-1.905,7.281-2.826,10.928c-1.38,5.461-2.723,10.928-4.31,16.359c-0.049,0.164,0.043,0.334,0.206,0.383 c0.166,0.049,0.337-0.043,0.386-0.205c1.544-5.018,2.954-10.047,4.234-15.113c1.021-4.051,2.043-8.105,2.932-12.197 c0.223-1.021,0.396-2.053,0.601-3.082c0.021-0.082-0.03-0.162-0.108-0.182 C13567.297-23884.848,13567.212-23884.799,13567.193-23884.719z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.74794,0,0,2.74794,-2074.65,-185.766)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#F8F0E9"
    },
    d: "M-4597.028-5782.816c2.833,0,5.129,2.296,5.129,5.129 s-2.296,5.129-5.129,5.129c-2.833,0-5.129-2.296-5.129-5.129S-4599.86-5782.816-4597.028-5782.816z"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.297415,0.112773,0.114692,0.302476,2354.09,12539.9)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2,0,0,2,-1230.28,-11.3452)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FA604B"
    },
    d: "M-10420.858-12176.484c0,0-3.454,10.094-3.231,15.983 c0.223,5.86,6.524,5.606,6.473-0.658C-10417.663-12166.826-10420.858-12176.484-10420.858-12176.484z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.22465e-16,2,-2,1.22465e-16,1564.7,-1734.77)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FA604B"
    },
    d: "M-11315.718,11819.397c0,0-3.454,10.094-3.231,15.984 c0.223,5.86,6.524,5.605,6.473-0.659C-11312.522,11829.056-11315.718,11819.397-11315.718,11819.397z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.88149,1.79526,-1.79526,-0.88149,2505.16,-1267.64)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FA604B"
    },
    d: "M-4950.856,16122.089c0,0-3.454,10.094-3.231,15.984 c0.223,5.86,6.524,5.605,6.473-0.659C-4947.66,16131.747-4950.856,16122.089-4950.856,16122.089z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1.71002,-1.03723,1.03723,-1.71002,2683.01,2156.42)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FA604B"
    },
    d: "M17460.271,4920.155c0,0-3.455,10.094-3.232,15.984 c0.223,5.86,6.525,5.606,6.473-0.659C17463.467,4929.813,17460.271,4920.155,17460.271,4920.155z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.97972,-1.7436,1.7436,-0.97972,1667.33,2760.64)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FA604B"
    },
    d: "M17638.807-3703.243c0,0-3.455,10.094-3.232,15.984 c0.223,5.86,6.525,5.606,6.473-0.659C17642.002-3693.585,17638.807-3703.243,17638.807-3703.243z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.71504,-1.0289,1.0289,1.71504,-1184.1,1232.54)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FA604B"
    },
    d: "M-2371.605-16347.08c0,0-3.454,10.094-3.231,15.984 c0.223,5.86,6.525,5.606,6.473-0.658C-2368.409-16337.421-2371.605-16347.08-2371.605-16347.08z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-2,-2.44929e-16,2.44929e-16,-2,3287.37,1064.5)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FA604B"
    },
    d: "M12679.889,12715.819c0,0-3.453,10.094-3.23,15.983 c0.223,5.86,6.524,5.606,6.473-0.658C12683.085,12725.478,12679.889,12715.819,12679.889,12715.819z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.22465e-16,-2,2,1.22465e-16,490.873,2787.93)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FA604B"
    },
    d: "M13576.587-11280.798c0,0-3.453,10.094-3.23,15.984 c0.223,5.86,6.524,5.605,6.473-0.659C13579.783-11271.14,13576.587-11280.798,13576.587-11280.798z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.991667,-1.73684,1.73684,0.991667,-556.942,2223.55)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FA604B"
    },
    d: "M6211.279-15932.96c0,0-3.454,10.094-3.231,15.984 c0.223,5.859,6.524,5.605,6.473-0.659C6214.474-15923.302,6211.279-15932.96,6211.279-15932.96z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.71002,1.03723,-1.03723,1.71002,-623.284,-1107.65)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FA604B"
    },
    d: "M-15200.496-4380.723c0,0-3.454,10.094-3.231,15.984 c0.223,5.86,6.524,5.606,6.473-0.659C-15197.301-4371.064-15200.496-4380.723-15200.496-4380.723z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.97972,1.7436,-1.7436,0.97972,389.931,-1707.99)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FA604B"
    },
    d: "M-15378.371,4242.404c0,0-3.454,10.094-3.231,15.984 c0.224,5.86,6.524,5.605,6.474-0.659C-15375.176,4252.063-15378.371,4242.404-15378.371,4242.404z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1.71504,1.0289,-1.0289,-1.71504,3242.83,-172.818)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FA604B"
    },
    d: "M4631.189,16885.127c0,0-3.454,10.094-3.231,15.984 c0.223,5.861,6.524,5.605,6.473-0.658C4634.385,16894.785,4631.189,16885.127,4631.189,16885.127z"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.746771,0.278422,0.283159,0.734277,2169.73,-2328.23)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#201F1D"
    },
    d: "M18417.756-37039.602c0.006,0.32-0.066,0.535,0.008,0.848 c0.514,2.137,1.922,3.988,2.936,6c1.654,3.281,3.34,6.598,4.797,9.961c1.055,2.441,2.064,4.871,2.814,7.355 c0.074,0.281,0.355,0.449,0.633,0.375c0.281-0.07,0.449-0.352,0.379-0.633c-0.922-4.293-2.291-8.621-4.221-12.727 c-1.717-3.66-3.854-7.117-5.918-10.457c-0.117-0.188-0.195-0.41-0.357-0.563c-0.219-0.207-0.412-0.23-0.678-0.379 c-0.061-0.109-0.197-0.148-0.305-0.086C18417.734-37039.844,18417.697-37039.707,18417.756-37039.602z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.746771,0.278422,0.283159,0.734277,2169.73,-2328.23)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#201F1D"
    },
    d: "M18400.098-37025.324c0.326,0.57,0.6,1.129,0.984,1.652 c1.502,2.055,3.391,3.762,5.275,5.438c3.496,3.113,7.365,5.777,11.107,8.68c0.26,0.203,0.637,0.16,0.844-0.094 c0.207-0.258,0.166-0.637-0.094-0.844l-17.777-15.125c-0.08-0.094-0.223-0.105-0.314-0.023 C18400.027-37025.559,18400.02-37025.418,18400.098-37025.324z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.746771,0.278422,0.283159,0.734277,2169.73,-2328.23)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#201F1D"
    },
    d: "M18395.434-37006.664c3.273,0.43,6.531,0.832,9.816,0.953 c4.914,0.176,9.83-0.148,14.768-0.398c0.258-0.008,0.461-0.227,0.453-0.488c-0.01-0.258-0.229-0.461-0.488-0.453l-24.514-0.059 c-0.123-0.012-0.232,0.082-0.242,0.207C18395.219-37006.781,18395.307-37006.672,18395.434-37006.664z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.746771,0.278422,0.283159,0.734277,2169.73,-2328.23)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#201F1D"
    },
    d: "M18395.041-36984.355c0.152,0.008,0.256,0.051,0.408,0.023 c1.059-0.188,1.961-0.891,2.938-1.359c5.773-2.777,11.488-5.875,17.201-8.867c3.818-2,7.596-4.016,11.59-5.539 c0.098-0.031,0.152-0.141,0.117-0.238c-0.033-0.102-0.143-0.152-0.24-0.121c-3.455,1.008-6.855,2.211-10.139,3.742 c-6.813,3.18-13.217,7.332-19.896,10.68c-0.672,0.336-1.48,0.473-2.02,0.992c-0.096,0.09-0.084,0.16-0.146,0.277 c-0.113,0.051-0.162,0.184-0.111,0.297S18394.928-36984.305,18395.041-36984.355z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.746771,0.278422,0.283159,0.734277,2169.73,-2328.23)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#201F1D"
    },
    d: "M18405.281-36970.871c0.35,0.066,0.309,0.207,0.656,0.121 c0.205-0.047,0.334-0.25,0.498-0.383c2.453-1.973,4.799-4.063,7.047-6.258c5.793-5.656,11.045-11.832,16.91-17.441 c0.166-0.152,0.176-0.41,0.027-0.574c-0.152-0.164-0.41-0.176-0.576-0.027c-4.414,3.781-8.672,7.707-12.799,11.773 c-3.695,3.641-7.303,7.359-11.131,10.875c-0.297,0.277-0.713,0.461-0.883,0.828c-0.152,0.324-0.02,0.387-0.041,0.746 c-0.096,0.078-0.105,0.219-0.025,0.316C18405.047-36970.801,18405.188-36970.789,18405.281-36970.871z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.746771,0.278422,0.283159,0.734277,2169.73,-2328.23)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#201F1D"
    },
    d: "M18424.527-36961.73l5.969-27.891 c0.043-0.191-0.076-0.379-0.268-0.422s-0.379,0.078-0.424,0.27c-1.344,5.539-2.932,11.043-4.117,16.633 c-0.787,3.738-1.336,7.516-1.844,11.297c-0.031,0.188,0.098,0.367,0.285,0.398 C18424.318-36961.414,18424.498-36961.543,18424.527-36961.73z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.746771,0.278422,0.283159,0.734277,2169.73,-2328.23)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#201F1D"
    },
    d: "M18443.939-36964.703c-0.008-0.746,0.018-1.473-0.059-2.215 c-0.307-2.902-1.111-5.734-1.889-8.559c-2.236-8.145-5.398-16.09-7.344-24.293c-0.039-0.168-0.207-0.277-0.379-0.242 c-0.17,0.039-0.279,0.207-0.244,0.379c0.473,2.375,1.033,4.734,1.65,7.086c1.705,6.543,3.715,13.031,5.34,19.574 c0.486,1.957,0.871,3.938,1.363,5.887c0.215,0.852,0.502,1.66,0.734,2.508c0.031,0.227,0.244,0.383,0.475,0.352 C18443.816-36964.262,18443.975-36964.473,18443.939-36964.703z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.746771,0.278422,0.283159,0.734277,2169.73,-2328.23)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#201F1D"
    },
    d: "M18466.049-36975.082c-0.01-0.293,0.107-0.309-0.012-0.574 c-0.205-0.457-0.723-0.688-1.092-1.027c-4.037-3.719-7.867-7.926-11.586-12.27c-4.16-4.863-8.26-9.801-12.205-14.414 c-0.117-0.148-0.334-0.172-0.482-0.055c-0.146,0.121-0.17,0.34-0.051,0.484c4.447,5.77,8.871,12.195,13.887,17.984 c3.043,3.516,6.293,6.801,9.771,9.613c0.277,0.227,0.504,0.555,0.848,0.652c0.285,0.086,0.34-0.023,0.635-0.047 c0.096,0.078,0.236,0.066,0.316-0.031C18466.156-36974.859,18466.143-36975,18466.049-36975.082z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.746771,0.278422,0.283159,0.734277,2169.73,-2328.23)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#201F1D"
    },
    d: "M18470.137-36994.957c-1.518-0.652-3-1.34-4.553-1.891 c-3.604-1.281-7.316-2.234-11.033-3.117c-5.311-1.266-10.695-2.156-16.111-2.934c-0.191-0.031-0.373,0.098-0.406,0.289 c-0.031,0.191,0.096,0.371,0.289,0.402l31.676,7.676c0.121,0.039,0.246-0.027,0.283-0.148 C18470.32-36994.797,18470.254-36994.922,18470.137-36994.957z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.746771,0.278422,0.283159,0.734277,2169.73,-2328.23)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#201F1D"
    },
    d: "M18471.688-37018.246c-1.498,0.305-2.988,0.59-4.461,0.996 c-3.416,0.953-6.732,2.23-10.021,3.57c-7.029,2.855-13.811,6.34-20.473,9.922c-0.207,0.109-0.289,0.363-0.18,0.57 c0.109,0.211,0.363,0.289,0.57,0.18c5.609-2.816,11.338-5.453,17.139-7.906c3.473-1.465,7.004-2.785,10.512-4.148 c2.355-0.914,4.662-1.902,7.039-2.75c0.119-0.039,0.186-0.164,0.15-0.277 C18471.928-37018.211,18471.807-37018.281,18471.688-37018.246z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.746771,0.278422,0.283159,0.734277,2169.73,-2328.23)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#201F1D"
    },
    d: "M18463.004-37033.957c-0.828,0.582-1.666,1.098-2.461,1.723 c-1.826,1.426-3.52,3.008-5.242,4.559c-5.746,5.156-11.338,10.477-16.994,15.73c-0.234,0.211-0.254,0.574-0.041,0.809 c0.211,0.234,0.572,0.25,0.807,0.039c5.783-5.121,11.689-10.094,17.361-15.332c1.703-1.574,3.436-3.125,5.006-4.832 c0.684-0.746,1.266-1.543,1.906-2.328c0.102-0.094,0.107-0.254,0.012-0.352 C18463.266-37034.043,18463.105-37034.051,18463.004-37033.957z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.746771,0.278422,0.283159,0.734277,2169.73,-2328.23)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#201F1D"
    },
    d: "M18440.844-37041.766c-0.619,2.004-1.283,3.988-1.834,6.008 c-2.205,8.063-3.924,16.219-6.303,24.258c-0.072,0.238,0.066,0.496,0.309,0.57c0.24,0.07,0.496-0.066,0.566-0.309 c1.869-6.02,3.621-12.039,5.066-18.148c0.965-4.063,1.732-8.172,2.631-12.27c0.029-0.117-0.045-0.242-0.164-0.27 C18440.996-37041.957,18440.873-37041.887,18440.844-37041.766z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.74794,0,0,2.74794,-2074.65,-185.766)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#F8F0E9"
    },
    d: "M-7277.248-8804.698c2.833,0,5.129,2.296,5.129,5.129 c0,2.832-2.296,5.128-5.129,5.128s-5.129-2.296-5.129-5.129C-7282.377-8802.402-7280.081-8804.698-7277.248-8804.698z"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.356635,0.135228,0.137529,0.362703,2187.85,12555.2)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2,0,0,2,-1230.28,-11.3452)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FA604B"
    },
    d: "M-8718.667-10099.73c0,0-3.454,10.094-3.23,15.984 c0.223,5.86,6.524,5.605,6.473-0.659C-8715.472-10090.072-8718.667-10099.73-8718.667-10099.73z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.22465e-16,2,-2,1.22465e-16,1564.7,-1734.77)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FA604B"
    },
    d: "M-9238.964,10117.206c0,0-3.454,10.093-3.231,15.983 c0.223,5.86,6.524,5.606,6.474-0.658C-9235.769,10126.864-9238.964,10117.206-9238.964,10117.206z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.88149,1.79526,-1.79526,-0.88149,2505.16,-1267.64)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FA604B"
    },
    d: "M-3836.927,13678.821c0,0-3.454,10.094-3.231,15.984 c0.223,5.859,6.525,5.605,6.473-0.659C-3833.731,13688.479-3836.927,13678.821-3836.927,13678.821z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1.71002,-1.03723,1.03723,-1.71002,2683.01,2156.42)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FA604B"
    },
    d: "M14927.853,4027.295c0,0-3.454,10.094-3.23,15.984 c0.223,5.86,6.524,5.606,6.473-0.659C14931.049,4036.953,14927.853,4027.295,14927.853,4027.295z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.97972,-1.7436,1.7436,-0.97972,1667.33,2760.64)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FA604B"
    },
    d: "M14994.45-3236.591c0,0-3.453,10.094-3.23,15.984 c0.223,5.86,6.524,5.606,6.473-0.659C14997.646-3226.932,14994.45-3236.591,14994.45-3236.591z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.71504,-1.0289,1.0289,1.71504,-1184.1,1232.54)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FA604B"
    },
    d: "M-1980.328-13690.527c0,0-3.454,10.094-3.231,15.984 c0.223,5.86,6.525,5.605,6.473-0.658C-1977.132-13680.869-1980.328-13690.527-1980.328-13690.527z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-2,-2.44929e-16,2.44929e-16,-2,3287.37,1064.5)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FA604B"
    },
    d: "M10977.697,10639.064c0,0-3.454,10.094-3.231,15.984 c0.224,5.86,6.524,5.605,6.474-0.658C10980.893,10648.723,10977.697,10639.064,10977.697,10639.064z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.22465e-16,-2,2,1.22465e-16,490.873,2787.93)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FA604B"
    },
    d: "M11499.833-9578.606c0,0-3.454,10.094-3.231,15.984 c0.224,5.86,6.525,5.606,6.474-0.658C11503.028-9568.948,11499.833-9578.606,11499.833-9578.606z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.991667,-1.73684,1.73684,0.991667,-556.942,2223.55)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FA604B"
    },
    d: "M5251.792-13425.029c0,0-3.454,10.094-3.231,15.984 c0.223,5.86,6.524,5.606,6.473-0.658C5254.987-13415.371,5251.792-13425.029,5251.792-13425.029z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.71002,1.03723,-1.03723,1.71002,-623.284,-1107.65)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FA604B"
    },
    d: "M-12668.078-3487.862c0,0-3.454,10.094-3.231,15.984 c0.223,5.86,6.524,5.606,6.473-0.659C-12664.883-3478.204-12668.078-3487.862-12668.078-3487.862z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.97972,1.7436,-1.7436,0.97972,389.931,-1707.99)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FA604B"
    },
    d: "M-12734.016,3775.751c0,0-3.454,10.094-3.231,15.984 c0.223,5.86,6.524,5.606,6.473-0.659C-12730.82,3785.41-12734.016,3775.751-12734.016,3775.751z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1.71504,1.0289,-1.0289,-1.71504,3242.83,-172.818)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FA604B"
    },
    d: "M4239.911,14228.575c0,0-3.454,10.094-3.231,15.984 c0.223,5.859,6.524,5.605,6.473-0.659C4243.107,14238.233,4239.911,14228.575,4239.911,14228.575z"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.746771,0.278422,0.283159,0.734277,2169.73,-2328.23)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#201F1D"
    },
    d: "M16307.28-30582.764c0.024,0.299-0.014,0.527,0.067,0.814 c0.599,2.113,1.959,3.969,2.981,5.979c1.668,3.281,3.345,6.604,4.791,9.979c1.046,2.451,2.032,4.898,2.766,7.389 c0.061,0.234,0.297,0.373,0.53,0.316c0.231-0.061,0.372-0.297,0.313-0.531c-0.945-4.275-2.364-8.578-4.291-12.676 c-1.72-3.652-3.82-7.123-5.858-10.473c-0.117-0.191-0.198-0.408-0.351-0.566c-0.195-0.201-0.392-0.26-0.622-0.412 c-0.049-0.092-0.163-0.123-0.253-0.074C16307.264-30582.967,16307.231-30582.854,16307.28-30582.764z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.746771,0.278422,0.283159,0.734277,2169.73,-2328.23)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#201F1D"
    },
    d: "M16289.619-30568.494c0.337,0.555,0.636,1.1,1.027,1.613 c1.538,2.02,3.413,3.729,5.294,5.395c3.5,3.107,7.348,5.799,11.079,8.707c0.214,0.172,0.529,0.139,0.7-0.076 c0.174-0.215,0.139-0.529-0.075-0.701c-3.628-3.006-7.245-5.945-10.772-8.994c-1.869-1.615-3.633-3.344-5.497-5.006 c-0.476-0.424-0.981-0.771-1.473-1.182c-0.068-0.08-0.188-0.088-0.264-0.02 C16289.56-30568.689,16289.552-30568.572,16289.619-30568.494z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.746771,0.278422,0.283159,0.734277,2169.73,-2328.23)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#201F1D"
    },
    d: "M16284.927-30549.844c3.274,0.398,6.538,0.764,9.815,0.871 c4.915,0.164,9.828-0.121,14.764-0.357c0.214-0.01,0.386-0.191,0.378-0.408c-0.009-0.217-0.19-0.387-0.405-0.379l-24.522-0.1 c-0.103-0.008-0.192,0.068-0.201,0.172C16284.747-30549.941,16284.823-30549.854,16284.927-30549.844z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.746771,0.278422,0.283159,0.734277,2169.73,-2328.23)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#201F1D"
    },
    d: "M16284.516-30527.535c0.462-0.148,0.925-0.271,1.375-0.451 c3.979-1.572,7.721-3.781,11.533-5.834c4.204-2.266,8.419-4.52,12.704-6.555c2.157-1.023,4.307-2.041,6.53-2.896 c0.081-0.027,0.127-0.117,0.098-0.201c-0.027-0.082-0.117-0.125-0.198-0.098c-3.446,1.027-6.826,2.271-10.101,3.811 c-6.802,3.197-13.227,7.314-19.914,10.646c-0.674,0.334-1.462,0.492-2.021,0.986c-0.09,0.078-0.098,0.152-0.163,0.252 c-0.093,0.041-0.133,0.152-0.09,0.248C16284.313-30527.535,16284.421-30527.494,16284.516-30527.535z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.746771,0.278422,0.283159,0.734277,2169.73,-2328.23)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#201F1D"
    },
    d: "M16294.747-30514.043c0.291,0.027,0.323,0.139,0.601,0.059 c0.201-0.061,0.331-0.26,0.494-0.389c2.438-1.99,4.772-4.088,7.017-6.277c5.797-5.656,11.093-11.789,16.979-17.377 c0.139-0.127,0.149-0.342,0.021-0.48c-0.124-0.135-0.339-0.146-0.478-0.021c-4.392,3.803-8.614,7.764-12.734,11.838 c-3.69,3.646-7.31,7.357-11.152,10.863c-0.299,0.271-0.701,0.465-0.891,0.82c-0.142,0.268-0.055,0.381-0.099,0.68 c-0.078,0.068-0.087,0.186-0.021,0.264C16294.552-30513.986,16294.668-30513.977,16294.747-30514.043z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.746771,0.278422,0.283159,0.734277,2169.73,-2328.23)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#201F1D"
    },
    d: "M16313.962-30504.885l5.968-27.891 c0.035-0.162-0.065-0.318-0.223-0.354c-0.16-0.037-0.318,0.064-0.354,0.223c-1.326,5.543-2.875,11.057-4.06,16.646 c-0.794,3.734-1.375,7.508-1.902,11.279c-0.024,0.158,0.081,0.309,0.239,0.332 C16313.788-30504.621,16313.938-30504.727,16313.962-30504.885z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.746771,0.278422,0.283159,0.734277,2169.73,-2328.23)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#201F1D"
    },
    d: "M16333.362-30507.838c-0.024-0.74-0.022-1.469-0.109-2.201 c-0.34-2.895-1.122-5.727-1.894-8.547c-2.231-8.15-5.351-16.105-7.272-24.316c-0.032-0.141-0.174-0.232-0.314-0.199 c-0.145,0.029-0.234,0.17-0.204,0.314c0.479,2.371,1.049,4.729,1.668,7.078c1.729,6.535,3.77,13.02,5.397,19.559 c0.489,1.961,0.883,3.939,1.355,5.898c0.204,0.852,0.468,1.672,0.683,2.518c0.026,0.189,0.206,0.322,0.396,0.293 C16333.259-30507.469,16333.389-30507.648,16333.362-30507.838z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.746771,0.278422,0.283159,0.734277,2169.73,-2328.23)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#201F1D"
    },
    d: "M16355.515-30518.195c-0.049-0.246,0.011-0.355-0.111-0.572 c-0.175-0.305-0.514-0.477-0.772-0.713c-3.261-2.961-6.366-6.266-9.402-9.695c-5.06-5.717-9.942-11.754-14.627-17.303 c-0.099-0.121-0.28-0.141-0.403-0.039c-0.122,0.098-0.141,0.275-0.043,0.4c4.471,5.748,8.938,12.143,13.954,17.922 c3.044,3.506,6.28,6.797,9.736,9.623c0.277,0.225,0.509,0.541,0.843,0.658c0.239,0.08,0.337,0.004,0.587,0.008 c0.081,0.064,0.198,0.055,0.264-0.027C16355.604-30518.012,16355.594-30518.129,16355.515-30518.195z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.746771,0.278422,0.283159,0.734277,2169.73,-2328.23)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#201F1D"
    },
    d: "M16359.615-30538.066c-1.521-0.625-3.02-1.281-4.573-1.818 c-3.612-1.25-7.318-2.209-11.033-3.102c-5.305-1.268-10.68-2.201-16.087-3c-0.16-0.027-0.313,0.082-0.34,0.242 c-0.027,0.158,0.081,0.311,0.239,0.338c4.274,0.84,8.494,1.863,12.715,2.896c4.432,1.082,8.817,2.318,13.236,3.453 c1.905,0.49,3.82,0.873,5.729,1.346c0.098,0.029,0.204-0.025,0.236-0.123 C16359.768-30537.932,16359.716-30538.037,16359.615-30538.066z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.746771,0.278422,0.283159,0.734277,2169.73,-2328.23)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#201F1D"
    },
    d: "M16361.188-30561.355c-1.489,0.328-2.973,0.635-4.44,1.057 c-3.404,0.977-6.723,2.244-10.008,3.582c-7.027,2.855-13.818,6.311-20.484,9.877c-0.171,0.09-0.239,0.305-0.149,0.479 c0.09,0.172,0.305,0.24,0.476,0.15c5.604-2.834,11.323-5.494,17.125-7.955c3.473-1.473,7-2.805,10.52-4.148 c2.358-0.9,4.682-1.854,7.065-2.68c0.1-0.029,0.157-0.133,0.127-0.234 C16361.39-30561.326,16361.286-30561.383,16361.188-30561.355z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.746771,0.278422,0.283159,0.734277,2169.73,-2328.23)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#201F1D"
    },
    d: "M16352.525-30577.07c-0.81,0.598-1.636,1.141-2.419,1.771 c-1.804,1.451-3.5,3.033-5.22,4.582c-5.739,5.162-11.356,10.457-17.027,15.699c-0.195,0.176-0.21,0.477-0.033,0.67 c0.177,0.195,0.479,0.213,0.675,0.035c5.771-5.133,11.654-10.133,17.331-15.367c1.704-1.572,3.43-3.125,5.024-4.809 c0.69-0.732,1.297-1.512,1.951-2.275c0.085-0.078,0.09-0.211,0.011-0.295 C16352.74-30577.145,16352.609-30577.146,16352.525-30577.07z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.746771,0.278422,0.283159,0.734277,2169.73,-2328.23)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#201F1D"
    },
    d: "M16330.37-30584.898c-0.601,2.008-1.236,4-1.78,6.018 c-2.174,8.072-3.935,16.219-6.317,24.256c-0.063,0.201,0.051,0.416,0.255,0.477c0.201,0.059,0.413-0.055,0.476-0.256 c1.856-6.021,3.576-12.049,5.033-18.15c0.973-4.064,1.776-8.162,2.698-12.252c0.024-0.102-0.035-0.205-0.136-0.229 C16330.498-30585.061,16330.397-30585,16330.37-30584.898z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.74794,0,0,2.74794,-2074.65,-185.766)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#F8F0E9"
    },
    d: "M-6038.362-7293.2c2.833,0,5.129,2.296,5.129,5.129 s-2.296,5.129-5.129,5.129s-5.129-2.296-5.129-5.129S-6041.195-7293.2-6038.362-7293.2z"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.402662,0.15268,0.155278,0.409513,2392.22,12597.2)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2,0,0,2,-1230.28,-11.3452)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FA604B"
    },
    d: "M-7486.77-9029.262c0,0-3.454,10.094-3.231,15.984 c0.223,5.86,6.524,5.606,6.473-0.658C-7483.574-9019.604-7486.77-9029.262-7486.77-9029.262z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.22465e-16,2,-2,1.22465e-16,1564.7,-1734.77)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FA604B"
    },
    d: "M-8168.495,8885.309c0,0-3.454,10.094-3.231,15.984 c0.223,5.86,6.524,5.605,6.473-0.659C-8165.299,8894.967-8168.495,8885.309-8168.495,8885.309z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.88149,1.79526,-1.79526,-0.88149,2505.16,-1267.64)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FA604B"
    },
    d: "M-3418.992,12101.223c0,0-3.454,10.094-3.231,15.984 c0.223,5.86,6.524,5.605,6.473-0.658C-3415.797,12110.881-3418.992,12101.223-3418.992,12101.223z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1.71002,-1.03723,1.03723,-1.71002,2683.01,2156.42)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FA604B"
    },
    d: "M13319.413,3750.915c0,0-3.454,10.094-3.23,15.984 c0.223,5.86,6.524,5.606,6.473-0.659C13322.608,3760.573,13319.413,3750.915,13319.413,3750.915z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.97972,-1.7436,1.7436,-0.97972,1667.33,2760.64)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FA604B"
    },
    d: "M13457.756-2687.002c0,0-3.454,10.094-3.231,15.984 c0.223,5.86,6.524,5.606,6.474-0.659C13460.951-2677.343,13457.756-2687.002,13457.756-2687.002z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.71504,-1.0289,1.0289,1.71504,-1184.1,1232.54)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FA604B"
    },
    d: "M-1474.654-12138.828c0,0-3.454,10.094-3.231,15.984 c0.223,5.86,6.525,5.605,6.473-0.659C-1471.458-12129.17-1474.654-12138.828-1474.654-12138.828z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-2,-2.44929e-16,2.44929e-16,-2,3287.37,1064.5)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FA604B"
    },
    d: "M9745.8,9568.596c0,0-3.453,10.094-3.23,15.984 c0.223,5.86,6.524,5.605,6.473-0.659C9748.996,9578.254,9745.8,9568.596,9745.8,9568.596z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.22465e-16,-2,2,1.22465e-16,490.873,2787.93)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FA604B"
    },
    d: "M10429.364-8346.709c0,0-3.454,10.094-3.231,15.984 c0.223,5.859,6.524,5.605,6.473-0.659C10432.56-8337.051,10429.364-8346.709,10429.364-8346.709z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.991667,-1.73684,1.73684,0.991667,-556.942,2223.55)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FA604B"
    },
    d: "M4932.992-11824.457c0,0-3.454,10.094-3.231,15.984 c0.223,5.859,6.524,5.605,6.473-0.659C4936.188-11814.799,4932.992-11824.457,4932.992-11824.457z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.71002,1.03723,-1.03723,1.71002,-623.284,-1107.65)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FA604B"
    },
    d: "M-11059.639-3211.482c0,0-3.454,10.094-3.231,15.984 c0.223,5.86,6.524,5.606,6.474-0.659C-11056.443-3201.823-11059.639-3211.482-11059.639-3211.482z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.97972,1.7436,-1.7436,0.97972,389.931,-1707.99)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FA604B"
    },
    d: "M-11197.321,3226.163c0,0-3.454,10.094-3.23,15.984 c0.223,5.86,6.524,5.606,6.473-0.659C-11194.125,3235.821-11197.321,3226.163-11197.321,3226.163z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1.71504,1.0289,-1.0289,-1.71504,3242.83,-172.818)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FA604B"
    },
    d: "M3734.238,12676.876c0,0-3.454,10.094-3.231,15.984 c0.223,5.86,6.525,5.605,6.473-0.659C3737.433,12686.534,3734.238,12676.876,3734.238,12676.876z"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.746771,0.278422,0.283159,0.734277,2169.73,-2328.23)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#201F1D"
    },
    d: "M14389.361-26939.824c0.038,0.285,0.017,0.518,0.101,0.795 c0.652,2.096,1.984,3.959,3.009,5.965c1.677,3.283,3.351,6.609,4.788,9.992c1.043,2.453,2.014,4.91,2.739,7.408 c0.051,0.207,0.261,0.328,0.467,0.277c0.207-0.053,0.329-0.264,0.277-0.469c-0.959-4.271-2.407-8.557-4.331-12.646 c-1.721-3.648-3.802-7.131-5.827-10.486c-0.113-0.189-0.198-0.404-0.348-0.564c-0.179-0.199-0.372-0.275-0.587-0.436 c-0.043-0.078-0.144-0.105-0.226-0.063C14389.346-26940.004,14389.318-26939.904,14389.361-26939.824z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.746771,0.278422,0.283159,0.734277,2169.73,-2328.23)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#201F1D"
    },
    d: "M14371.698-26925.559c0.346,0.543,0.657,1.084,1.052,1.588 c1.557,2.002,3.427,3.709,5.308,5.375c3.502,3.1,7.334,5.809,11.06,8.723c0.19,0.152,0.47,0.121,0.622-0.068 s0.122-0.471-0.067-0.623c-3.637-2.996-7.264-5.926-10.788-8.975c-1.873-1.619-3.642-3.346-5.487-5.029 c-0.47-0.428-0.967-0.789-1.448-1.207c-0.06-0.068-0.166-0.076-0.233-0.018 C14371.644-26925.732,14371.639-26925.627,14371.698-26925.559z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.746771,0.278422,0.283159,0.734277,2169.73,-2328.23)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#201F1D"
    },
    d: "M14366.992-26906.918c3.274,0.387,6.538,0.727,9.815,0.83 c4.912,0.154,9.826-0.111,14.758-0.34c0.193-0.006,0.343-0.168,0.337-0.359c-0.008-0.193-0.168-0.342-0.361-0.336 c-3.28,0.076-6.546,0.105-9.813,0.092c-2.451-0.01-4.899-0.098-7.351-0.131c-2.451-0.029-4.899,0.006-7.361-0.084 c-0.09-0.008-0.169,0.061-0.177,0.15C14366.831-26907.004,14366.899-26906.926,14366.992-26906.918z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.746771,0.278422,0.283159,0.734277,2169.73,-2328.23)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#201F1D"
    },
    d: "M14366.57-26884.607c0.457-0.152,0.916-0.285,1.367-0.467 c3.965-1.604,7.712-3.797,11.52-5.848c4.206-2.27,8.421-4.525,12.712-6.549c2.163-1.021,4.317-2.021,6.546-2.867 c0.073-0.025,0.111-0.105,0.087-0.176c-0.024-0.074-0.103-0.115-0.176-0.09c-3.438,1.043-6.811,2.307-10.079,3.85 c-6.797,3.209-13.231,7.305-19.922,10.629c-0.674,0.334-1.451,0.504-2.024,0.986c-0.087,0.07-0.104,0.143-0.169,0.232 c-0.084,0.039-0.119,0.137-0.081,0.219C14366.389-26884.604,14366.486-26884.568,14366.57-26884.607z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.746771,0.278422,0.283159,0.734277,2169.73,-2328.23)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#201F1D"
    },
    d: "M14376.796-26871.109c0.259,0.008,0.323,0.102,0.568,0.02 c0.198-0.066,0.329-0.258,0.492-0.393c2.429-1.994,4.755-4.098,7-6.287c5.796-5.656,11.119-11.762,17.017-17.338 c0.125-0.111,0.133-0.301,0.021-0.424s-0.302-0.131-0.424-0.02c-4.381,3.813-8.582,7.795-12.696,11.871 c-3.688,3.654-7.317,7.357-11.169,10.857c-0.298,0.273-0.689,0.469-0.891,0.818c-0.136,0.24-0.076,0.373-0.134,0.643 c-0.07,0.059-0.078,0.164-0.019,0.232C14376.622-26871.059,14376.729-26871.049,14376.796-26871.109z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.746771,0.278422,0.283159,0.734277,2169.73,-2328.23)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#201F1D"
    },
    d: "M14395.992-26861.941l5.968-27.895 c0.032-0.141-0.058-0.279-0.198-0.313c-0.142-0.029-0.28,0.059-0.313,0.199c-1.315,5.547-2.84,11.063-4.03,16.652 c-0.796,3.734-1.395,7.5-1.932,11.271c-0.022,0.139,0.07,0.271,0.212,0.293 C14395.837-26861.707,14395.968-26861.803,14395.992-26861.941z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.746771,0.278422,0.283159,0.734277,2169.73,-2328.23)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#201F1D"
    },
    d: "M14415.384-26864.881c-0.032-0.74-0.043-1.465-0.133-2.195 c-0.361-2.893-1.131-5.721-1.902-8.541c-2.226-8.15-5.323-16.117-7.229-24.326c-0.027-0.129-0.152-0.207-0.28-0.18 c-0.125,0.027-0.206,0.152-0.179,0.279c1.682,8.264,4.399,16.355,6.565,24.527c0.739,2.797,1.314,5.623,1.976,8.428 c0.168,0.709,0.391,1.391,0.57,2.098c0.027,0.168,0.185,0.285,0.354,0.26 C14415.294-26864.555,14415.411-26864.713,14415.384-26864.881z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.746771,0.278422,0.283159,0.734277,2169.73,-2328.23)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#201F1D"
    },
    d: "M14437.563-26875.229c-0.06-0.223-0.021-0.346-0.139-0.541 c-0.182-0.299-0.517-0.473-0.777-0.709c-3.271-2.955-6.383-6.258-9.421-9.693c-5.058-5.721-9.916-11.775-14.587-17.334 c-0.09-0.109-0.248-0.125-0.356-0.039c-0.108,0.088-0.128,0.248-0.038,0.355c4.481,5.738,8.971,12.113,13.989,17.887 c3.044,3.502,6.274,6.793,9.721,9.629c0.274,0.225,0.505,0.531,0.837,0.66c0.217,0.08,0.331,0.023,0.56,0.041 c0.07,0.057,0.177,0.045,0.233-0.025C14437.643-26875.068,14437.634-26875.172,14437.563-26875.229z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.746771,0.278422,0.283159,0.734277,2169.73,-2328.23)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#201F1D"
    },
    d: "M14441.672-26895.1c-1.526-0.607-3.029-1.244-4.584-1.773 c-3.62-1.234-7.32-2.199-11.033-3.09c-5.301-1.275-10.674-2.227-16.076-3.041c-0.141-0.021-0.277,0.074-0.302,0.215 c-0.021,0.141,0.071,0.273,0.215,0.299c4.274,0.826,8.5,1.834,12.724,2.859c4.435,1.076,8.823,2.307,13.239,3.459 c1.899,0.496,3.813,0.902,5.718,1.389c0.087,0.029,0.179-0.02,0.206-0.105 C14441.808-26894.977,14441.759-26895.072,14441.672-26895.1z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.746771,0.278422,0.283159,0.734277,2169.73,-2328.23)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#201F1D"
    },
    d: "M14443.257-26918.385c-1.484,0.338-2.965,0.664-4.427,1.088 c-3.399,0.99-6.718,2.254-10.003,3.592c-7.024,2.855-13.821,6.293-20.489,9.852c-0.152,0.08-0.212,0.268-0.134,0.424 c0.082,0.15,0.27,0.211,0.421,0.129c5.602-2.84,11.316-5.516,17.117-7.979c3.474-1.475,7.001-2.814,10.525-4.148 c2.358-0.891,4.695-1.826,7.081-2.639c0.087-0.025,0.139-0.117,0.111-0.203 C14443.436-26918.359,14443.344-26918.408,14443.257-26918.385z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.746771,0.278422,0.283159,0.734277,2169.73,-2328.23)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#201F1D"
    },
    d: "M14434.602-26934.102c-0.799,0.604-1.611,1.166-2.389,1.799 c-1.794,1.465-3.489,3.043-5.209,4.592c-5.736,5.168-11.37,10.445-17.047,15.682c-0.171,0.156-0.185,0.422-0.027,0.596 c0.155,0.172,0.424,0.186,0.596,0.029c5.766-5.139,11.633-10.156,17.315-15.385c1.704-1.57,3.429-3.123,5.035-4.797 c0.695-0.723,1.318-1.492,1.979-2.248c0.076-0.066,0.079-0.184,0.011-0.26 C14434.794-26934.168,14434.678-26934.172,14434.602-26934.102z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.746771,0.278422,0.283159,0.734277,2169.73,-2328.23)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#201F1D"
    },
    d: "M14412.454-26941.945c-0.317,1-0.657,1.986-0.945,2.994 c-1.038,3.623-1.916,7.283-2.837,10.928c-1.381,5.459-2.715,10.93-4.296,16.361c-0.055,0.178,0.049,0.367,0.225,0.42 c0.18,0.053,0.37-0.047,0.422-0.227c1.546-5.016,2.965-10.043,4.244-15.109c1.024-4.051,2.047-8.105,2.924-12.201 c0.218-1.023,0.387-2.055,0.585-3.084c0.021-0.09-0.033-0.18-0.12-0.201 C14412.566-26942.088,14412.477-26942.035,14412.454-26941.945z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.74794,0,0,2.74794,-2074.65,-185.766)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#F8F0E9"
    },
    d: "M-5141.766-6514.093c2.833,0,5.129,2.296,5.129,5.129 s-2.296,5.129-5.129,5.129s-5.129-2.296-5.129-5.129S-5144.598-6514.093-5141.766-6514.093z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.983056, 0, 0, 0.983056, 94.857903, 242.011993)",
    id: "object-7"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.33467,0.132328,-0.060859,0.613829,-203.821,4878.55)",
    id: "object-0"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.374723,0,0,0.814774,-820.403,79.0267)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "rgb(124, 147, 154)"
    },
    d: "M2068.224-10063.065l-377.688,73.778l62.944,527.807 l31.574-3.125l306.719-45.272L2068.224-10063.065z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.374723,0,0,0.814774,-806.022,80.1238)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FBFAEB"
    },
    d: "M1717.919-9962.224l-21.495-18.315l323.418-65.979 l42.183,11.93l38.115,517.997l-353.464,50.626L1717.919-9962.224z"
  }), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_1_",
    points: "1717.919,-9962.224 1696.424,-9980.539 2019.842,-10046.519 2062.025,-10034.589  2100.14,-9516.592 1746.675,-9465.966 \t\t\t\t\t\t\t"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000093141323689233650670000014573031556039547305_"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "1717.919,-9962.224 1696.424,-9980.539 2019.842,-10046.519 2062.025,-10034.589  2100.14,-9516.592 1746.675,-9465.966 \t\t\t\t\t\t\t",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000093141323689233650670000014573031556039547305_)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.18703,0.0185513,-0.0210453,1.18146,-1307.18,-3113.33)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    d: "M2450.053-5842.31c0,0,0.799-0.082,2.302-0.38 c3.435-0.652,10.546-2.31,20.462-4.511c41.829-9.266,133.225-29.593,204.576-45.462 c22.093-4.918,42.267-9.375,58.444-13.017c23.778-5.326,38.933-8.804,38.933-8.804c0.054-0.027,0.09-0.082,0.079-0.136 c-0.014-0.055-0.068-0.082-0.125-0.082c0,0-15.199,3.288-39.001,8.532c-16.19,3.56-36.359,8.044-58.455,12.962 c-71.357,15.843-162.755,36.142-204.568,45.49c-9.913,2.201-17.057,3.723-20.451,4.565c-1.484,0.38-2.245,0.625-2.245,0.625 c-0.06,0.027-0.098,0.082-0.084,0.136S2449.993-5842.282,2450.053-5842.31z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.18703,0.0185513,-0.0210453,1.18146,-1342.46,-3127.03)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    d: "M2471.841-5834.207c0,0,0.799-0.082,2.302-0.38 c3.435-0.652,10.546-2.31,20.462-4.511c41.83-9.266,133.225-29.592,204.576-45.462c22.093-4.918,42.267-9.375,58.444-13.017 c23.778-5.326,38.933-8.804,38.933-8.804c0.054-0.027,0.09-0.082,0.079-0.136c-0.014-0.055-0.068-0.082-0.125-0.082 c0,0-15.199,3.288-39.001,8.533c-16.19,3.56-36.359,8.043-58.455,12.962c-71.357,15.843-162.755,36.142-204.568,45.49 c-9.913,2.201-17.057,3.723-20.451,4.565c-1.484,0.38-2.244,0.625-2.244,0.625c-0.06,0.027-0.098,0.081-0.084,0.136 C2471.722-5834.234,2471.781-5834.18,2471.841-5834.207z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.18703,0.0185513,-0.0210453,1.18146,-1358.58,-3146.34)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    d: "M2481.939-5822.463c0,0,0.799-0.082,2.302-0.38 c3.435-0.652,10.547-2.31,20.462-4.511c41.83-9.267,133.225-29.593,204.576-45.463c22.093-4.918,42.267-9.375,58.444-13.017 c23.778-5.326,38.933-8.804,38.933-8.804c0.054-0.027,0.09-0.082,0.079-0.136c-0.014-0.055-0.068-0.082-0.125-0.082 c0,0-15.199,3.288-39.001,8.533c-16.19,3.56-36.359,8.043-58.455,12.962c-71.357,15.843-162.755,36.142-204.568,45.49 c-9.913,2.201-17.057,3.723-20.451,4.565c-1.484,0.38-2.245,0.625-2.245,0.625c-0.06,0.027-0.098,0.082-0.084,0.136 C2481.82-5822.49,2481.88-5822.436,2481.939-5822.463z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.741956,-0.0735623,0.0735623,0.741956,-13276.7,15018.1)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#8FB3C2"
    },
    d: "M23870.51-31428.826l-83.234,21.527l-447.234,49.346 l69.268,726.631l438.92,39L23870.51-31428.826z"
  }), /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000036965710476382972940000013934291070002474669_",
    points: "23870.51,-31428.826  23787.275,-31407.299 23340.041,-31357.953 23409.309,-30631.322 23848.229,-30592.322 \t\t\t\t\t\t\t\t\t\t"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000124860019396310329160000014275029783238649250_"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "23870.51,-31428.826  23787.275,-31407.299 23340.041,-31357.953 23409.309,-30631.322 23848.229,-30592.322 \t\t\t\t\t\t\t\t\t\t",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000124860019396310329160000014275029783238649250_)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.831136,0.113096,-0.101061,0.742692,5180.69,-2655.25)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#CEDEE4"
    },
    d: "M17041.896-41062.336 c23.996-11.375,50.844-17.848,76.904-22.492c18.451-3.293,81.25-4.383,95.518-17.113 c3.533-3.164-7.527-13.109-9.811-14.246c-18.914-9.379-38.152,2.012-53.045-2.965c-0.379-0.133-0.787-3.297-0.814-3.578 c-2.092-19.746,13.234-54.148-16.93-59.961c-19.238-3.703-35.354,8.297-44.43,24.047 c-0.189,0.371-3.207,6.641-3.262,6.637c-7.174-1.047-13.287-6.266-20.652-7.008 c-29.836-3.004-36.658,16.633-32.961,39.742c0.08,0.535-6.469,2.664-6.877,2.813 c-15.732,5.738-27.119,11.988-20.053,30.328L17041.896-41062.336z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.06047,0.144302,-0.128946,0.947618,-691.661,-3745.57)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#CEDEE4"
    },
    d: "M19071.438-31764.57 c23.996-11.377,50.844-17.85,76.904-22.492c18.451-3.291,81.25-4.385,95.518-17.111 c3.533-3.164-7.527-13.109-9.811-14.248c-18.914-9.379-38.152,2.014-53.045-2.965c-0.379-0.133-0.787-3.297-0.814-3.58 c-2.092-19.744,13.234-54.146-16.93-59.957c-19.24-3.707-35.354,8.297-44.43,24.047 c-0.189,0.369-3.207,6.639-3.262,6.633c-7.174-1.043-13.287-6.264-20.652-7.006 c-29.836-3.002-36.658,16.631-32.963,39.744c0.082,0.531-6.467,2.662-6.875,2.809 c-15.732,5.742-27.119,11.99-20.053,30.33L19071.438-31764.57z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.557668,0.126258,-0.122397,0.540613,12915.7,-1301.57)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#CEDEE4"
    },
    d: "M6579.604-56362.363 c23.995-11.375,50.843-17.848,76.903-22.488c18.451-3.293,81.251-4.387,95.518-17.113 c3.532-3.164-7.528-13.109-9.811-14.246c-18.914-9.379-38.152,2.012-53.044-2.965c-0.38-0.133-0.788-3.297-0.815-3.582 c-2.093-19.742,13.233-54.145-16.93-59.957c-19.239-3.707-35.354,8.297-44.43,24.047 c-0.19,0.371-3.207,6.641-3.261,6.633c-7.174-1.043-13.288-6.262-20.652-7.004 c-29.837-3.004-36.658,16.629-32.962,39.742c0.081,0.531-6.468,2.664-6.875,2.809 c-15.734,5.742-27.12,11.992-20.055,30.332L6579.604-56362.363z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(6.07299,0,7.30979e-17,5.17801,27473.5,3194.3)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FB624D"
    },
    d: "M-617.23-6602.547 c-13.713-1.825-29.596,7.058-37.267,22.368c-9.373,18.707-7.023,39.595-7.023,39.595l22.624,0.152 c0,0-0.276-33.484,17.429-33.655c24.278-0.233,18.923,36.178,18.923,36.178l20.067-0.285 C-582.476-6538.194-572.021-6596.53-617.23-6602.547z"
  }), /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000074429511706539006990000000906542861574709947_",
    d: "M-617.23-6602.547 c-13.713-1.825-29.596,7.058-37.267,22.368c-9.373,18.707-7.023,39.595-7.023,39.595l22.624,0.152 c0,0-0.276-33.484,17.429-33.655c24.278-0.233,18.923,36.178,18.923,36.178l20.067-0.285 C-582.476-6538.194-572.021-6596.53-617.23-6602.547z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000060006629530533467140000012577515849514350991_"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-617.23-6602.547 c-13.713-1.825-29.596,7.058-37.267,22.368c-9.373,18.707-7.023,39.595-7.023,39.595l22.624,0.152 c0,0-0.276-33.484,17.429-33.655c24.278-0.233,18.923,36.178,18.923,36.178l20.067-0.285 C-582.476-6538.194-572.021-6596.53-617.23-6602.547z",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000060006629530533467140000012577515849514350991_)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.891462,0,0,0.93034,27.3602,34.6439)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#EDB14D"
    },
    d: "M-723.604-7126.748 c-13.713-1.825-29.596,7.058-37.267,22.368c-9.373,18.707-7.023,39.595-7.023,39.595l24.329,0.514 c0,0-3.946-34.824,15.02-34.901c24.279-0.098,19.628,37.062,19.628,37.062l20.067-0.285 C-688.85-7062.394-678.394-7120.73-723.604-7126.748z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.759571,0,0,0.792697,60.6073,76.9216)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#46937B"
    },
    d: "M-893.78-8409.354 c-13.713-1.825-29.596,7.058-37.267,22.368c-9.373,18.707-7.023,39.595-7.023,39.595l24.329,0.515 c0,0-3.946-34.824,15.02-34.901c24.279-0.098,19.628,37.063,19.628,37.063l20.067-0.285 C-859.026-8345-848.571-8403.336-893.78-8409.354z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.620546,0,0,0.671287,101.1,121.972)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#CEDEE4"
    },
    d: "M-1157.868-9985.702 c-13.713-1.825-29.596,7.058-37.267,22.368c-9.373,18.707-7.023,39.595-7.023,39.595l24.329,0.515 c0,0-3.946-34.824,15.02-34.901c24.279-0.098,19.628,37.063,19.628,37.063l20.067-0.285 C-1123.114-9921.349-1112.659-9979.685-1157.868-9985.702z"
  }))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "object-1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.374723,0,0,0.374723,-8669.25,11673.7)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FBFAEB"
    },
    d: "M23297.795-31383.926l-49.186,693.896l182.42,88.123 l38.207,2.158l0.49-9.645l16.412,1.945l12.311-705.328L23297.795-31383.926z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.374723,0,0,0.374723,-8669.25,11673.7)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    d: "M23326.408-31374.24c9.43,3.232,35.844,13.982,64.648,25.828 c43.316,17.799,92.012,38.121,96.225,39.875c-0.164,10.605-4.213,284.229-6.875,484.09 c-1.551,116.289-2.609,207.609-2.609,207.609c0,0.09,0.082,0.162,0.162,0.162c0.109,0.004,0.164-0.07,0.164-0.16 c0,0,1.549-91.311,3.287-207.598c3.043-203.834,6.82-484.406,6.82-484.406c0-0.193-0.107-0.367-0.299-0.441 c0,0-64.32-26.967-112.691-46.449c-22.201-8.951-41.061-16.291-48.723-18.85c-0.082-0.033-0.189,0.018-0.219,0.111 C23326.271-31374.373,23326.328-31374.273,23326.408-31374.24z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.374723,0,0,0.374723,-8669.25,11673.7)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    d: "M23309.344-31380.953c4.104,2.029,9.809,4.91,16.711,8.254 c5.027,2.434,10.734,5.088,16.85,7.977c49.918,23.605,128.805,60.662,134.512,63.344 c-0.164,12.678-4.564,355.477-6.848,553.914c-0.924,81.443-1.469,138.57-1.469,138.57c0,0.066,0.057,0.121,0.137,0.121 c0.055,0,0.109-0.051,0.109-0.119c0,0,0.924-57.121,2.037-138.564c2.799-202.188,7.148-554.27,7.148-554.27 c0-0.221-0.109-0.424-0.328-0.516c0,0-103.615-49.018-151.74-71.311c-6.984-3.229-12.799-5.824-16.957-7.723 c-0.082-0.045-0.189-0.006-0.244,0.084C23309.234-31381.102,23309.262-31380.996,23309.344-31380.953z"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.374723,0,0,0.374723,-8669.25,11673.7)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "rgb(124, 147, 154)"
    },
    d: "M23234.424-31402.805l12.473,712.775l207.883,105.014 l14.457-710.164L23234.424-31402.805z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.381182,0,0,0.381182,-8924.09,11633.6)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    d: "M23715.877-30612.732c0.027,0,0.053-0.006,0.08-0.021 c0.055-0.025,0.082-0.068,0.082-0.117c0.082-0.092,0.109-0.248,0.082-0.508c-0.055-0.463-0.625-1.285-1.223-2.469 c-3.451-6.945-12.283-24.676-12.283-24.676c-0.055-0.107-0.137-0.191-0.244-0.24l-144.568-65.227 c-0.352-0.156-0.76-0.053-0.979,0.254l-20.76,26.75c-0.137,0.148-0.191,0.334-0.191,0.527l2.201,566.574 c0,0.121,0.027,0.24,0.082,0.355l14.402,36.992c0.109,0.23,0.271,0.422,0.488,0.529l124.324,60.807 c0.299,0.146,0.65,0.088,0.896-0.143l29.238-28.471c0.271-0.273,0.271-0.725,0-1.008c-0.271-0.285-0.705-0.291-1.004-0.016 l-28.941,27.98c-8.234-4.055-116.361-57.352-123.289-60.764l-14.213-36.457l-2.473-566.096l20.137-26.02 c0,0,138.588,61.857,144.051,64.291c0.924,1.799,9.049,17.914,12.336,24.449c0.598,1.18,0.896,2.141,1.25,2.459 C23715.658-30612.695,23715.822-30612.723,23715.877-30612.732z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.381182,0,0,0.381182,-8687.39,11707.9)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    d: "M23094.902-30807.656l-0.189-0.17c0,0-0.055-0.115-0.217,0.102 c-0.082,0.139-0.027,0.508-0.027,1.027c-0.055,1.676-0.109,5.174-0.219,10.27c-0.354,17.84-1.113,55.258-1.955,102.699 c-1.875,107.338-4.402,265.979-5.816,365.174c-0.787,54.68-1.168,91.297-1.168,91.297c0,0.395,0.326,0.719,0.705,0.727 c0.408,0.006,0.734-0.311,0.734-0.705c0,0,0.789-36.611,1.686-91.289c1.686-99.189,4.076-257.832,5.543-365.176 c0.652-47.447,1.033-84.871,1.25-102.715c0.055-5.092,0.109-8.588,0.109-10.268c0-0.52,0.055-0.889-0.027-1.027 c-0.137-0.223-0.191-0.105-0.191-0.105L23094.902-30807.656c0.191-0.271,0.109-0.352,0-0.354c-0.082,0-0.162,0.076-0.162,0.174 L23094.902-30807.656z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "object-8"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.082,0,0,1.1111,268.062,13005.8)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FFFFFF"
    },
    d: "M-183.679-11369.252l1.322,3.573l3.573,1.321l-3.573,1.322 l-1.322,3.573l-1.322-3.573l-3.573-1.322l3.573-1.321L-183.679-11369.252z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.082,0,0,1.1111,1080.33,12026.4)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FFFFFF"
    },
    d: "M-881.847-10725.315l3,8.109l8.11,3.001l-8.11,3.001 l-3,8.109l-3.001-8.109l-8.11-3.001l8.11-3.001L-881.847-10725.315z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.603877,0,0,0.620119,966.459,12917.8)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FFFFFF"
    },
    d: "M-1394.722-20363.842l3.622,9.791l9.791,3.621l-9.791,3.623 l-3.622,9.791l-3.622-9.791l-9.791-3.623l9.791-3.621L-1394.722-20363.842z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.603877,0,0,0.620119,1612.72,12029.9)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FFFFFF"
    },
    d: "M-2401.352-19279.691l3,8.109l8.11,3l-8.11,3l-3,8.109 l-3-8.109l-8.11-3l8.11-3L-2401.352-19279.691z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.603877,0,0,0.620119,2151.93,12708.2)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FFFFFF"
    },
    d: "M-2880.819-20106.617l3.622,9.789l9.791,3.623l-9.791,3.623 l-3.622,9.789l-3.622-9.789l-9.791-3.623l9.791-3.623L-2880.819-20106.617z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.334148,0,0,0.343135,1091.09,12759.6)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FFFFFF"
    },
    d: "M-3022.767-36533.621l3.622,9.789l9.791,3.625l-9.791,3.621 l-3.622,9.789l-3.622-9.789l-9.791-3.621l9.791-3.625L-3022.767-36533.621z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.334148,0,0,0.343135,1124.08,12969.2)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FFFFFF"
    },
    d: "M-3094.667-36978.469l3.622,9.789l9.791,3.621l-9.791,3.625 l-3.622,9.789l-3.622-9.789l-9.791-3.625l9.791-3.621L-3094.667-36978.469z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.334148,0,0,0.343135,948.455,13123.8)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FFFFFF"
    },
    d: "M-2711.903-37306.586l3.622,9.789l9.791,3.625l-9.791,3.621 l-3.622,9.789l-3.622-9.789l-9.791-3.621l9.791-3.625L-2711.903-37306.586z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.334148,0,0,0.343135,2037.63,12250.6)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FFFFFF"
    },
    d: "M-5528.797-35376.461l3.623,9.793l9.791,3.621l-9.791,3.621 l-3.623,9.793l-3.623-9.793l-9.791-3.621l9.791-3.621L-5528.797-35376.461z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.334148,0,0,0.343135,2590.7,12560)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FFFFFF"
    },
    d: "M-6393.979-36068.715l3.623,9.789l9.791,3.625l-9.791,3.621 l-3.623,9.789l-3.623-9.789l-9.791-3.621l9.791-3.625L-6393.979-36068.715z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "object-9"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.571049,0,0,0.571049,979.869,5803.97)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-18.8467,-5.49435)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.776242,6.85347,5.02305,-0.568923,2415.65,12514.1)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#F4B484"
    },
    d: "M-3262.523-213.41c0,0-0.264,2.378,0.572,3.681 c0.812,1.264,4.795,3.827,9.067,6.27c2.557,1.462,2.864-1.519,1.889-2.398c-0.951-0.857-5.982-7.109-5.982-7.109 s-4.001-0.29-5.568-0.405"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-6.33445,-3.13225,-2.40671,4.86716,2579.35,12977.1)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#F4B484"
    },
    d: "M1890.398-3431.256c3.623,2.341,6.567,3.603,8.661,4.57 c0.826,0.382,1.015-0.816,0.449-1.306c-1.07-0.927-5.087-7.022-7.41-7.004c-0.458,0.004-1.733,0.623-2.223,1.458 C1889.536-3432.959,1889.578-3431.785,1890.398-3431.256z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.15522,-5.71749,-6.92658,-1.39952,1601.33,12619.9)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#F4B484"
    },
    d: "M3650.656,1029.679c0.048,0.009,0.338,0.136,0.589,0.323 c0.352,0.261,0.601,0.879,0.873,1.376c0.385,0.705,1.463,1.085,1.385,1.431c-0.068,0.305-0.971-0.01-0.962,0.012 c0.094,0.232,0.683,0.769,0.683,0.769c0.02,0.338-0.603,0.636-1.094,0.271c0.015,0.38-0.832,0.261-1.053-0.156 c0.055,0.437-0.829,0.452-1.205-0.075c0.067,0.294-0.663,0.258-0.794-0.099c-0.28-0.76-0.957-3.272-1.022-3.514 C3647.959,1029.662,3650.656,1029.679,3650.656,1029.679"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-132.552,71.4337)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    d: "M-1200.783-9780.324l0.541,1.087c0.212,0.354,0.416,0.733,0.641,1.114 c0.152,0.244,0.315,0.489,0.489,0.706c0.459,0.599,0.943,1.169,1.448,1.712c0.755,0.789,1.552,1.576,2.34,2.364 c0.013,0.027,0.032,0.027,0.043,0c0.014,0,0.014-0.027,0.003-0.027c-0.755-0.842-1.511-1.657-2.236-2.473 c-0.481-0.57-0.954-1.141-1.394-1.739c-0.166-0.217-0.318-0.461-0.465-0.679c-0.223-0.381-0.432-0.761-0.641-1.114 c-0.144-0.245-0.253-0.517-0.419-0.761c-0.063-0.082-0.117-0.19-0.209-0.245c-0.033,0-0.052,0-0.087-0.026 c-0.016,0-0.041,0-0.054,0.026C-1200.799-9780.379-1200.799-9780.352-1200.783-9780.324z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-132.552,71.4337)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    d: "M-1207.639-9779.835l2.087,2.445c0.462,0.489,0.954,0.924,1.465,1.332 c0.761,0.625,1.563,1.223,2.367,1.793c0.024,0.027,0.06,0,0.079-0.026c0.019-0.027,0.014-0.055-0.011-0.082 c-0.788-0.57-1.573-1.169-2.318-1.82c-0.495-0.436-0.973-0.87-1.424-1.359c-0.522-0.517-0.981-1.114-1.492-1.657 c-0.223-0.244-0.457-0.462-0.701-0.68c-0.016-0.027-0.041-0.027-0.054,0 C-1207.655-9779.862-1207.655-9779.862-1207.639-9779.835z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-132.552,71.4337)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    d: "M-1209.204-9773.612c0.063,0.055,0.12,0.136,0.188,0.19 c0.592,0.543,1.228,1.06,1.826,1.604c0.992,0.924,1.968,1.875,2.965,2.771c0.421,0.381,0.848,0.761,1.283,1.114 c0.016,0,0.041,0,0.054-0.027c0.016,0,0.014-0.027-0.003-0.055c-1.484-1.25-2.837-2.717-4.291-4.076 c-0.563-0.516-1.114-1.032-1.75-1.467c-0.073-0.055-0.149-0.082-0.226-0.108c-0.016-0.027-0.041-0.027-0.054,0 C-1209.226-9773.64-1209.22-9773.64-1209.204-9773.612z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-132.552,71.4337)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    d: "M-1209.723-9766.411c0.584,0.462,1.141,0.924,1.701,1.359 c0.864,0.706,1.723,1.358,2.633,1.956c0.997,0.652,2.06,1.223,3.25,1.685c0.041,0,0.087-0.027,0.103-0.054 c0.016-0.055-0.005-0.082-0.046-0.109c-1.158-0.462-2.177-1.087-3.155-1.739c-0.902-0.598-1.764-1.25-2.652-1.902 c-0.579-0.435-1.174-0.842-1.788-1.249c-0.019-0.027-0.043-0.027-0.054,0 C-1209.745-9766.438-1209.74-9766.411-1209.723-9766.411z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-132.552,71.4337)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    d: "M-1210.438-9762.742l0.277-1.522c0.003-0.026-0.008-0.054-0.03-0.054 c-0.019,0-0.041,0-0.043,0.027l-0.283,1.549c0,0.026,0.014,0.054,0.035,0.054S-1210.441-9762.716-1210.438-9762.742z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-132.552,71.4337)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    d: "M-1209.886-9762.416l0.457-2.012c0.005-0.026-0.011-0.054-0.033-0.054 s-0.046,0-0.052,0.027l-0.446,2.011c-0.005,0.027,0.005,0.055,0.027,0.055 C-1209.911-9762.389-1209.892-9762.389-1209.886-9762.416z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-132.552,71.4337)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    d: "M-1210.772-9768.992c0.084-0.436,0.179-0.843,0.285-1.25 c0.109-0.408,0.228-0.815,0.361-1.224c0.005-0.026-0.005-0.054-0.027-0.054c-0.024,0-0.046,0-0.054,0.027 c-0.13,0.407-0.25,0.814-0.356,1.25c-0.109,0.407-0.204,0.814-0.285,1.25c-0.003,0,0.011,0.026,0.033,0.026 C-1210.797-9768.966-1210.775-9768.966-1210.772-9768.992z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-132.552,71.4337)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    d: "M-1209.022-9775.895c0.084-0.272,0.182-0.517,0.291-0.788 c0.163-0.381,0.348-0.762,0.538-1.142c0.008,0,0-0.027-0.019-0.055c-0.019,0-0.043,0-0.054,0.027 c-0.188,0.381-0.372,0.761-0.538,1.142c-0.109,0.244-0.207,0.517-0.291,0.788c-0.008,0.027,0.003,0.055,0.025,0.055 C-1209.052-9775.867-1209.03-9775.867-1209.022-9775.895z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-132.552,71.4337)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    d: "M-1206.897-9781.928l0.427-1.114c0.008,0,0-0.026-0.022-0.054 c-0.022,0-0.046,0-0.057,0.027l-0.421,1.113c-0.005,0.027,0.005,0.055,0.027,0.055 C-1206.924-9781.9-1206.902-9781.9-1206.897-9781.928z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-132.552,71.4337)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    d: "M-1199.036-9785.922c-0.288,0-0.486,0.163-0.611,0.38 c-0.174,0.326-0.204,0.788-0.207,1.087c-0.003,0.408,0.141,0.815,0.372,1.169s0.549,0.652,0.891,0.815 c0.467,0.271,0.94,0.271,1.321,0.136c0.397-0.19,0.693-0.544,0.761-1.06c0.003,0-0.003,0-0.005,0c-0.005,0-0.011,0-0.011,0 c-0.09,0.488-0.386,0.814-0.775,0.978c-0.361,0.136-0.804,0.109-1.236-0.136c-0.323-0.19-0.617-0.462-0.834-0.815 c-0.212-0.326-0.345-0.706-0.34-1.087c0-0.299,0.041-0.706,0.19-1.005c0.098-0.218,0.245-0.381,0.489-0.408 c0.022,0,0.038,0,0.035-0.026C-1198.995-9785.922-1199.014-9785.922-1199.036-9785.922z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-132.552,71.4337)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    d: "M-1197.519-9780.977l0.918-0.299c0.025,0,0.035-0.027,0.027-0.055 c-0.011-0.026-0.038-0.054-0.062-0.026l-0.902,0.299c-0.022,0-0.033,0.027-0.027,0.054 C-1197.563-9780.977-1197.541-9780.977-1197.519-9780.977z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-132.552,71.4337)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    d: "M-1197.302-9780.324l0.75-0.19c0.022,0,0.035-0.027,0.024-0.054 c-0.008-0.027-0.033-0.027-0.057-0.027l-0.731,0.217c-0.022,0-0.035,0.027-0.03,0.027 C-1197.343-9780.324-1197.321-9780.297-1197.302-9780.324z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.868122,7.01303,-5.38856,-0.667033,1868.29,12500.1)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#F4B484"
    },
    d: "M-3068.459,1066.853c0,0-0.264,2.378,0.572,3.681 c0.812,1.264,4.66,4.939,8.934,7.381c3.532,2.018,3.195-2.38,2.022-3.509c-0.931-0.896-3.573-3.945-5.265-5.173 c-2.426-1.76-4.717-2.226-6.284-2.341"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-6.92313,-1.41649,1.08838,-5.31949,2186.37,12764.5)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#F4B484"
    },
    d: "M1115.315,3920.171c3.686,2.169,6.938,2.895,9.032,3.862 c0.826,0.382,0.984-1.497,0.419-1.987c-1.071-0.927-5.872-4.957-8.15-5.551c-0.747-0.195-1.215,0.343-1.525,0.692 C1114.833,3917.478,1114.81,3919.875,1115.315,3920.171z"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-7.04879,0.500839,0.500839,7.04879,2070.45,13741.8)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#F4B484"
    },
    d: "M233.564-3335.146c0,0,0.762,2.799,1.063,3.911 c0.39,1.438,0.569,3.526,0.497,5.298c-0.11,2.709-0.335,7.617-1.159,10.958c-0.691,2.803-0.952,8.279-0.756,11.915 c0.038,0.698,1.948,1.446,3.324,1.702c0,0,0.003,0.568-2.575,0.556c-0.613-0.14-2.377,0.391-2.923-0.055 c-0.667-0.545-0.002-1.396-0.173-1.935c-1.806-5.672-3.807-9.243-0.5-12.9c0,0-2.634-14.953-0.216-18.14 C231.233-3335.268,233.564-3335.146,233.564-3335.146"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-7.06445,0.172425,0.170416,6.98213,2145.82,13736.3)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#F4B484"
    },
    d: "M392.635-3359.873c0,0,4.377,1.816,4.586,4.675 c0.268,3.68-1.433,12.982-2.257,16.323c-0.691,2.803-10.386,6.864-10.743,7.028c-1.706,0.788-0.969,4.897-0.62,5.448 c0,0-1.673-2.09-1.732-3.358c-0.049-1.06-1.137-3.054-1.023-3.453c0.314-1.097,2.312,0.047,2.44-0.226 c2.001-4.269,4.164-5.416,8.075-6.157l-0.958-10.715c0,0-1.512-2.583-0.091-5.215 C391.135-3357.046,392.635-3359.873,392.635-3359.873z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-7.04714,-0.523469,-0.523469,7.04714,2183.48,12575.4)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#F4B484"
    },
    d: "M711.254-3115.595c0,0,0.431,2.807-0.524,3.767 c-0.788,0.792,3.745,1.617,4.159,0.837c0,0-0.64-0.884-0.77-1.303c-0.164-0.53-0.217-1.877-0.217-1.877 S713.856-3115.356,711.254-3115.595"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-7.04714,-0.523469,-0.523469,7.04714,2020.26,12744.5)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#F4B484"
    },
    d: "M695.77-3131.548c-0.011,0.33,0.153,7.221,0.153,7.221 c-0.707-0.276-3.91,4.708-3.91,4.708l-3.079-0.123c0,0,0.095-0.968,0.157-2.111c0.112-2.063-0.278-2.962-0.958-3.757 l0.753-1.475c-1.398-4.664-2.002-7.626-0.133-10.732c0,0,0.997-0.069,1.03,0.022l4.179-0.088c0,0,1.341,2.836,1.585,3.175 C696.772-3133.012,695.778-3131.781,695.77-3131.548"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-7.04714,-0.523469,-0.444308,5.98144,2166.09,12356.3)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#F4B484"
    },
    d: "M708.284-3631.812c-0.911-0.501-1.649-1.117-2.137-2.263 c-0.966-2.267-0.08-3.5,1.316-4.01c1.661-0.606,2.622,0.252,3.058,0.76c0.415,0.483,0.888,1.931,0.972,3.216 c0.057,0.876-0.581,2.092-1.058,2.373C709.908-3631.425,708.899-3631.473,708.284-3631.812z"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-4.88277,-0.362697,-0.357654,4.81488,2830.97,11733.2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.152646,-0.0114986,-0.0113387,0.154798,2223.02,275.279)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#8FB3C2"
    },
    d: "M11209.28-15798.603c-2.201,1.454,0.435,3.59-0.788,5.014 c-1.55,1.794,1.494,2.704-0.544,4.924c-1.305,1.389,0.544,4.207,0.544,4.207l-0.544,7.47l13.669-7.47 c0.271,0.06,2.31-0.146,2.581-1.558c0.19-1.114-0.815-2.476,0-3.605c1.305-1.794,0.788-2.111,0.517-3.563 c-0.381-1.968,1.142-3.517,0.761-5.419H11209.28z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.152646,0.0114986,-0.0113387,0.154798,-2015.17,-43.9775)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    d: "M16540.916-15794.333c0.055-0.027,0.055-0.055,0.109-0.074 c0.027-0.014,0.055-0.008,0.107-0.011c0.627-0.065,1.277-0.078,1.957-0.057c1.686,0.049,3.396,0.293,5.027,0.348 c0,0,0.027,0.019,0.027,0.043c0,0.025-0.027,0.044-0.027,0.044c-1.385-0.008-2.881-0.13-4.32-0.19 c-0.869-0.035-1.74-0.041-2.582,0.011c-0.055,0.006-0.107,0.022-0.162,0.011c-0.055-0.008-0.082-0.032-0.137-0.051 c0,0-0.027-0.014-0.027-0.033C16540.889-15794.312,16540.889-15794.331,16540.916-15794.333z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.152646,0.0114986,-0.0113387,0.154798,-2015.17,-43.9775)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    d: "M16555.482-15789.758c-1.25,0.286-2.527,0.465-3.805,0.522 c-1.93,0.087-3.859-0.073-5.762-0.229c-0.055-0.003-0.082-0.038-0.082-0.079c0.027-0.038,0.055-0.07,0.082-0.067 c1.604,0.095,3.207,0.16,4.811,0.141c0.625-0.008,1.25-0.029,1.902-0.064c0.951-0.052,1.902-0.131,2.854-0.294 c0.027-0.003,0.027,0.011,0.053,0.03C16555.535-15789.779,16555.51-15789.76,16555.482-15789.758z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.152646,0.0114986,-0.0113387,0.154798,-2015.17,-43.9775)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    d: "M16553.879-15793.331c-0.518,0.044-1.006,0.131-1.494,0.174 c-0.354,0.03-0.68,0.038-1.006,0.022c-0.055,0-0.082-0.03-0.055-0.065c0-0.035,0.027-0.063,0.055-0.06l2.473-0.142 c0.027-0.003,0.055,0.014,0.055,0.032C16553.906-15793.35,16553.879-15793.334,16553.879-15793.331z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.152646,0.0114986,-0.0113387,0.154798,-2015.17,-43.9775)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    d: "M16553.145-15796.687c-0.381,0.011-0.734,0.027-1.086,0.029 c-0.545,0.003-1.061-0.019-1.604-0.029c-0.055-0.003-0.082-0.035-0.082-0.076c0-0.038,0.055-0.071,0.082-0.071 c0.625,0.014,1.25,0.006,1.875,0.027c0.271,0.009,0.543,0.033,0.814,0.049c0,0,0.027,0.017,0.027,0.036 C16553.172-15796.7,16553.145-15796.685,16553.145-15796.687z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.152646,0.0114986,-0.0113387,0.154798,-2015.17,-43.9775)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    d: "M16544.938-15787.472c0.354,0.052,0.707,0.067,1.061,0.073 c0.354,0.008,0.707,0.008,1.061,0c0.053,0,0.08,0.035,0.08,0.076c0,0.043-0.027,0.078-0.08,0.081 c-0.436,0-0.871,0.006-1.277-0.029c-0.301-0.024-0.572-0.068-0.871-0.131c0-0.005-0.027-0.021-0.027-0.043 C16544.883-15787.464,16544.91-15787.475,16544.938-15787.472z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.152646,0.0114986,-0.0113387,0.154798,-2015.17,-43.9775)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    d: "M16540.998-15797.092c0.055-0.035,0.027-0.046,0.082-0.057 c0.135-0.041,0.299,0.076,0.434,0.141c0.219,0.109,0.408,0.262,0.625,0.413c0.027,0.022,0.027,0.068,0.027,0.101 c-0.027,0.036-0.082,0.047-0.109,0.022c-0.324-0.19-0.625-0.343-0.977-0.449c-0.027-0.008-0.055-0.005-0.082-0.024 c-0.027-0.04,0-0.021,0-0.076c-0.027-0.005-0.027-0.024-0.027-0.043S16540.998-15797.097,16540.998-15797.092z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.152646,0.0114986,-0.0113387,0.154798,-2015.17,-43.9775)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    d: "M16545.916-15797.032c-0.055,0.047-0.082,0.093-0.135,0.134 c-0.246,0.206-0.572,0.345-0.816,0.543c-0.135,0.087-0.244,0.166-0.354,0.261c-0.027,0.036-0.08,0.036-0.135,0.003 c-0.027-0.035-0.027-0.09,0-0.128c0.189-0.209,0.406-0.401,0.625-0.557c0.217-0.139,0.434-0.315,0.68-0.343 c0.025-0.005,0.053,0.011,0.08,0.022c0.027-0.009,0.055,0,0.055,0.016 C16545.916-15797.062,16545.916-15797.04,16545.916-15797.032z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.152646,0.0114986,-0.0113387,0.154798,-2015.17,-43.9775)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    d: "M16541.242-15792.644c0.082-0.024,0.109-0.052,0.164-0.054 c0.189-0.009,0.354,0.087,0.543,0.165c0.299,0.145,0.57,0.362,0.842,0.585c0.027,0.019,0.027,0.06,0,0.09 c-0.027,0.026-0.055,0.035-0.082,0.013c-0.217-0.119-0.434-0.209-0.678-0.313c-0.219-0.101-0.436-0.2-0.652-0.282 c-0.027-0.008-0.055-0.011-0.055-0.027c-0.055-0.035-0.055-0.06-0.082-0.105c-0.027-0.006-0.027-0.024-0.027-0.044 C16541.215-15792.635,16541.242-15792.648,16541.242-15792.644z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.152646,0.0114986,-0.0113387,0.154798,-2015.17,-43.9775)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    d: "M16548.498-15796.478l-0.762,0.394c0,0.012-0.027,0.006-0.053-0.013 c0-0.022,0-0.047,0.025-0.058c0.164-0.108,0.326-0.22,0.518-0.302c0.082-0.035,0.162-0.057,0.244-0.087 c0.027-0.008,0.027-0.003,0.055,0.017C16548.525-15796.508,16548.525-15796.488,16548.498-15796.478z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.152646,0.0114986,-0.0113387,0.154798,-2015.17,-43.9775)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    d: "M16547.955-15792.586c0.08,0.029,0.107,0.021,0.162,0.067 c0.271,0.27,0.354,0.652,0.57,0.971c0.055,0.049,0.027,0.116,0,0.152c-0.053,0.035-0.135,0.024-0.162-0.024 c-0.217-0.283-0.436-0.552-0.598-0.856c-0.027-0.046-0.055-0.09-0.055-0.145c0-0.06,0-0.073,0.027-0.133 c0-0.019,0-0.041,0.027-0.049C16547.928-15792.61,16547.955-15792.603,16547.955-15792.586z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.152646,0.0114986,-0.0113387,0.154798,-2015.17,-43.9775)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    d: "M16552.928-15795.537c-0.055,0.046-0.082,0.092-0.137,0.133 c-0.162,0.142-0.381,0.245-0.57,0.386c-0.162,0.12-0.299,0.264-0.436,0.395c-0.08,0.057-0.135,0.101-0.217,0.16 c-0.027,0.032-0.055,0.038-0.109,0.014c-0.025-0.024-0.025-0.071,0-0.106c0.055-0.089,0.082-0.177,0.137-0.255 c0.109-0.114,0.217-0.204,0.326-0.294c0.271-0.198,0.543-0.427,0.842-0.497c0.055-0.008,0.082,0,0.137,0.003 c0-0.011,0.027-0.003,0.027,0.014C16552.955-15795.567,16552.955-15795.545,16552.928-15795.537z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.152646,0.0114986,-0.0113387,0.154798,-2015.17,-43.9775)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    d: "M16554.611-15797.151c-0.244,0.166-0.488,0.364-0.732,0.563 c-0.246,0.201-0.463,0.402-0.707,0.608c-0.027,0.02-0.055,0.02-0.055-0.003c-0.027-0.019-0.027-0.051,0-0.067 c0.299-0.305,0.625-0.622,0.979-0.878c0.164-0.108,0.326-0.198,0.488-0.285c0.027-0.011,0.055-0.006,0.055,0.014 C16554.639-15797.185,16554.639-15797.162,16554.611-15797.151z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.152646,0.0114986,-0.0113387,0.154798,-2015.17,-43.9775)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    d: "M16545.672-15791.648c0.027,0.06,0.027,0.003,0.027,0.067 c-0.027,0.036-0.055,0.061-0.082,0.087c-0.271,0.28-0.598,0.492-0.896,0.742c-0.055,0.038-0.109,0.032-0.137-0.008 c-0.053-0.044-0.053-0.109,0-0.145c0.299-0.269,0.545-0.59,0.871-0.796c0.053-0.02,0.08-0.044,0.107-0.041 c0.055,0.003,0,0.003,0.055,0.035c0.027-0.014,0.055-0.011,0.055,0.006 C16545.699-15791.684,16545.699-15791.662,16545.672-15791.648z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.152646,0.0114986,-0.0113387,0.154798,-2015.17,-43.9775)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    d: "M16551.025-15791.072c0.055-0.035,0.055-0.065,0.135-0.079 c0.164-0.027,0.326,0.057,0.49,0.108c0.299,0.099,0.543,0.253,0.814,0.451c0.055,0.03,0.082,0.087,0.055,0.134 c-0.055,0.043-0.109,0.057-0.135,0.029c-0.219-0.105-0.436-0.168-0.625-0.236c-0.219-0.07-0.436-0.081-0.625-0.198 c-0.082-0.041-0.082-0.081-0.137-0.139c0-0.006-0.027-0.024-0.027-0.044 C16550.971-15791.064,16550.998-15791.075,16551.025-15791.072z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.152646,0.0114986,-0.0113387,0.154798,-2015.17,-43.9775)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    d: "M16554.123-15795.206c0.055,0.02,0.109,0.02,0.162,0.052 c0.191,0.108,0.326,0.285,0.463,0.443c0.189,0.198,0.354,0.415,0.488,0.654c0.027,0.03,0,0.073-0.025,0.093 c-0.027,0.021-0.055,0.011-0.082-0.02c-0.109-0.111-0.191-0.206-0.299-0.307c-0.219-0.239-0.518-0.424-0.707-0.698 c-0.027-0.055-0.027-0.106-0.055-0.166c-0.027-0.014-0.027-0.035,0-0.052 C16554.068-15795.22,16554.096-15795.22,16554.123-15795.206z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.152646,0.0114986,-0.0113387,0.154798,-2015.17,-43.9775)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    d: "M16548.879-15794.994c0.135,0.065,0.271,0.134,0.406,0.212 c0.191,0.117,0.381,0.253,0.572,0.397c0.025,0.016,0.025,0.054,0,0.081c0,0.024-0.055,0.03-0.082,0.014l-0.979-0.546 c-0.027-0.02-0.055-0.071-0.027-0.114C16548.77-15794.994,16548.824-15795.013,16548.879-15794.994z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.152646,0.0114986,-0.0113387,0.154798,-2015.17,-43.9775)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    d: "M16551.297-15787.103c0.055,0,0.055-0.017,0.109,0.006 c0.053,0.021,0.08,0.07,0.107,0.114c0.137,0.136,0.246,0.293,0.354,0.439c0.055,0.099,0.137,0.196,0.217,0.28 c0.027,0.021,0.027,0.065,0.027,0.098c-0.027,0.032-0.08,0.041-0.107,0.02c-0.219-0.114-0.408-0.272-0.57-0.46 c-0.082-0.084-0.164-0.165-0.219-0.261c0-0.024-0.027-0.049-0.027-0.078c0-0.05,0-0.041,0.027-0.09 c-0.027-0.022-0.027-0.058,0-0.076C16551.242-15787.13,16551.27-15787.127,16551.297-15787.103z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.152646,0.0114986,-0.0113387,0.154798,-2015.17,-43.9775)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    d: "M16555.156-15788.045c0.027,0.054,0.027,0.038,0.027,0.095 c0,0.027-0.027,0.044-0.055,0.068c-0.109,0.16-0.271,0.307-0.408,0.453c-0.137,0.142-0.271,0.274-0.408,0.433 c-0.027,0.038-0.08,0.046-0.107,0.021c-0.055-0.024-0.055-0.076-0.027-0.114c0.162-0.277,0.381-0.527,0.598-0.764 c0.055-0.079,0.109-0.185,0.217-0.23c0.055-0.022,0.055-0.003,0.109-0.009c0.027-0.014,0.027-0.016,0.055-0.003 C16555.184-15788.083,16555.184-15788.059,16555.156-15788.045z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.152646,0.0114986,-0.0113387,0.154798,-2015.17,-43.9775)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    d: "M16551.596-15784.918c0.109,0.052,0.217,0.065,0.326,0.134 c0.244,0.144,0.436,0.366,0.625,0.565c0.027,0.032,0.055,0.087,0.027,0.122c-0.055,0.035-0.109,0.041-0.137,0.011 c-0.217-0.166-0.488-0.267-0.678-0.459c-0.109-0.093-0.164-0.204-0.219-0.318c-0.027-0.011-0.027-0.035,0-0.049 C16551.541-15784.929,16551.568-15784.929,16551.596-15784.918z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.152646,0.0114986,-0.0113387,0.154798,-2015.17,-43.9775)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    d: "M16548.635-15787.554c-0.027,0.049-0.027,0.09-0.055,0.134 c-0.271,0.301-0.652,0.467-0.951,0.73c-0.027,0.033-0.082,0.03-0.109-0.005c-0.027-0.033-0.027-0.087,0-0.117 c0.299-0.277,0.57-0.601,0.924-0.77c0.055-0.021,0.109-0.019,0.164-0.029c0-0.011,0.027-0.009,0.027,0.008 C16548.66-15787.589,16548.66-15787.564,16548.635-15787.554z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.152646,0.0114986,-0.0113387,0.154798,-2015.17,-43.9775)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    d: "M16543.77-15789.238c0,0.024,0,0.032,0,0.052 c-0.055,0.101-0.189,0.144-0.299,0.209c-0.271,0.198-0.57,0.386-0.842,0.593c-0.055,0.043-0.109,0.092-0.164,0.13 c-0.082,0.044-0.135,0.063-0.189,0.104c-0.055,0.038-0.109,0.041-0.164,0.003c-0.027-0.038-0.027-0.101,0-0.139 c0.055-0.073,0.082-0.145,0.137-0.209c0.082-0.087,0.189-0.152,0.271-0.224c0.326-0.225,0.68-0.401,1.006-0.616 c0.027-0.02,0.055-0.052,0.082-0.06c0.025-0.003,0.025,0.008,0.053,0.014c0.027-0.03,0.082-0.022,0.137,0.016 C16543.824-15789.325,16543.797-15789.269,16543.77-15789.238z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.152646,0.0114986,-0.0113387,0.154798,-2015.17,-43.9775)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    d: "M16542.955-15786.898c0.053-0.009,0.053-0.027,0.107-0.021 c0.219,0.026,0.408,0.203,0.625,0.299c0.027,0.016,0.055,0.064,0.055,0.105c-0.027,0.038-0.082,0.058-0.109,0.041 c-0.217-0.087-0.488-0.117-0.65-0.274c-0.027-0.027-0.027-0.049-0.055-0.084c-0.027-0.009-0.027-0.03-0.027-0.05 C16542.928-15786.901,16542.928-15786.907,16542.955-15786.898z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.152646,0.0114986,-0.0113387,0.154798,-2015.17,-43.9775)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    d: "M16555.4-15792.04c-0.055,0.106-0.082,0.204-0.164,0.294 c-0.162,0.179-0.379,0.285-0.598,0.426c-0.055,0.05-0.162,0.033-0.189-0.035c-0.055-0.067-0.055-0.163,0.027-0.212 c0.189-0.146,0.354-0.331,0.57-0.44c0.109-0.054,0.217-0.054,0.326-0.087c0-0.014,0.027-0.011,0.055,0.006 C16555.428-15792.072,16555.428-15792.051,16555.4-15792.04z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-2.30675,4.31878,4.25873,2.27468,930.309,12161.7)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.152646,-0.0114986,-0.0113387,0.154798,2223.02,275.279)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#8FB3C2"
    },
    d: "M28642.711-7783.259c-2.201,1.454,0.436,3.589-0.787,5.013 c-1.549,1.794,1.494,2.704-0.545,4.924c-1.303,1.389,0.545,4.207,0.545,4.207l-0.545,7.47l13.67-7.47 c0.271,0.06,2.309-0.146,2.582-1.557c0.189-1.114-0.816-2.476-0.002-3.606c1.305-1.793,0.789-2.111,0.518-3.563 c-0.381-1.967,1.141-3.517,0.76-5.418H28642.711z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.152646,0.0114986,-0.0113387,0.154798,-2015.17,-43.9775)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    d: "M-892.515-7778.989c0.054-0.027,0.054-0.054,0.109-0.073 c0.027-0.014,0.054-0.008,0.109-0.011c0.625-0.065,1.277-0.079,1.957-0.057c1.685,0.049,3.397,0.293,5.027,0.348 c0,0,0.027,0.019,0.027,0.043c0,0.024-0.027,0.043-0.027,0.043c-1.386-0.008-2.88-0.13-4.321-0.19 c-0.87-0.036-1.739-0.041-2.582,0.011c-0.054,0.005-0.109,0.021-0.163,0.011c-0.054-0.008-0.082-0.033-0.136-0.052 c0,0-0.027-0.013-0.027-0.032C-892.542-7778.967-892.542-7778.986-892.515-7778.989z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.152646,0.0114986,-0.0113387,0.154798,-2015.17,-43.9775)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    d: "M-877.95-7774.413c-1.25,0.285-2.527,0.465-3.804,0.522 c-1.93,0.087-3.859-0.074-5.761-0.229c-0.054-0.002-0.082-0.038-0.081-0.079c0.027-0.038,0.054-0.071,0.081-0.068 c1.603,0.095,3.206,0.16,4.81,0.141c0.625-0.008,1.25-0.03,1.902-0.065c0.951-0.051,1.902-0.13,2.853-0.293 c0.027-0.002,0.027,0.011,0.054,0.03C-877.895-7774.435-877.923-7774.416-877.95-7774.413z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.152646,0.0114986,-0.0113387,0.154798,-2015.17,-43.9775)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    d: "M-879.553-7777.986c-0.516,0.043-1.005,0.13-1.495,0.174 c-0.353,0.03-0.679,0.038-1.005,0.021c-0.054,0-0.081-0.03-0.055-0.065c0-0.036,0.027-0.063,0.055-0.06l2.473-0.141 c0.027-0.003,0.054,0.014,0.054,0.033C-879.526-7778.005-879.553-7777.989-879.553-7777.986z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.152646,0.0114986,-0.0113387,0.154798,-2015.17,-43.9775)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    d: "M-880.287-7781.343c-0.38,0.011-0.734,0.027-1.087,0.03 c-0.544,0.002-1.06-0.019-1.603-0.03c-0.054-0.002-0.082-0.035-0.082-0.076c0-0.038,0.055-0.071,0.082-0.071 c0.625,0.014,1.25,0.005,1.875,0.027c0.272,0.008,0.544,0.032,0.815,0.049c0,0,0.027,0.016,0.027,0.035 C-880.26-7781.356-880.287-7781.34-880.287-7781.343z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.152646,0.0114986,-0.0113387,0.154798,-2015.17,-43.9775)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    d: "M-888.493-7772.127c0.353,0.051,0.707,0.068,1.06,0.073 c0.353,0.008,0.706,0.008,1.06,0c0.054,0,0.081,0.035,0.081,0.076c0,0.044-0.027,0.079-0.081,0.082 c-0.435,0-0.87,0.005-1.277-0.03c-0.299-0.024-0.571-0.068-0.87-0.13c0-0.005-0.027-0.021-0.027-0.043 C-888.548-7772.12-888.521-7772.13-888.493-7772.127z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.152646,0.0114986,-0.0113387,0.154798,-2015.17,-43.9775)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    d: "M-892.434-7781.748c0.054-0.035,0.027-0.046,0.082-0.057 c0.136-0.041,0.299,0.076,0.435,0.141c0.217,0.108,0.408,0.261,0.625,0.413c0.027,0.021,0.027,0.068,0.027,0.101 c-0.027,0.035-0.082,0.046-0.109,0.021c-0.326-0.19-0.625-0.342-0.978-0.448c-0.027-0.008-0.055-0.005-0.082-0.024 c-0.027-0.041,0-0.022,0-0.076c-0.027-0.005-0.027-0.024-0.027-0.043C-892.461-7781.739-892.434-7781.753-892.434-7781.748z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.152646,0.0114986,-0.0113387,0.154798,-2015.17,-43.9775)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    d: "M-887.515-7781.688c-0.054,0.046-0.081,0.092-0.136,0.133 c-0.245,0.206-0.571,0.345-0.815,0.543c-0.136,0.087-0.245,0.166-0.353,0.261c-0.027,0.035-0.082,0.035-0.136,0.003 c-0.027-0.036-0.027-0.09,0-0.128c0.19-0.209,0.408-0.402,0.625-0.557c0.217-0.139,0.435-0.315,0.679-0.342 c0.027-0.005,0.054,0.011,0.081,0.021c0.027-0.008,0.054,0,0.054,0.017C-887.515-7781.718-887.515-7781.696-887.515-7781.688z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.152646,0.0114986,-0.0113387,0.154798,-2015.17,-43.9775)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    d: "M-892.189-7777.299c0.081-0.024,0.109-0.052,0.163-0.054 c0.19-0.008,0.353,0.086,0.543,0.166c0.299,0.144,0.571,0.361,0.843,0.584c0.027,0.019,0.027,0.06,0,0.089 c-0.027,0.027-0.054,0.035-0.081,0.014c-0.218-0.12-0.435-0.209-0.679-0.313c-0.218-0.101-0.435-0.201-0.652-0.283 c-0.027-0.008-0.055-0.011-0.054-0.027c-0.054-0.036-0.055-0.06-0.081-0.106c-0.027-0.005-0.027-0.024-0.027-0.043 C-892.216-7777.291-892.189-7777.304-892.189-7777.299z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.152646,0.0114986,-0.0113387,0.154798,-2015.17,-43.9775)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    d: "M-884.934-7781.133l-0.761,0.394c0,0.011-0.027,0.005-0.054-0.014 c0-0.021,0-0.046,0.027-0.057c0.163-0.108,0.326-0.22,0.516-0.301c0.082-0.036,0.163-0.057,0.245-0.087 c0.027-0.008,0.027-0.003,0.054,0.016C-884.906-7781.163-884.906-7781.144-884.934-7781.133z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.152646,0.0114986,-0.0113387,0.154798,-2015.17,-43.9775)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    d: "M-885.477-7777.242c0.082,0.03,0.109,0.021,0.163,0.068 c0.272,0.269,0.353,0.652,0.571,0.97c0.054,0.049,0.027,0.117,0,0.152c-0.054,0.035-0.136,0.024-0.163-0.024 c-0.217-0.283-0.435-0.552-0.598-0.856c-0.027-0.046-0.054-0.09-0.054-0.144c0-0.06,0-0.073,0.027-0.133 c0-0.019,0-0.041,0.027-0.049C-885.504-7777.266-885.477-7777.258-885.477-7777.242z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.152646,0.0114986,-0.0113387,0.154798,-2015.17,-43.9775)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    d: "M-880.504-7780.193c-0.054,0.046-0.081,0.092-0.136,0.133 c-0.163,0.142-0.38,0.245-0.57,0.386c-0.163,0.12-0.299,0.263-0.435,0.394c-0.081,0.057-0.136,0.101-0.217,0.16 c-0.027,0.033-0.054,0.038-0.109,0.014c-0.027-0.024-0.027-0.071,0-0.106c0.054-0.09,0.082-0.177,0.136-0.255 c0.109-0.114,0.218-0.204,0.326-0.294c0.272-0.198,0.543-0.426,0.843-0.497c0.054-0.008,0.081,0,0.136,0.003 c0-0.011,0.027-0.003,0.027,0.014C-880.477-7780.223-880.477-7780.201-880.504-7780.193z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.152646,0.0114986,-0.0113387,0.154798,-2015.17,-43.9775)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    d: "M-878.819-7781.807c-0.245,0.166-0.489,0.364-0.734,0.563 c-0.245,0.201-0.462,0.402-0.706,0.608c-0.027,0.019-0.054,0.019-0.054-0.002c-0.027-0.019-0.027-0.052,0-0.068 c0.299-0.304,0.625-0.623,0.978-0.878c0.163-0.108,0.326-0.198,0.489-0.285c0.027-0.011,0.054-0.005,0.054,0.014 C-878.792-7781.84-878.792-7781.818-878.819-7781.807z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.152646,0.0114986,-0.0113387,0.154798,-2015.17,-43.9775)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    d: "M-887.76-7776.304c0.027,0.06,0.027,0.002,0.027,0.068 c-0.027,0.035-0.054,0.06-0.082,0.087c-0.272,0.28-0.598,0.492-0.897,0.742c-0.054,0.038-0.109,0.033-0.136-0.008 c-0.054-0.043-0.054-0.108,0-0.144c0.299-0.269,0.543-0.59,0.87-0.796c0.055-0.019,0.081-0.043,0.109-0.041 c0.054,0.003,0,0.003,0.054,0.036c0.027-0.014,0.054-0.011,0.054,0.005C-887.732-7776.34-887.732-7776.318-887.76-7776.304z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.152646,0.0114986,-0.0113387,0.154798,-2015.17,-43.9775)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    d: "M-882.406-7775.728c0.054-0.036,0.054-0.065,0.136-0.079 c0.163-0.027,0.326,0.057,0.489,0.109c0.299,0.098,0.543,0.252,0.815,0.451c0.055,0.03,0.081,0.087,0.054,0.133 c-0.054,0.043-0.109,0.057-0.136,0.03c-0.217-0.106-0.435-0.168-0.625-0.236c-0.217-0.07-0.435-0.082-0.625-0.198 c-0.082-0.041-0.082-0.082-0.136-0.139c0-0.005-0.027-0.024-0.027-0.043C-882.461-7775.72-882.433-7775.731-882.406-7775.728z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.152646,0.0114986,-0.0113387,0.154798,-2015.17,-43.9775)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    d: "M-879.308-7779.861c0.054,0.019,0.109,0.019,0.163,0.051 c0.19,0.109,0.326,0.286,0.462,0.443c0.19,0.199,0.353,0.416,0.489,0.655c0.027,0.03,0,0.073-0.027,0.092 c-0.027,0.021-0.054,0.011-0.082-0.019c-0.109-0.111-0.19-0.207-0.299-0.307c-0.217-0.239-0.516-0.424-0.706-0.698 c-0.027-0.054-0.027-0.106-0.054-0.166c-0.027-0.013-0.027-0.035,0-0.051C-879.363-7779.875-879.336-7779.875-879.308-7779.861 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.152646,0.0114986,-0.0113387,0.154798,-2015.17,-43.9775)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    d: "M-884.553-7779.649c0.136,0.065,0.272,0.133,0.408,0.212 c0.19,0.117,0.38,0.252,0.571,0.396c0.027,0.017,0.027,0.055,0,0.082c0,0.024-0.054,0.03-0.081,0.014l-0.978-0.546 c-0.027-0.019-0.054-0.071-0.027-0.114C-884.662-7779.649-884.607-7779.668-884.553-7779.649z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.152646,0.0114986,-0.0113387,0.154798,-2015.17,-43.9775)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    d: "M-882.135-7771.758c0.054,0,0.055-0.016,0.109,0.006 c0.054,0.021,0.082,0.07,0.109,0.114c0.136,0.136,0.245,0.293,0.353,0.44c0.054,0.098,0.136,0.196,0.218,0.28 c0.027,0.022,0.027,0.065,0.027,0.098c-0.027,0.033-0.082,0.041-0.109,0.019c-0.217-0.114-0.408-0.271-0.571-0.459 c-0.081-0.084-0.163-0.166-0.217-0.261c0-0.025-0.027-0.049-0.027-0.079c0-0.049,0-0.041,0.027-0.089 c-0.027-0.022-0.027-0.057,0-0.076C-882.189-7771.785-882.162-7771.783-882.135-7771.758z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.152646,0.0114986,-0.0113387,0.154798,-2015.17,-43.9775)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    d: "M-878.276-7772.701c0.027,0.055,0.027,0.038,0.027,0.095 c0,0.027-0.027,0.043-0.054,0.068c-0.109,0.161-0.272,0.307-0.408,0.454c-0.136,0.141-0.272,0.274-0.408,0.432 c-0.027,0.038-0.082,0.046-0.109,0.022c-0.054-0.024-0.054-0.076-0.027-0.114c0.163-0.277,0.381-0.527,0.598-0.764 c0.054-0.079,0.109-0.185,0.217-0.231c0.054-0.021,0.054-0.002,0.109-0.008c0.027-0.014,0.027-0.017,0.055-0.003 C-878.249-7772.739-878.249-7772.715-878.276-7772.701z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.152646,0.0114986,-0.0113387,0.154798,-2015.17,-43.9775)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    d: "M-881.836-7769.573c0.109,0.052,0.218,0.065,0.326,0.133 c0.245,0.144,0.435,0.367,0.625,0.565c0.027,0.033,0.054,0.087,0.027,0.123c-0.054,0.035-0.109,0.041-0.136,0.011 c-0.217-0.166-0.489-0.266-0.679-0.459c-0.109-0.092-0.163-0.204-0.217-0.318c-0.027-0.011-0.027-0.035,0-0.049 C-881.89-7769.584-881.863-7769.584-881.836-7769.573z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.152646,0.0114986,-0.0113387,0.154798,-2015.17,-43.9775)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    d: "M-884.798-7772.209c-0.027,0.049-0.027,0.09-0.054,0.133 c-0.272,0.302-0.652,0.468-0.951,0.731c-0.027,0.033-0.082,0.03-0.109-0.005c-0.027-0.033-0.027-0.087,0-0.117 c0.299-0.277,0.571-0.601,0.924-0.769c0.054-0.022,0.109-0.019,0.163-0.03c0-0.011,0.027-0.008,0.027,0.008 C-884.771-7772.245-884.771-7772.22-884.798-7772.209z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.152646,0.0114986,-0.0113387,0.154798,-2015.17,-43.9775)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    d: "M-889.662-7773.894c0,0.024,0,0.033,0,0.052 c-0.054,0.101-0.19,0.144-0.299,0.209c-0.272,0.199-0.571,0.386-0.843,0.593c-0.054,0.043-0.109,0.092-0.163,0.13 c-0.081,0.043-0.136,0.063-0.19,0.103c-0.054,0.038-0.108,0.041-0.163,0.003c-0.027-0.038-0.027-0.101,0-0.139 c0.054-0.073,0.081-0.144,0.136-0.209c0.081-0.087,0.19-0.152,0.272-0.223c0.326-0.226,0.679-0.402,1.006-0.617 c0.027-0.019,0.054-0.052,0.081-0.06c0.027-0.002,0.027,0.008,0.054,0.014c0.027-0.03,0.081-0.021,0.136,0.016 C-889.608-7773.981-889.635-7773.924-889.662-7773.894z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.152646,0.0114986,-0.0113387,0.154798,-2015.17,-43.9775)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    d: "M-890.477-7771.554c0.054-0.008,0.054-0.027,0.109-0.022 c0.217,0.027,0.408,0.204,0.625,0.299c0.027,0.016,0.054,0.065,0.055,0.106c-0.027,0.038-0.082,0.057-0.109,0.041 c-0.217-0.087-0.489-0.117-0.652-0.274c-0.027-0.027-0.027-0.049-0.054-0.084c-0.027-0.008-0.027-0.03-0.027-0.049 C-890.504-7771.557-890.504-7771.563-890.477-7771.554z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.152646,0.0114986,-0.0113387,0.154798,-2015.17,-43.9775)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    d: "M-878.031-7776.696c-0.054,0.106-0.081,0.204-0.163,0.293 c-0.163,0.18-0.38,0.286-0.598,0.427c-0.054,0.049-0.163,0.033-0.19-0.035c-0.054-0.068-0.054-0.163,0.027-0.212 c0.19-0.146,0.353-0.332,0.57-0.44c0.109-0.054,0.217-0.054,0.326-0.087c0-0.014,0.027-0.011,0.055,0.005 C-878.004-7776.729-878.004-7776.707-878.031-7776.696z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3.56326,-2.24498,-2.32311,-3.68728,2413.68,14923)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "rgb(124, 147, 154)"
    },
    d: "M1408.927,3075.122c0,0-0.604-1.778-1.049-2.43 c-0.387-0.568-7.745,4.174-7.745,4.174s0.183,0.441,0.281,0.494c0.097,0.052,3.75-1.219,4.718-1.232 c0.968-0.013,0.942,0.427,1.104,0.634c0,0,0.513-0.231,0.362-0.612l-0.547-0.63l1.012,0.138L1408.927,3075.122z"
  }), /*#__PURE__*/React.createElement("g", null, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000174562831755363679030000014683527185260359061_",
    d: "M1408.927,3075.122c0,0-0.604-1.778-1.049-2.43 c-0.387-0.568-7.745,4.174-7.745,4.174s0.183,0.441,0.281,0.494c0.097,0.052,3.75-1.219,4.718-1.232 c0.968-0.013,0.942,0.427,1.104,0.634c0,0,0.513-0.231,0.362-0.612l-0.547-0.63l1.012,0.138L1408.927,3075.122z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000071550528663505819440000005851464920660152511_"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1408.927,3075.122c0,0-0.604-1.778-1.049-2.43 c-0.387-0.568-7.745,4.174-7.745,4.174s0.183,0.441,0.281,0.494c0.097,0.052,3.75-1.219,4.718-1.232 c0.968-0.013,0.942,0.427,1.104,0.634c0,0,0.513-0.231,0.362-0.612l-0.547-0.63l1.012,0.138L1408.927,3075.122z",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000071550528663505819440000005851464920660152511_)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.04754,-4.996e-16,1.11022e-16,1.01231,-17.2896,3.20665)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FFFFFF"
    },
    d: "M1352.925,3036.826c0.127,0.037,0.023,0.073,0.153,0.051 c0.021-0.003,0.034-0.023,0.051-0.036c0.091-0.067,0.186-0.121,0.282-0.183c0.233-0.152,0.471-0.302,0.698-0.454 c0.327-0.225,0.668-0.431,1.008-0.642c0.226-0.14,0.45-0.284,0.678-0.421c0.383-0.23,0.77-0.452,1.158-0.663 c1.01-0.559,2.006-1.23,3.039-1.81c0.242-0.136,0.489-0.261,0.732-0.392c0.163-0.088,0.321-0.18,0.484-0.266 c0.164-0.087,0.332-0.16,0.494-0.251c0.114-0.064,0.209-0.138,0.321-0.206c0.067-0.02,0.105-0.091,0.085-0.158 c-0.02-0.067-0.091-0.105-0.158-0.085c-0.188,0.015-0.365,0.025-0.55,0.065c-0.413,0.09-0.807,0.254-1.196,0.431 c-1.254,0.571-2.404,1.409-3.592,2.047c-0.595,0.325-1.198,0.661-1.766,1.046c-0.382,0.258-0.744,0.541-1.096,0.83 c-0.269,0.237-0.579,0.449-0.816,0.723c-0.045,0.052-0.115,0.094-0.124,0.163c-0.016,0.126,0.011,0.047,0.06,0.165 c-0.013,0.016-0.011,0.039,0.004,0.052C1352.889,3036.844,1352.912,3036.842,1352.925,3036.826z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.04754,-4.996e-16,1.11022e-16,1.01231,-17.2896,3.20665)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FFFFFF"
    },
    d: "M1355.754,3035.191c-0.129,0.023-0.248,0.056-0.334,0.084 c-0.198,0.065-0.402,0.135-0.598,0.228c-0.287,0.136-0.56,0.307-0.819,0.496c-0.261,0.191-0.519,0.385-0.714,0.631 c-0.018,0.023-0.048,0.042-0.048,0.071c-0.001,0.134-0.023,0.048-0.001,0.037c0.009-0.005,0.027,0.005,0.059,0.054 c-0.015,0.014-0.015,0.037-0.001,0.052c0.014,0.015,0.037,0.015,0.052,0.001c0.129,0.086-0.027,0.073,0.044,0.067 c0.011-0.001,0.028-0.002,0.052-0.002c0.018,0,0.033-0.011,0.047-0.024c0.019,0.041,0.051,0.082,0.101,0.119 c-0.071,0.045-0.141,0.091-0.212,0.138c-0.202,0.136-0.151,0.315-0.149,0.336c0.006,0.043,0.152,0.404,0.483,0.263 c0.017-0.007,0.078-0.039,0.102-0.052l0.221-0.13l0.609-0.325l1.308-0.533c0.123,0.036,0.259,0.093,0.39,0.127 c0.088,0.023,0.175,0.04,0.259,0.038c0.074,0,0.142-0.019,0.208-0.047c0.104-0.045,0.195-0.129,0.286-0.192l0.58-0.298 l0.002-0.001l0.015-0.008l0.145-0.074c0.149-0.074,0.275-0.156,0.346-0.273c0.046-0.075,0.045-0.167,0.039-0.3 c-0.038-0.243-0.189-0.401-0.378-0.512c-0.202-0.118-0.477-0.143-0.691-0.162c-0.438-0.033-0.862,0.026-1.269,0.148 C1355.844,3035.161,1355.799,3035.176,1355.754,3035.191z M1353.804,3036.301l-0.044,0.036 c-0.025-0.04,0.02-0.051,0.066-0.053L1353.804,3036.301z M1356.542,3036.471c0.018,0.003,0.035,0.004,0.053,0.003l0.25-0.185 l0.13-0.08l-0.063-0.019c-0.031-0.008-0.063-0.016-0.094-0.024l-0.072-0.016c-0.03,0.053-0.069,0.103-0.113,0.15 C1356.62,3036.368,1356.59,3036.425,1356.542,3036.471z M1357.247,3036.287c0.004,0.01,0.032,0.009,0.042,0.012 L1357.247,3036.287z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.04754,-5.55112e-17,1.11022e-16,1.01231,-17.2896,3.20665)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#46937B"
    },
    d: "M1357.588,3034.847c-0.03,0.033-0.052,0.041-0.073,0.081 c-0.013,0.026-0.014,0.057-0.019,0.087c-0.039,0.229-0.065,0.478-0.057,0.719c0.003,0.084,0.008,0.168,0.028,0.247 c0.031,0.127,0.085,0.239,0.153,0.346c0.011,0.027,0.041,0.039,0.068,0.029c0.027-0.011,0.039-0.042,0.028-0.068 c-0.029-0.123-0.021-0.247-0.026-0.378c-0.01-0.297,0.023-0.613,0.026-0.902c0-0.026,0.003-0.051-0.005-0.075 c-0.013-0.039-0.03-0.046-0.052-0.08c0.002-0.02-0.013-0.038-0.033-0.04 C1357.608,3034.813,1357.59,3034.827,1357.588,3034.847z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.04754,-5.55112e-17,1.11022e-16,1.01231,-17.2896,3.20665)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#46937B"
    },
    d: "M1357.207,3034.761c-0.022,0.018-0.039,0.026-0.057,0.049 c-0.121,0.158-0.154,0.372-0.182,0.574c-0.046,0.333,0.001,0.68,0.076,0.992c0.011,0.05,0.06,0.082,0.11,0.071 c0.05-0.011,0.082-0.06,0.071-0.11c-0.036-0.198-0.048-0.408-0.048-0.619c0-0.218,0.019-0.435,0.061-0.644 c0.016-0.083,0.06-0.162,0.054-0.246c-0.002-0.02-0.01-0.019-0.018-0.038c0.008-0.019-0.001-0.04-0.019-0.048 C1357.236,3034.733,1357.215,3034.742,1357.207,3034.761z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.04754,-1.17961e-16,1.04083e-16,1.01231,-17.2896,3.20665)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#201F1D"
    },
    d: "M1360.909,3032.389c-0.17,0.031-0.336,0.087-0.497,0.156 c-0.242,0.104-0.475,0.238-0.698,0.364l-1.387,0.794c-1.042,0.592-2.082,1.195-3.135,1.773 c-0.702,0.385-1.412,0.757-2.126,1.116c-0.002,0.001-0.005,0-0.006-0.002c-0.001-0.002,0-0.005,0.002-0.007 c0.708-0.37,1.409-0.757,2.108-1.148c1.049-0.586,2.092-1.182,3.133-1.775l1.39-0.791c0.225-0.126,0.459-0.26,0.703-0.365 c0.165-0.07,0.333-0.126,0.507-0.157c0.011-0.002,0.022,0.005,0.024,0.017 C1360.928,3032.376,1360.92,3032.387,1360.909,3032.389z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.04754,-1.17961e-16,1.04083e-16,1.01231,-17.2896,3.20665)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#201F1D"
    },
    d: "M1358.228,3035.62c-0.202-0.23-0.433-0.332-0.684-0.365 c-0.247-0.033-0.516,0.001-0.798,0.052c-0.277,0.052-0.535,0.131-0.783,0.228c-0.377,0.148-0.733,0.338-1.103,0.541 c-0.282,0.154-0.56,0.307-0.828,0.476c-0.178,0.112-0.353,0.23-0.519,0.366c-0.005,0.004-0.013,0.004-0.017-0.001 c-0.004-0.005-0.004-0.013,0.001-0.017c0.161-0.145,0.33-0.275,0.506-0.392c0.265-0.176,0.546-0.325,0.829-0.481 c0.373-0.203,0.732-0.392,1.111-0.539c0.252-0.097,0.513-0.176,0.793-0.227c0.351-0.067,0.681-0.11,0.977-0.028 c0.199,0.055,0.382,0.167,0.545,0.361c0.008,0.009,0.007,0.022-0.002,0.029 C1358.248,3035.63,1358.235,3035.629,1358.228,3035.62z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.04754,-1.17961e-16,1.04083e-16,1.01231,-17.2896,3.20665)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#201F1D"
    },
    d: "M1361.353,3033.952c-0.276,0.059-0.558,0.153-0.838,0.263 c-0.416,0.163-0.828,0.361-1.203,0.55c-0.006,0.003-0.015,0.001-0.018-0.006c-0.003-0.007-0.001-0.014,0.006-0.018 c0.372-0.195,0.781-0.405,1.197-0.57c0.282-0.112,0.568-0.202,0.847-0.26c0.011-0.002,0.022,0.005,0.025,0.016 C1361.372,3033.939,1361.365,3033.95,1361.353,3033.952z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.04754,-1.17961e-16,1.04083e-16,1.01231,-17.2896,3.20665)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#201F1D"
    },
    d: "M1360.862,3033.896c-0.103,0.031-0.203,0.072-0.303,0.113 c-0.234,0.096-0.464,0.209-0.689,0.319c-0.01,0.005-0.022,0.001-0.027-0.009c-0.005-0.01-0.001-0.022,0.009-0.028 c0.191-0.101,0.381-0.213,0.582-0.299c0.135-0.058,0.275-0.103,0.418-0.136c0.011-0.003,0.023,0.004,0.025,0.015 C1360.879,3033.882,1360.873,3033.893,1360.862,3033.896z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.04754,-1.17961e-16,1.04083e-16,1.01231,-17.2896,3.20665)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#201F1D"
    },
    d: "M1357.921,3034.914c0.013,0,0.022-0.003,0.033,0.002 c0.021,0.01,0.028,0.034,0.044,0.051c0.009,0.006,0.012,0.018,0.007,0.027s-0.018,0.012-0.027,0.007 c-0.023-0.007-0.047-0.007-0.065-0.023c-0.009-0.008-0.008-0.018-0.014-0.029c-0.01-0.006-0.013-0.019-0.006-0.029 C1357.899,3034.911,1357.912,3034.908,1357.921,3034.914z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.04754,-1.17961e-16,1.04083e-16,1.01231,-17.2896,3.20665)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#201F1D"
    },
    d: "M1357.197,3034.928c0.007-0.017-0.006-0.013,0.01-0.022 c0.014-0.008,0.03,0.005,0.046,0.009c0.018,0,0.032,0.015,0.032,0.033c0,0.018-0.015,0.032-0.033,0.032 c-0.014,0.003-0.027,0.015-0.04,0.01c-0.016-0.007-0.002-0.006-0.011-0.021c-0.011,0.001-0.021-0.007-0.023-0.019 S1357.186,3034.929,1357.197,3034.928z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.04754,-1.17961e-16,1.04083e-16,1.01231,-17.2896,3.20665)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#201F1D"
    },
    d: "M1359.29,3035.462c-0.306-0.392-0.728-0.638-1.185-0.731 c-0.456-0.093-0.946-0.034-1.389,0.177c-0.006,0.003-0.014,0-0.017-0.006c-0.003-0.006-0.001-0.014,0.006-0.017 c0.449-0.214,0.944-0.271,1.406-0.179c0.465,0.092,0.897,0.336,1.213,0.731c0.007,0.009,0.006,0.022-0.004,0.029 C1359.311,3035.472,1359.297,3035.471,1359.29,3035.462z"
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.611804,-4.16683,-4.31185,0.633098,3678.67,13833.6)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "rgb(124, 147, 154)"
    },
    d: "M3273.417,310.808c0,0-0.604-1.778-1.049-2.43 c-0.387-0.568-7.745,4.174-7.745,4.174s0.183,0.441,0.281,0.494c0.097,0.052,3.75-1.219,4.718-1.232 c0.968-0.013,0.942,0.427,1.104,0.633c0,0,0.513-0.231,0.362-0.612l-0.547-0.63l1.012,0.138L3273.417,310.808z"
  }), /*#__PURE__*/React.createElement("g", null, _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000043437615433186364750000013111865894536439428_",
    d: "M3273.417,310.808c0,0-0.604-1.778-1.049-2.43 c-0.387-0.568-7.745,4.174-7.745,4.174s0.183,0.441,0.281,0.494c0.097,0.052,3.75-1.219,4.718-1.232 c0.968-0.013,0.942,0.427,1.104,0.633c0,0,0.513-0.231,0.362-0.612l-0.547-0.63l1.012,0.138L3273.417,310.808z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000013901952195814595580000000688371422536877210_"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3273.417,310.808c0,0-0.604-1.778-1.049-2.43 c-0.387-0.568-7.745,4.174-7.745,4.174s0.183,0.441,0.281,0.494c0.097,0.052,3.75-1.219,4.718-1.232 c0.968-0.013,0.942,0.427,1.104,0.633c0,0,0.513-0.231,0.362-0.612l-0.547-0.63l1.012,0.138L3273.417,310.808z",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000013901952195814595580000000688371422536877210_)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.04754,-4.996e-16,1.11022e-16,1.01231,-17.2896,3.20665)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FFFFFF"
    },
    d: "M3132.8,306.127c0.127,0.037,0.023,0.073,0.154,0.051 c0.021-0.004,0.034-0.023,0.051-0.036c0.09-0.067,0.186-0.121,0.281-0.183c0.233-0.152,0.471-0.302,0.698-0.454 c0.327-0.225,0.668-0.431,1.008-0.642c0.226-0.14,0.45-0.284,0.678-0.421c0.383-0.23,0.77-0.452,1.158-0.663 c1.01-0.558,2.007-1.23,3.039-1.81c0.242-0.136,0.489-0.261,0.732-0.392c0.163-0.088,0.321-0.18,0.484-0.266 c0.164-0.087,0.332-0.16,0.493-0.251c0.115-0.064,0.209-0.138,0.321-0.206c0.067-0.02,0.105-0.091,0.084-0.158 s-0.091-0.105-0.158-0.085c-0.188,0.015-0.365,0.025-0.55,0.065c-0.413,0.09-0.807,0.254-1.196,0.431 c-1.254,0.571-2.404,1.409-3.593,2.047c-0.595,0.326-1.198,0.661-1.766,1.046c-0.382,0.258-0.744,0.541-1.096,0.83 c-0.269,0.237-0.579,0.449-0.816,0.723c-0.045,0.052-0.115,0.094-0.124,0.163c-0.016,0.126,0.011,0.048,0.06,0.165 c-0.013,0.016-0.011,0.039,0.004,0.052C3132.764,306.144,3132.787,306.142,3132.8,306.127z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.04754,-4.996e-16,1.11022e-16,1.01231,-17.2896,3.20665)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FFFFFF"
    },
    d: "M3135.629,304.492c-0.129,0.023-0.248,0.056-0.334,0.084 c-0.198,0.065-0.402,0.134-0.598,0.228c-0.288,0.136-0.56,0.307-0.819,0.496c-0.261,0.191-0.519,0.385-0.714,0.631 c-0.018,0.023-0.048,0.042-0.048,0.071c-0.001,0.134-0.023,0.048-0.001,0.037c0.009-0.005,0.027,0.005,0.059,0.054 c-0.015,0.014-0.015,0.037-0.001,0.052c0.014,0.015,0.037,0.015,0.052,0.001c0.129,0.086-0.027,0.073,0.044,0.067 c0.011-0.001,0.028-0.002,0.052-0.002c0.018,0,0.033-0.011,0.048-0.024c0.019,0.041,0.051,0.082,0.101,0.119 c-0.071,0.045-0.141,0.091-0.212,0.138c-0.202,0.136-0.151,0.315-0.149,0.336c0.006,0.043,0.152,0.404,0.483,0.263 c0.017-0.007,0.078-0.039,0.102-0.052l0.221-0.13l0.609-0.325l1.308-0.533c0.123,0.036,0.259,0.093,0.39,0.127 c0.088,0.023,0.175,0.04,0.259,0.038c0.074,0.001,0.142-0.019,0.208-0.047c0.104-0.045,0.196-0.129,0.286-0.192l0.58-0.298 l0.002-0.001l0.015-0.008l0.145-0.074c0.149-0.074,0.275-0.156,0.347-0.273c0.046-0.075,0.044-0.167,0.039-0.3 c-0.038-0.243-0.189-0.401-0.378-0.512c-0.202-0.118-0.477-0.143-0.691-0.162c-0.438-0.033-0.862,0.026-1.269,0.148 C3135.719,304.462,3135.674,304.477,3135.629,304.492z M3133.679,305.602l-0.044,0.036c-0.025-0.04,0.02-0.051,0.066-0.053 L3133.679,305.602z M3136.417,305.772c0.018,0.003,0.035,0.004,0.053,0.003l0.25-0.185l0.13-0.08l-0.063-0.019 c-0.032-0.008-0.063-0.016-0.094-0.024l-0.072-0.016c-0.03,0.053-0.069,0.103-0.113,0.15 C3136.495,305.668,3136.466,305.726,3136.417,305.772z M3137.122,305.587c0.004,0.01,0.032,0.009,0.042,0.012 L3137.122,305.587z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.04754,-5.55112e-17,1.11022e-16,1.01231,-17.2896,3.20665)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#46937B"
    },
    d: "M3137.463,304.148c-0.03,0.033-0.052,0.04-0.073,0.081 c-0.013,0.026-0.013,0.057-0.018,0.087c-0.039,0.229-0.066,0.478-0.057,0.72c0.003,0.084,0.008,0.168,0.028,0.247 c0.031,0.127,0.085,0.239,0.153,0.346c0.011,0.027,0.042,0.039,0.068,0.029c0.027-0.011,0.039-0.042,0.029-0.068 c-0.029-0.123-0.021-0.247-0.026-0.378c-0.01-0.297,0.022-0.613,0.026-0.902c0-0.026,0.003-0.051-0.005-0.075 c-0.013-0.039-0.03-0.046-0.052-0.079c0.002-0.02-0.013-0.038-0.033-0.04C3137.483,304.113,3137.465,304.128,3137.463,304.148 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.04754,-5.55112e-17,1.11022e-16,1.01231,-17.2896,3.20665)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#46937B"
    },
    d: "M3137.082,304.061c-0.022,0.018-0.039,0.026-0.056,0.049 c-0.121,0.158-0.154,0.372-0.182,0.574c-0.046,0.333,0.001,0.68,0.076,0.992c0.011,0.05,0.06,0.082,0.11,0.071 c0.05-0.011,0.082-0.06,0.071-0.11c-0.036-0.198-0.048-0.408-0.048-0.619c0-0.217,0.019-0.435,0.061-0.644 c0.016-0.083,0.06-0.162,0.054-0.246c-0.002-0.02-0.01-0.019-0.018-0.038c0.008-0.019-0.001-0.04-0.019-0.048 C3137.111,304.034,3137.09,304.043,3137.082,304.061z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.04754,-1.17961e-16,1.04083e-16,1.01231,-17.2896,3.20665)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#201F1D"
    },
    d: "M3140.784,301.689c-0.17,0.031-0.336,0.087-0.497,0.156 c-0.242,0.104-0.475,0.238-0.698,0.364l-1.387,0.794c-1.042,0.592-2.082,1.195-3.135,1.773 c-0.702,0.385-1.412,0.757-2.126,1.116c-0.002,0.001-0.005,0-0.007-0.002c-0.001-0.002,0-0.005,0.002-0.007 c0.708-0.37,1.409-0.757,2.108-1.148c1.049-0.586,2.092-1.182,3.133-1.775l1.39-0.79c0.225-0.126,0.459-0.26,0.704-0.364 c0.165-0.07,0.333-0.126,0.507-0.157c0.011-0.002,0.022,0.005,0.024,0.017 C3140.803,301.677,3140.796,301.687,3140.784,301.689z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.04754,-1.17961e-16,1.04083e-16,1.01231,-17.2896,3.20665)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#201F1D"
    },
    d: "M3138.103,304.921c-0.202-0.23-0.433-0.332-0.684-0.366 c-0.247-0.033-0.515,0.001-0.798,0.051c-0.277,0.052-0.534,0.131-0.783,0.228c-0.376,0.148-0.732,0.337-1.103,0.541 c-0.282,0.154-0.56,0.307-0.828,0.476c-0.178,0.112-0.353,0.23-0.519,0.366c-0.005,0.004-0.013,0.004-0.018-0.001 c-0.004-0.005-0.004-0.013,0.001-0.017c0.161-0.145,0.33-0.275,0.506-0.392c0.265-0.176,0.546-0.326,0.83-0.481 c0.373-0.203,0.732-0.392,1.111-0.539c0.252-0.098,0.513-0.176,0.793-0.227c0.351-0.067,0.681-0.11,0.977-0.028 c0.199,0.055,0.382,0.167,0.545,0.361c0.008,0.009,0.007,0.022-0.002,0.029S3138.11,304.93,3138.103,304.921z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.04754,-1.17961e-16,1.04083e-16,1.01231,-17.2896,3.20665)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#201F1D"
    },
    d: "M3141.229,303.253c-0.276,0.059-0.558,0.153-0.838,0.263 c-0.416,0.163-0.828,0.361-1.203,0.55c-0.006,0.003-0.015,0.001-0.018-0.006c-0.003-0.007-0.001-0.014,0.006-0.018 c0.372-0.195,0.781-0.405,1.197-0.57c0.282-0.112,0.569-0.202,0.847-0.26c0.011-0.002,0.022,0.005,0.025,0.016 C3141.247,303.24,3141.24,303.25,3141.229,303.253z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.04754,-1.17961e-16,1.04083e-16,1.01231,-17.2896,3.20665)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#201F1D"
    },
    d: "M3140.737,303.197c-0.103,0.031-0.203,0.072-0.303,0.113 c-0.234,0.096-0.464,0.21-0.689,0.319c-0.01,0.005-0.022,0.001-0.027-0.009c-0.005-0.01-0.001-0.022,0.009-0.027 c0.191-0.101,0.381-0.213,0.582-0.299c0.135-0.058,0.275-0.102,0.417-0.136c0.011-0.003,0.023,0.004,0.025,0.015 C3140.755,303.183,3140.748,303.194,3140.737,303.197z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.04754,-1.17961e-16,1.04083e-16,1.01231,-17.2896,3.20665)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#201F1D"
    },
    d: "M3137.797,304.215c0.013,0,0.022-0.004,0.033,0.002 c0.021,0.01,0.028,0.034,0.044,0.051c0.009,0.006,0.012,0.018,0.006,0.027c-0.006,0.009-0.018,0.012-0.027,0.007 c-0.023-0.007-0.047-0.007-0.065-0.023c-0.009-0.008-0.008-0.018-0.014-0.029c-0.01-0.006-0.012-0.019-0.006-0.029 C3137.774,304.212,3137.787,304.209,3137.797,304.215z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.04754,-1.17961e-16,1.04083e-16,1.01231,-17.2896,3.20665)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#201F1D"
    },
    d: "M3137.072,304.229c0.007-0.017-0.006-0.014,0.01-0.022 c0.014-0.008,0.03,0.005,0.046,0.009c0.018,0.001,0.032,0.015,0.032,0.033c-0.001,0.018-0.015,0.032-0.033,0.032 c-0.014,0.003-0.027,0.015-0.04,0.01c-0.016-0.007-0.002-0.006-0.011-0.021c-0.011,0.001-0.021-0.007-0.023-0.019 C3137.052,304.24,3137.061,304.23,3137.072,304.229z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.04754,-1.17961e-16,1.04083e-16,1.01231,-17.2896,3.20665)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#201F1D"
    },
    d: "M3139.166,304.762c-0.306-0.392-0.728-0.638-1.185-0.731 c-0.456-0.093-0.946-0.034-1.389,0.177c-0.007,0.003-0.014,0-0.017-0.006c-0.003-0.007,0-0.014,0.006-0.017 c0.449-0.214,0.944-0.271,1.406-0.179c0.465,0.092,0.897,0.336,1.213,0.731c0.007,0.009,0.006,0.022-0.004,0.029 C3139.186,304.773,3139.173,304.771,3139.166,304.762z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.374723,0,0,0.374723,-8669.25,11673.7)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "rgb(124, 147, 154)"
    },
    d: "M23847.428-30359.479l81.496-7.027 c0,0,32.473,40.75,30.354,73.096c-2.119,32.35-3.859,108.174,8.969,116.973c27.363,18.744,77.527,44.91,44.076,79.514 l-6.549,14.865c0,0-11.93,17.68-30.898,9.637c-12.391-5.256-42.5-38.893-42.5-38.893s1.195,22.783-1.086,37.553 c-2.475,15.83-19.051,23.229-19.051,23.229l-32.609,0.502c0,0-35.434-3.943-35.488-29.965 c-0.055-26.023-6.195-114.822-8.805-165.549C23831.885-30312.27,23847.428-30359.479,23847.428-30359.479z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.374723,0,0,0.374723,-8669.25,11673.7)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#201F1D"
    },
    d: "M23933.299-30109.666c-0.137-2.25-0.271-4.488-0.57-6.719 c-1.168-8.887-3.342-17.602-4.484-26.479c-0.354-2.754-0.652-5.52-0.787-8.305c-0.572-10.336-1.225-34.352-1.496-55.658 c-0.189-16.523-0.135-31.414,0.545-36.982c2.01-17.033,14.32-34.855,17.662-55.693c1.277-7.943,1.195-16.307-1.086-25.172 c-0.055-0.168-0.217-0.275-0.381-0.234s-0.271,0.211-0.244,0.379c1.902,8.791,1.549,16.979,0.08,24.748 c-3.857,20.809-16.031,38.641-18.178,55.709c-0.707,5.615-0.789,20.623-0.49,37.277c0.354,21.336,1.332,45.379,1.984,55.721 c0.271,4.234,0.842,8.42,1.549,12.58c1.141,6.764,2.527,13.488,3.857,20.225c0.572,2.879,1.225,5.74,1.686,8.645 c0.027,0.098,0.109,0.17,0.189,0.156C23933.244-30109.48,23933.326-30109.566,23933.299-30109.666z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.374723,0,0,0.374723,-8669.25,11673.7)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#201F1D"
    },
    d: "M23964.658-30180.531c-0.57,0.156-1.113,0.225-1.686,0.469 c-4.619,2.035-8.424,5.693-12.119,9.201c-2.854,2.744-5.57,5.701-7.664,9.041c-0.924,1.438-1.656,2.965-2.336,4.518 c-0.082,0.127-0.027,0.283,0.082,0.354c0.135,0.068,0.299,0.021,0.352-0.105c0.926-1.404,1.93-2.715,2.936-4.051 c2.311-3.09,4.783-6.072,7.609-8.746c3.613-3.438,8.016-5.951,11.82-9.111c0.463-0.383,0.789-0.83,1.195-1.264 c0.082-0.051,0.109-0.16,0.055-0.242C23964.848-30180.553,23964.74-30180.582,23964.658-30180.531z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.374723,0,0,0.374723,-8669.25,11673.7)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#201F1D"
    },
    d: "M23964.74-30180.555c-0.354-0.223-0.436-0.422-0.844-0.529 c-0.189-0.047-0.379,0.01-0.543,0.023c-3.805,0.283-7.988,1.215-11.984,2.521c-4.51,1.471-8.803,3.521-12.201,5.91 c-0.162,0.115-0.217,0.346-0.107,0.52c0.107,0.172,0.352,0.217,0.516,0.104c2.799-1.736,6.168-3.16,9.674-4.35 c4.619-1.559,9.564-2.588,13.969-3.096c0.271-0.029,0.57,0.006,0.787-0.102c0.381-0.168,0.463-0.389,0.762-0.652 c0.107-0.004,0.162-0.09,0.162-0.188S23964.848-30180.563,23964.74-30180.555z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.374723,0,0,0.374723,-8669.25,11673.7)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#201F1D"
    },
    d: "M23872.348-30156.248c0.543-0.016,1.031,0.02,1.549-0.035 c4.51-0.482,8.939-1.393,13.479-1.723c7.555-0.549,15.162-0.559,22.717-0.582c0.191,0.004,0.381-0.17,0.381-0.383 c0-0.211-0.164-0.385-0.381-0.385c-7.582-0.072-15.217-0.229-22.799,0.309c-4.566,0.32-9.213,0.514-13.588,1.855 c-0.488,0.152-0.951,0.393-1.439,0.6c-0.082,0.021-0.137,0.115-0.109,0.211 C23872.156-30156.285,23872.266-30156.227,23872.348-30156.248z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.374723,0,0,0.374723,-8669.25,11673.7)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#201F1D"
    },
    d: "M23882.646-30168.408c1.141,0.092,2.229,0.227,3.369,0.264 c4.43,0.146,8.887-0.104,13.344,0.15c0.217,0.014,0.406-0.162,0.406-0.387c0.027-0.225-0.135-0.418-0.381-0.432 c-3.342-0.217-6.684-0.271-10.055-0.264c-1.33,0.002-2.662-0.047-3.994,0.033c-0.896,0.051-1.793,0.189-2.689,0.281 c-0.082,0-0.164,0.08-0.164,0.178S23882.564-30168.408,23882.646-30168.408z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.374723,0,0,0.374723,-8669.25,11673.7)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#201F1D"
    },
    d: "M23854.25-30355.727 c-4.051,9.527-7.121,19.256-9.213,29.162c-3.18,14.945-4.295,30.252-4.32,45.676c-0.027,38.234,7.092,77.277,9.729,114.17 c2.5,35.172-1.305,59.986-0.68,78.645c0.434,12.934,2.988,22.924,11.033,31.336c0.135,0.145,0.352,0.15,0.516,0.014 c0.135-0.135,0.135-0.361,0-0.506c-7.799-8.34-10.137-18.18-10.463-30.877c-0.516-18.672,3.234-43.496,0.762-78.691 c-2.582-36.871-9.592-75.885-9.592-114.09c0-15.34,1.195-30.535,4.129-45.445c1.957-9.893,4.646-19.672,8.424-29.26 c0.027-0.088,0-0.191-0.107-0.23C23854.385-30355.859,23854.275-30355.816,23854.25-30355.727z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.374723,0,0,0.374723,-8669.25,11673.7)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#201F1D"
    },
    d: "M23929.168-30130.939c1.494,2.641,3.451,5.932,5.924,9.52 c7.146,10.461,18.1,23.668,30.328,32.871c11.113,8.373,23.314,13.354,34.836,9.957c0.137-0.037,0.219-0.18,0.191-0.313 c-0.055-0.135-0.191-0.211-0.326-0.174c-11.359,3.215-23.262-1.916-34.158-10.201c-12.094-9.203-22.826-22.402-30.191-32.631 c-2.527-3.516-4.701-6.648-6.305-9.209c-0.053-0.084-0.162-0.111-0.244-0.063 C23929.141-30131.131,23929.115-30131.021,23929.168-30130.939z"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.374723,0,0,0.374723,-8669.25,11673.7)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FB624D"
    },
    d: "M23891.668-30497.818c0,0-28.424-8.441-56.332,27.732 s-35.191,39.652-35.191,39.652s-22.799-15.113-44.893-2.078l-12.824,18.695c0,0-4.377,10.459,4.266,20.715 c12.473,14.785,45.082,23.344,60.326,22.918c20.027-0.557,35.381-16.07,35.381-16.07s-9.811,26.115,4.756,32.463l89.893-2.846 c11.713-1.252,7.744-13.547,7.744-13.547s27.201,13.234,48.344,2.541c19.049-9.639,24.646-36.23,8.641-59.396 c-10.842-15.719-40.109-63.934-60.979-67.371c-15.109-2.488-17.691-4.086-17.691-4.086S23911.26-30486.492,23891.668-30497.818z"
  }), /*#__PURE__*/React.createElement("g", null, _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000118377566273524527720000001527153969725958300_",
    d: "M23891.668-30497.818c0,0-28.424-8.441-56.332,27.732 s-35.191,39.652-35.191,39.652s-22.799-15.113-44.893-2.078l-12.824,18.695c0,0-4.377,10.459,4.266,20.715 c12.473,14.785,45.082,23.344,60.326,22.918c20.027-0.557,35.381-16.07,35.381-16.07s-9.811,26.115,4.756,32.463l89.893-2.846 c11.713-1.252,7.744-13.547,7.744-13.547s27.201,13.234,48.344,2.541c19.049-9.639,24.646-36.23,8.641-59.396 c-10.842-15.719-40.109-63.934-60.979-67.371c-15.109-2.488-17.691-4.086-17.691-4.086S23911.26-30486.492,23891.668-30497.818 z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000089562139166260641830000001416728273847934893_"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23891.668-30497.818c0,0-28.424-8.441-56.332,27.732 s-35.191,39.652-35.191,39.652s-22.799-15.113-44.893-2.078l-12.824,18.695c0,0-4.377,10.459,4.266,20.715 c12.473,14.785,45.082,23.344,60.326,22.918c20.027-0.557,35.381-16.07,35.381-16.07s-9.811,26.115,4.756,32.463l89.893-2.846 c11.713-1.252,7.744-13.547,7.744-13.547s27.201,13.234,48.344,2.541c19.049-9.639,24.646-36.23,8.641-59.396 c-10.842-15.719-40.109-63.934-60.979-67.371c-15.109-2.488-17.691-4.086-17.691-4.086S23911.26-30486.492,23891.668-30497.818 z",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000089562139166260641830000001416728273847934893_)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.66864,0,0,2.66864,23135.1,-31153)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.21698,0,0,0.21698,-1344.55,12352.2)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#C23521"
    },
    d: "M7286.012-55671.844 c0.271,2.508,1.793,4.371,3.505,5.418c3.533,2.16,8.913,1,11.087-4.715c1.93-5.117-0.625-8.602-4.267-9.695 c-2.636-0.789-6.386-0.488-8.777,2.219c-1.141,1.297-1.929,2.906-2.174,5.063 C7285.114-55672.902,7285.386-55672.148,7286.012-55671.844z M7290.386-55674.332c-0.163,1.816,0.462,3.039,1.522,3.566 c1.305,0.633,2.908-0.176,3.56-2.188c0.516-1.582-0.517-2.438-1.767-2.445c-1.06-0.012-2.201,0.316-3.288,1.055 L7290.386-55674.332z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.21698,0,0,0.21698,-1365.84,12376.8)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#C23521"
    },
    d: "M7357.468-55754.406 c0.271,2.508,1.793,4.367,3.505,5.418c3.533,2.16,8.913,1,11.086-4.719c1.93-5.113-0.625-8.602-4.266-9.691 c-2.636-0.789-6.386-0.492-8.778,2.215c-1.141,1.301-1.929,2.906-2.174,5.063 C7356.57-55755.465,7356.842-55754.715,7357.468-55754.406z M7361.842-55756.898c-0.163,1.82,0.462,3.039,1.522,3.566 c1.305,0.633,2.907-0.172,3.56-2.184c0.516-1.586-0.517-2.441-1.767-2.449c-1.06-0.008-2.201,0.316-3.288,1.059 L7361.842-55756.898z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.21698,0,0,0.21698,-1329.2,12380.9)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#C23521"
    },
    d: "M7234.491-55768.172 c0.272,2.508,1.794,4.371,3.505,5.418c3.533,2.164,8.914,1,11.087-4.715c1.93-5.113-0.625-8.602-4.267-9.695 c-2.636-0.785-6.386-0.488-8.777,2.219c-1.141,1.301-1.929,2.906-2.174,5.063 C7233.594-55769.227,7233.866-55768.477,7234.491-55768.172z M7238.866-55770.66c-0.163,1.82,0.462,3.039,1.522,3.566 c1.305,0.633,2.908-0.176,3.56-2.188c0.516-1.582-0.516-2.438-1.766-2.445c-1.06-0.008-2.201,0.316-3.288,1.055 L7238.866-55770.66z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.21698,0,0,0.21698,-1319.77,12411.4)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#C23521"
    },
    d: "M7202.842-55870.539 c0.271,2.508,1.793,4.371,3.505,5.418c3.532,2.16,8.913,1,11.086-4.715c1.93-5.117-0.625-8.602-4.266-9.695 c-2.636-0.789-6.386-0.488-8.778,2.219c-1.141,1.297-1.929,2.902-2.174,5.063 C7201.944-55871.598,7202.216-55870.848,7202.842-55870.539z M7207.216-55873.027c-0.163,1.816,0.462,3.039,1.522,3.566 c1.305,0.633,2.907-0.176,3.56-2.188c0.516-1.582-0.517-2.438-1.767-2.445c-1.06-0.012-2.201,0.316-3.288,1.055 L7207.216-55873.027z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.21698,0,0,0.21698,-1297.78,12364.5)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#C23521"
    },
    d: "M7129.036-55713.125 c0.272,2.508,1.793,4.367,3.505,5.418c3.533,2.16,8.914,1,11.087-4.719c1.929-5.113-0.625-8.598-4.266-9.691 c-2.636-0.789-6.386-0.488-8.778,2.219c-1.141,1.297-1.929,2.902-2.174,5.063 C7128.139-55714.184,7128.411-55713.434,7129.036-55713.125z M7133.411-55715.613c-0.163,1.816,0.462,3.035,1.521,3.563 c1.305,0.633,2.908-0.172,3.561-2.184c0.516-1.586-0.517-2.441-1.767-2.449c-1.06-0.008-2.201,0.32-3.288,1.059 L7133.411-55715.613z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.21698,0,0,0.21698,-1277.12,12407.3)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#C23521"
    },
    d: "M7059.694-55856.777 c0.272,2.508,1.793,4.371,3.505,5.422c3.533,2.16,8.913,1,11.087-4.719c1.93-5.113-0.625-8.602-4.266-9.695 c-2.636-0.785-6.386-0.488-8.777,2.219c-1.141,1.301-1.929,2.906-2.174,5.063 C7058.797-55857.832,7059.069-55857.082,7059.694-55856.777z M7064.069-55859.266c-0.163,1.82,0.462,3.039,1.522,3.566 c1.304,0.633,2.907-0.176,3.56-2.184c0.516-1.586-0.516-2.441-1.766-2.449c-1.06-0.008-2.202,0.316-3.288,1.055 L7064.069-55859.266z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.21698,0,0,0.21698,-1243.35,12385)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#C23521"
    },
    d: "M6946.351-55781.93c0.272,2.508,1.793,4.371,3.505,5.418 c3.533,2.16,8.913,1,11.087-4.719c1.929-5.113-0.625-8.598-4.267-9.691c-2.636-0.789-6.386-0.488-8.778,2.219 c-1.141,1.297-1.929,2.902-2.174,5.063C6945.454-55782.988,6945.725-55782.238,6946.351-55781.93z M6950.726-55784.418 c-0.163,1.816,0.462,3.035,1.522,3.563c1.304,0.633,2.908-0.172,3.56-2.184c0.516-1.586-0.517-2.441-1.767-2.449 c-1.06-0.008-2.201,0.32-3.288,1.059L6950.726-55784.418z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.21698,0,0,0.21698,-1262.97,12368.6)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#C23521"
    },
    d: "M7012.202-55726.887 c0.272,2.512,1.793,4.371,3.505,5.422c3.533,2.16,8.914,1,11.087-4.719c1.929-5.113-0.625-8.602-4.267-9.695 c-2.636-0.785-6.386-0.488-8.777,2.219c-1.141,1.301-1.929,2.906-2.174,5.063 C7011.305-55727.941,7011.576-55727.191,7012.202-55726.887z M7016.577-55729.375c-0.163,1.82,0.462,3.039,1.522,3.566 c1.304,0.633,2.908-0.176,3.56-2.184c0.516-1.586-0.517-2.441-1.766-2.449c-1.06-0.008-2.201,0.316-3.288,1.055 L7016.577-55729.375z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.21698,0,0,0.21698,-1227.33,12337.4)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#C23521"
    },
    d: "M6892.582-55622.172 c0.272,2.512,1.793,4.371,3.505,5.422c3.532,2.16,8.913,1,11.087-4.719c1.93-5.113-0.625-8.602-4.266-9.695 c-2.636-0.785-6.386-0.488-8.777,2.219c-1.141,1.301-1.929,2.906-2.174,5.063 C6891.685-55623.227,6891.957-55622.477,6892.582-55622.172z M6896.957-55624.66c-0.163,1.82,0.462,3.039,1.521,3.566 c1.305,0.633,2.908-0.176,3.56-2.184c0.516-1.586-0.516-2.441-1.766-2.449c-1.06-0.008-2.202,0.316-3.288,1.055 L6896.957-55624.66z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.21698,0,0,0.21698,-1238.64,12302.5)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#C23521"
    },
    d: "M6930.542-55505.031 c0.272,2.508,1.793,4.367,3.505,5.418c3.532,2.16,8.913,1,11.087-4.719c1.929-5.113-0.625-8.602-4.266-9.691 c-2.636-0.789-6.386-0.492-8.778,2.215c-1.141,1.301-1.929,2.906-2.174,5.063 C6929.646-55506.09,6929.917-55505.34,6930.542-55505.031z M6934.917-55507.523c-0.163,1.82,0.462,3.039,1.521,3.566 c1.305,0.633,2.908-0.172,3.56-2.184c0.516-1.586-0.517-2.441-1.767-2.449c-1.06-0.008-2.201,0.316-3.288,1.059 L6934.917-55507.523z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.21698,0,0,0.21698,-1201.61,12271.9)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#C23521"
    },
    d: "M6806.257-55402.332 c0.271,2.508,1.793,4.371,3.505,5.422c3.533,2.16,8.913,1,11.087-4.719c1.93-5.113-0.625-8.602-4.266-9.695 c-2.636-0.785-6.387-0.488-8.778,2.219c-1.141,1.301-1.929,2.906-2.174,5.063 C6805.36-55403.387,6805.632-55402.637,6806.257-55402.332z M6810.632-55404.82c-0.163,1.816,0.462,3.039,1.522,3.566 c1.305,0.633,2.908-0.176,3.56-2.184c0.517-1.586-0.517-2.441-1.766-2.449c-1.06-0.008-2.201,0.316-3.289,1.055 L6810.632-55404.82z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.21698,0,0,0.21698,-1201.61,12310.8)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#C23521"
    },
    d: "M6806.257-55532.891 c0.271,2.508,1.793,4.371,3.505,5.418c3.533,2.16,8.913,1,11.087-4.715c1.93-5.117-0.625-8.602-4.266-9.695 c-2.636-0.785-6.387-0.488-8.778,2.219c-1.141,1.297-1.929,2.906-2.174,5.063 C6805.36-55533.945,6805.632-55533.195,6806.257-55532.891z M6810.632-55535.379c-0.163,1.816,0.462,3.039,1.522,3.566 c1.305,0.633,2.908-0.176,3.56-2.188c0.517-1.582-0.517-2.438-1.766-2.445c-1.06-0.012-2.201,0.316-3.289,1.055 L6810.632-55535.379z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.21698,0,0,0.21698,-1164.6,12280.1)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#C23521"
    },
    d: "M6682.04-55429.852c0.272,2.512,1.793,4.371,3.505,5.422 c3.533,2.16,8.913,1,11.087-4.719c1.929-5.113-0.625-8.602-4.267-9.691c-2.636-0.789-6.386-0.492-8.778,2.215 c-1.141,1.301-1.929,2.906-2.174,5.063C6681.143-55430.906,6681.414-55430.156,6682.04-55429.852z M6686.415-55432.34 c-0.163,1.82,0.462,3.039,1.521,3.566c1.305,0.633,2.908-0.176,3.56-2.184c0.516-1.586-0.517-2.441-1.767-2.449 c-1.06-0.008-2.201,0.316-3.288,1.055L6686.415-55432.34z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.21698,0,0,0.21698,-1164.6,12319)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#C23521"
    },
    d: "M6682.04-55560.414c0.272,2.508,1.793,4.371,3.505,5.422 c3.533,2.16,8.913,1,11.087-4.719c1.929-5.113-0.625-8.602-4.267-9.695c-2.636-0.785-6.386-0.488-8.778,2.219 c-1.141,1.301-1.929,2.906-2.174,5.063C6681.143-55561.469,6681.414-55560.719,6682.04-55560.414z M6686.415-55562.902 c-0.163,1.82,0.462,3.039,1.521,3.566c1.305,0.633,2.908-0.176,3.56-2.184c0.516-1.586-0.517-2.441-1.767-2.449 c-1.06-0.008-2.201,0.316-3.288,1.055L6686.415-55562.902z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.21698,0,0,0.21698,-1192.17,12349.9)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#C23521"
    },
    d: "M6774.574-55664.125 c0.272,2.508,1.793,4.371,3.505,5.418c3.533,2.16,8.913,1,11.087-4.715c1.929-5.117-0.625-8.602-4.267-9.695 c-2.636-0.789-6.386-0.488-8.777,2.219c-1.141,1.297-1.93,2.906-2.174,5.063 C6773.677-55665.18,6773.949-55664.43,6774.574-55664.125z M6778.949-55666.613c-0.163,1.816,0.462,3.039,1.522,3.566 c1.304,0.633,2.908-0.176,3.56-2.188c0.516-1.582-0.516-2.438-1.767-2.449c-1.06-0.008-2.201,0.32-3.288,1.059 L6778.949-55666.613z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.21698,0,0,0.21698,-1206.32,12386.8)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#C23521"
    },
    d: "M6822.065-55787.973 c0.271,2.508,1.793,4.371,3.506,5.422c3.532,2.16,8.913,1,11.086-4.719c1.93-5.113-0.625-8.602-4.266-9.695 c-2.636-0.785-6.386-0.488-8.778,2.219c-1.141,1.301-1.929,2.906-2.174,5.063 C6821.168-55789.027,6821.44-55788.277,6822.065-55787.973z M6826.44-55790.461c-0.163,1.82,0.462,3.039,1.521,3.566 c1.305,0.633,2.908-0.176,3.561-2.184c0.516-1.586-0.517-2.441-1.767-2.449c-1.06-0.008-2.201,0.316-3.289,1.055 L6826.44-55790.461z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.21698,0,0,0.21698,-1227.72,12423.3)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#C23521"
    },
    d: "M6893.891-55910.477 c0.271,2.508,1.793,4.371,3.505,5.418c3.533,2.16,8.913,1,11.087-4.719c1.93-5.113-0.625-8.598-4.266-9.691 c-2.636-0.789-6.386-0.488-8.777,2.219c-1.141,1.297-1.929,2.902-2.174,5.063 C6892.994-55911.535,6893.266-55910.785,6893.891-55910.477z M6898.266-55912.965c-0.163,1.816,0.462,3.035,1.521,3.563 c1.305,0.633,2.908-0.172,3.561-2.184c0.516-1.586-0.517-2.441-1.767-2.449c-1.06-0.008-2.201,0.32-3.289,1.059 L6898.266-55912.965z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.21698,0,0,0.21698,-1182.74,12438.2)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#C23521"
    },
    d: "M6742.923-55960.488 c0.271,2.508,1.793,4.371,3.505,5.418c3.533,2.16,8.913,1,11.087-4.715c1.93-5.117-0.625-8.602-4.266-9.695 c-2.636-0.789-6.386-0.488-8.778,2.219c-1.141,1.297-1.929,2.906-2.174,5.063 C6742.026-55961.543,6742.298-55960.793,6742.923-55960.488z M6747.298-55962.977c-0.163,1.816,0.462,3.039,1.521,3.566 c1.305,0.633,2.908-0.176,3.561-2.188c0.516-1.582-0.517-2.438-1.767-2.449c-1.06-0.008-2.201,0.32-3.289,1.059 L6747.298-55962.977z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.21698,0,0,0.21698,-1173.31,12399.4)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#C23521"
    },
    d: "M6711.273-55830.262 c0.271,2.508,1.793,4.367,3.505,5.418c3.533,2.16,8.913,1,11.087-4.719c1.93-5.113-0.625-8.602-4.266-9.691 c-2.636-0.789-6.386-0.488-8.777,2.215c-1.142,1.301-1.93,2.906-2.174,5.063 C6710.376-55831.32,6710.648-55830.57,6711.273-55830.262z M6715.648-55832.75c-0.163,1.816,0.462,3.035,1.521,3.563 c1.305,0.633,2.908-0.172,3.56-2.184c0.516-1.586-0.517-2.441-1.767-2.449c-1.06-0.008-2.201,0.316-3.288,1.059 L6715.648-55832.75z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.21698,0,0,0.21698,-1159.89,12363.2)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#C23521"
    },
    d: "M6666.231-55708.762 c0.272,2.508,1.793,4.367,3.505,5.418c3.533,2.16,8.913,1,11.087-4.719c1.929-5.113-0.625-8.602-4.266-9.691 c-2.636-0.789-6.386-0.488-8.778,2.215c-1.141,1.301-1.929,2.906-2.174,5.063 C6665.334-55709.82,6665.606-55709.07,6666.231-55708.762z M6670.606-55711.254c-0.163,1.82,0.462,3.039,1.521,3.566 c1.305,0.633,2.908-0.172,3.56-2.184c0.516-1.586-0.517-2.441-1.767-2.449c-1.06-0.008-2.201,0.32-3.288,1.059 L6670.606-55711.254z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.21698,0,0,0.21698,-1139.57,12399.4)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#C23521"
    },
    d: "M6598.03-55830.262c0.272,2.508,1.794,4.367,3.505,5.418 c3.533,2.16,8.913,1,11.087-4.719c1.93-5.113-0.625-8.602-4.267-9.691c-2.636-0.789-6.386-0.488-8.777,2.215 c-1.141,1.301-1.929,2.906-2.174,5.063C6597.133-55831.32,6597.405-55830.57,6598.03-55830.262z M6602.405-55832.75 c-0.163,1.816,0.462,3.035,1.522,3.563c1.305,0.633,2.908-0.172,3.56-2.184c0.516-1.586-0.516-2.441-1.766-2.449 c-1.06-0.008-2.202,0.316-3.288,1.059L6602.405-55832.75z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.21698,0,0,0.21698,-1139.57,12434.1)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#C23521"
    },
    d: "M6598.03-55946.727c0.272,2.512,1.794,4.371,3.505,5.422 c3.533,2.16,8.913,1,11.087-4.719c1.93-5.113-0.625-8.602-4.267-9.691c-2.636-0.789-6.386-0.492-8.777,2.215 c-1.141,1.301-1.929,2.906-2.174,5.063C6597.133-55947.781,6597.405-55947.031,6598.03-55946.727z M6602.405-55949.215 c-0.163,1.82,0.462,3.039,1.522,3.566c1.305,0.633,2.908-0.176,3.56-2.184c0.516-1.586-0.516-2.441-1.766-2.449 c-1.06-0.008-2.202,0.316-3.288,1.055L6602.405-55949.215z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.21698,0,0,0.21698,-1108.25,12415.1)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#C23521"
    },
    d: "M6492.91-55882.953c0.272,2.508,1.794,4.367,3.505,5.418 c3.533,2.16,8.914,1,11.087-4.719c1.93-5.113-0.625-8.602-4.267-9.691c-2.636-0.789-6.386-0.492-8.777,2.215 c-1.141,1.301-1.929,2.906-2.174,5.063C6492.013-55884.012,6492.285-55883.262,6492.91-55882.953z M6497.285-55885.445 c-0.163,1.82,0.462,3.039,1.522,3.566c1.304,0.633,2.908-0.172,3.56-2.184c0.516-1.586-0.516-2.441-1.766-2.449 c-1.06-0.008-2.201,0.316-3.288,1.059L6497.285-55885.445z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.21698,0,0,0.21698,-1114.86,12370.2)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#C23521"
    },
    d: "M6515.096-55732.258 c0.272,2.508,1.793,4.371,3.505,5.418c3.533,2.16,8.913,1,11.087-4.715c1.929-5.117-0.625-8.602-4.266-9.695 c-2.636-0.789-6.386-0.488-8.778,2.219c-1.141,1.297-1.929,2.906-2.174,5.063 C6514.199-55733.316,6514.47-55732.563,6515.096-55732.258z M6519.471-55734.746c-0.163,1.816,0.462,3.039,1.522,3.566 c1.304,0.633,2.907-0.176,3.56-2.188c0.516-1.582-0.517-2.438-1.767-2.445c-1.06-0.012-2.201,0.316-3.288,1.055 L6519.471-55734.746z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.21698,0,0,0.21698,-1123.26,12337.1)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#C23521"
    },
    d: "M6543.289-55621.16c0.271,2.508,1.793,4.371,3.505,5.418 c3.533,2.16,8.914,1,11.087-4.719c1.93-5.113-0.625-8.598-4.267-9.691c-2.636-0.789-6.386-0.488-8.777,2.219 c-1.141,1.297-1.929,2.902-2.174,5.063C6542.392-55622.219,6542.664-55621.469,6543.289-55621.16z M6547.664-55623.648 c-0.163,1.816,0.462,3.035,1.522,3.563c1.305,0.633,2.908-0.172,3.56-2.184c0.516-1.586-0.516-2.441-1.766-2.449 c-1.06-0.008-2.201,0.32-3.288,1.059L6547.664-55623.648z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.21698,0,0,0.21698,-1132.69,12294.5)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#C23521"
    },
    d: "M6574.938-55478.184 c0.272,2.508,1.794,4.371,3.506,5.418c3.532,2.16,8.913,1.004,11.087-4.715c1.93-5.113-0.625-8.602-4.266-9.695 c-2.636-0.785-6.386-0.488-8.777,2.219c-1.141,1.301-1.929,2.906-2.174,5.063 C6574.042-55479.238,6574.314-55478.488,6574.938-55478.184z M6579.314-55480.672c-0.163,1.816,0.462,3.039,1.521,3.566 c1.304,0.633,2.908-0.176,3.56-2.188c0.516-1.582-0.516-2.438-1.766-2.445c-1.06-0.008-2.202,0.316-3.289,1.055 L6579.314-55480.672z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.21698,0,0,0.21698,-1123.26,12268.4)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#C23521"
    },
    d: "M6543.289-55390.582 c0.271,2.508,1.793,4.367,3.505,5.418c3.533,2.16,8.914,1,11.087-4.719c1.93-5.113-0.625-8.602-4.267-9.691 c-2.636-0.789-6.386-0.488-8.777,2.215c-1.141,1.301-1.929,2.906-2.174,5.063 C6542.392-55391.641,6542.664-55390.891,6543.289-55390.582z M6547.664-55393.074c-0.163,1.82,0.462,3.039,1.522,3.566 c1.305,0.633,2.908-0.172,3.56-2.184c0.516-1.586-0.516-2.441-1.766-2.449c-1.06-0.008-2.201,0.316-3.288,1.059 L6547.664-55393.074z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.21698,0,0,0.21698,-1083.84,12290.4)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#C23521"
    },
    d: "M6410.982-55464.422 c0.272,2.508,1.793,4.367,3.505,5.418c3.532,2.16,8.913,1,11.086-4.719c1.93-5.113-0.625-8.598-4.266-9.691 c-2.636-0.789-6.386-0.488-8.778,2.219c-1.141,1.297-1.929,2.902-2.174,5.063 C6410.085-55465.48,6410.357-55464.73,6410.982-55464.422z M6415.357-55466.91c-0.163,1.816,0.462,3.035,1.521,3.563 c1.305,0.633,2.908-0.172,3.561-2.184c0.516-1.586-0.517-2.441-1.767-2.449c-1.06-0.008-2.201,0.32-3.288,1.059 L6415.357-55466.91z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.21698,0,0,0.21698,-1108.25,12309.3)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#C23521"
    },
    d: "M6492.91-55527.855c0.272,2.508,1.794,4.371,3.505,5.418 c3.533,2.16,8.914,1,11.087-4.719c1.93-5.113-0.625-8.598-4.267-9.691c-2.636-0.789-6.386-0.488-8.777,2.219 c-1.141,1.297-1.929,2.902-2.174,5.063C6492.013-55528.914,6492.285-55528.164,6492.91-55527.855z M6497.285-55530.344 c-0.163,1.816,0.462,3.039,1.522,3.563c1.304,0.637,2.908-0.172,3.56-2.184c0.516-1.582-0.516-2.438-1.766-2.449 c-1.06-0.008-2.201,0.32-3.288,1.059L6497.285-55530.344z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.21698,0,0,0.21698,-1064.78,12322.2)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#C23521"
    },
    d: "M6347.011-55571.152 c0.272,2.508,1.793,4.367,3.505,5.418c3.533,2.16,8.913,1,11.087-4.719c1.929-5.113-0.625-8.602-4.267-9.691 c-2.636-0.789-6.386-0.488-8.778,2.215c-1.141,1.301-1.929,2.906-2.174,5.066 C6346.114-55572.211,6346.385-55571.461,6347.011-55571.152z M6351.386-55573.645c-0.163,1.82,0.462,3.039,1.521,3.566 c1.305,0.633,2.908-0.172,3.56-2.184c0.516-1.586-0.517-2.441-1.767-2.449c-1.06-0.008-2.201,0.32-3.288,1.059 L6351.386-55573.645z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.21698,0,0,0.21698,-1086.14,12342.7)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#C23521"
    },
    d: "M6418.702-55639.957 c0.271,2.508,1.793,4.367,3.505,5.418c3.533,2.16,8.913,1,11.087-4.719c1.929-5.113-0.625-8.602-4.266-9.691 c-2.636-0.789-6.386-0.488-8.778,2.215c-1.141,1.301-1.929,2.906-2.174,5.063 C6417.805-55641.016,6418.077-55640.266,6418.702-55639.957z M6423.077-55642.445c-0.163,1.816,0.462,3.035,1.522,3.563 c1.305,0.633,2.908-0.172,3.56-2.184c0.516-1.586-0.517-2.441-1.767-2.449c-1.06-0.008-2.201,0.316-3.288,1.059 L6423.077-55642.445z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.21698,0,0,0.21698,-1047.78,12345.3)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#C23521"
    },
    d: "M6289.953-55648.684 c0.272,2.508,1.793,4.371,3.505,5.418c3.532,2.16,8.913,1,11.087-4.715c1.93-5.117-0.625-8.602-4.266-9.695 c-2.636-0.789-6.386-0.488-8.777,2.219c-1.141,1.297-1.929,2.902-2.174,5.063 C6289.056-55649.742,6289.328-55648.988,6289.953-55648.684z M6294.328-55651.172c-0.163,1.816,0.462,3.039,1.521,3.566 c1.305,0.633,2.908-0.176,3.56-2.188c0.516-1.582-0.516-2.438-1.766-2.445c-1.06-0.012-2.202,0.316-3.289,1.055 L6294.328-55651.172z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.21698,0,0,0.21698,-1086.14,12378.4)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#C23521"
    },
    d: "M6418.702-55759.781 c0.271,2.508,1.793,4.371,3.505,5.422c3.533,2.16,8.913,0.996,11.087-4.719c1.929-5.113-0.625-8.602-4.266-9.695 c-2.636-0.785-6.386-0.488-8.778,2.219c-1.141,1.301-1.929,2.906-2.174,5.063 C6417.805-55760.836,6418.077-55760.086,6418.702-55759.781z M6423.077-55762.27c-0.163,1.82,0.462,3.039,1.522,3.566 c1.305,0.633,2.908-0.176,3.56-2.184c0.516-1.586-0.517-2.441-1.767-2.449c-1.06-0.008-2.201,0.316-3.288,1.055 L6423.077-55762.27z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.21698,0,0,0.21698,-1043.06,12374.3)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#C23521"
    },
    d: "M6274.111-55746.016 c0.271,2.508,1.793,4.367,3.505,5.418c3.533,2.16,8.913,1,11.087-4.719c1.93-5.113-0.625-8.602-4.266-9.691 c-2.636-0.789-6.386-0.492-8.777,2.215c-1.141,1.301-1.929,2.906-2.174,5.063 C6273.214-55747.074,6273.486-55746.324,6274.111-55746.016z M6278.486-55748.508c-0.163,1.82,0.462,3.039,1.521,3.566 c1.305,0.633,2.908-0.172,3.561-2.184c0.516-1.586-0.517-2.441-1.767-2.449c-1.06-0.008-2.201,0.316-3.289,1.059 L6278.486-55748.508z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.21698,0,0,0.21698,-1023.81,12403.4)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#C23521"
    },
    d: "M6209.501-55843.688 c0.272,2.508,1.794,4.367,3.505,5.418c3.533,2.16,8.914,1,11.087-4.719c1.93-5.113-0.625-8.598-4.266-9.691 c-2.636-0.789-6.386-0.488-8.777,2.219c-1.141,1.297-1.929,2.902-2.174,5.063 C6208.605-55844.746,6208.876-55843.996,6209.501-55843.688z M6213.876-55846.176c-0.163,1.816,0.462,3.035,1.522,3.563 c1.304,0.633,2.908-0.172,3.56-2.184c0.517-1.586-0.516-2.441-1.766-2.449c-1.06-0.008-2.202,0.32-3.289,1.059 L6213.876-55846.176z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.21698,0,0,0.21698,-1060.46,12395.1)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#C23521"
    },
    d: "M6332.511-55815.828 c0.272,2.508,1.794,4.371,3.505,5.418c3.533,2.16,8.914,1,11.087-4.715c1.93-5.117-0.625-8.602-4.266-9.695 c-2.636-0.789-6.386-0.488-8.777,2.219c-1.141,1.297-1.929,2.902-2.174,5.063 C6331.614-55816.887,6331.886-55816.137,6332.511-55815.828z M6336.886-55818.316c-0.163,1.816,0.462,3.039,1.521,3.563 c1.305,0.637,2.908-0.172,3.56-2.184c0.516-1.582-0.517-2.438-1.766-2.449c-1.06-0.008-2.201,0.32-3.289,1.059 L6336.886-55818.316z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.21698,0,0,0.21698,-1065.18,12423.8)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#C23521"
    },
    d: "M6348.354-55912.156 c0.272,2.508,1.793,4.371,3.505,5.418c3.532,2.16,8.913,1,11.087-4.715c1.929-5.113-0.625-8.602-4.266-9.695 c-2.636-0.789-6.386-0.488-8.778,2.219c-1.141,1.297-1.929,2.906-2.174,5.063 C6347.457-55913.211,6347.728-55912.461,6348.354-55912.156z M6352.729-55914.645c-0.163,1.816,0.462,3.039,1.521,3.566 c1.305,0.633,2.908-0.176,3.56-2.188c0.516-1.582-0.517-2.438-1.767-2.445c-1.06-0.012-2.201,0.316-3.288,1.055 L6352.729-55914.645z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.21698,0,0,0.21698,-1272.4,12333.3)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#C23521"
    },
    d: "M7043.852-55608.406 c0.272,2.508,1.793,4.367,3.505,5.418c3.533,2.16,8.913,1,11.087-4.719c1.93-5.113-0.625-8.602-4.266-9.691 c-2.636-0.789-6.386-0.488-8.777,2.215c-1.141,1.301-1.929,2.906-2.174,5.063 C7042.955-55609.465,7043.227-55608.715,7043.852-55608.406z M7048.227-55610.895c-0.163,1.816,0.462,3.035,1.521,3.563 c1.305,0.633,2.908-0.172,3.56-2.184c0.516-1.586-0.516-2.441-1.766-2.449c-1.06-0.008-2.201,0.316-3.288,1.059 L7048.227-55610.895z"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#201F1D"
    },
    d: "M23801.178-30431.436 c-0.271,0.576-0.598,1.111-0.842,1.709c-0.219,0.584-0.354,1.195-0.543,1.799c-1.088,3.846-2.094,7.717-2.99,11.615 c-0.217,0.977-0.408,1.959-0.625,2.939c0,0.041,0.027,0.082,0.055,0.092c0.055,0.012,0.082-0.01,0.107-0.049 c0.328-0.945,0.707-1.875,1.006-2.828c1.25-3.803,2.283-7.666,3.398-11.498c0.189-0.598,0.379-1.188,0.516-1.799 c0.135-0.625,0.162-1.242,0.271-1.875c0.027-0.092-0.027-0.193-0.137-0.221 C23801.314-30431.58,23801.205-30431.527,23801.178-30431.436z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#201F1D"
    },
    d: "M23800.824-30430.748c0.027,0.674,0,1.313,0.109,1.975 c0.109,0.639,0.354,1.254,0.543,1.873c0.869,2.965,1.848,5.896,2.799,8.84c0.625,1.959,1.277,3.902,1.793,5.9 c0.027,0.115,0.137,0.191,0.273,0.168c0.107-0.025,0.189-0.139,0.162-0.258c-0.543-3.201-1.25-6.354-2.146-9.465 c-0.707-2.477-1.305-4.998-2.283-7.385c-0.271-0.621-0.625-1.146-0.924-1.744c-0.027-0.092-0.107-0.148-0.217-0.121 C23800.852-30430.941,23800.797-30430.844,23800.824-30430.748z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#201F1D"
    },
    d: "M23841.994-30387.139c0.951-0.727,1.902-1.438,2.771-2.244 c0.896-0.803,1.686-1.684,2.5-2.563c6.332-6.93,11.412-15.211,15.109-24.09c4.592-11.107,6.957-23.164,7.064-34.699 c0-0.08-0.055-0.143-0.135-0.143c-0.055-0.002-0.137,0.059-0.137,0.137c-0.354,11.449-3.098,23.311-7.771,34.289 c-3.75,8.732-8.723,16.895-14.891,23.813c-0.789,0.881-1.604,1.717-2.393,2.586c-0.814,0.881-1.549,1.787-2.363,2.652 c-0.082,0.066-0.082,0.178,0,0.25C23841.803-30387.08,23841.912-30387.074,23841.994-30387.139z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#201F1D"
    },
    d: "M23866.207-30428.234c0.299-0.244,0.57-0.424,0.842-0.703 c0.924-1.053,1.576-2.326,2.311-3.514c1.357-2.248,2.553-4.576,3.504-7.094c0.082-0.223-0.027-0.469-0.244-0.557 c-0.217-0.084-0.488,0.027-0.57,0.248c-0.463,1.217-1.006,2.383-1.604,3.518c-1.113,2.145-2.609,4.063-3.777,6.205 c-0.299,0.549-0.488,1.121-0.762,1.697c-0.053,0.08-0.025,0.191,0.055,0.246 C23866.043-30428.135,23866.152-30428.156,23866.207-30428.234z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#201F1D"
    },
    d: "M23944.006-30368.994c0.164-0.381,0.326-0.734,0.436-1.125 c0.951-3.576,0.869-7.137,0.869-10.598c-0.027-5.764-0.68-11.443-1.033-17.607c-0.299-4.902-0.488-9.674-0.598-14.377 c-0.135-4.826-0.162-9.582,0.164-14.352c0.434-6.221,1.357-12.453,3.098-18.875c0.055-0.139-0.027-0.285-0.164-0.326 c-0.135-0.041-0.299,0.039-0.326,0.18c-2.555,8.049-3.857,15.85-4.293,23.734c-0.436,7.875,0,15.813,0.543,24.121 c0.49,6.137,1.305,11.777,1.496,17.52c0.107,3.408-0.273,6.816-0.545,10.451c-0.027,0.4,0.027,0.783,0,1.188 c0,0.096,0.055,0.188,0.164,0.207C23943.896-30368.834,23944.006-30368.896,23944.006-30368.994z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#201F1D"
    },
    d: "M23943.518-30408.484c-0.137,0.451-0.299,0.359-0.244,0.82 c0.107,0.686,0.76,1.164,1.168,1.727c3.152,4.344,6.656,8.576,9.836,12.951c1.387,1.889,2.771,3.742,3.996,5.693 c0.08,0.176,0.326,0.244,0.488,0.143c0.189-0.098,0.244-0.32,0.164-0.5c-0.951-1.955-1.93-3.885-3.1-5.758 c-1.113-1.842-2.363-3.619-3.641-5.383c-2.311-3.164-4.564-6.369-7.012-9.32c-0.162-0.201-0.299-0.463-0.516-0.568 c-0.434-0.193-0.408-0.006-0.869-0.014c-0.055-0.078-0.164-0.096-0.244-0.039 C23943.463-30408.672,23943.463-30408.563,23943.518-30408.484z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#201F1D"
    },
    d: "M23944.523-30407.924 c-0.027,0.527-0.137,1.002-0.109,1.527c0.109,1.988,0.734,3.904,1.277,5.809c1.549,5.508,3.832,10.789,5.543,16.289 c0.082,0.244,0.326,0.385,0.57,0.313c0.244-0.074,0.381-0.334,0.326-0.582l-7.256-23.41c0-0.096-0.107-0.164-0.189-0.146 C23944.576-30408.109,23944.523-30408.02,23944.523-30407.924z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.457451,0,0,0.42374,-11078.8,11511.8)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FFFFFF"
    },
    d: "M24845.318-26656.684 c-14.375,0.24-28.615,12.568-28.125,40.463c0.461,27.797,1.25,46.023-1.875,65.717c-4.783,30.002-4.078,46.693,4.348,57.596 c0,0-7.773-20.873-0.109-40.953c0,0-8.342,34.383,14.973,50.258c0,0-3.098-10.586-1.82-19.346c0,0-1.521,17.885,14.131,22.891 l1.576-19.535l2.744,19.881c0,0,23.67-3.52,27.311-33.68c0,0,1.875,11.938-6.305,23.846c0,0,18.424-13.393,15.271-38.422 c-3.152-25.031-8.83-39.129-8.967-46.061C24877.791-26605.734,24884.992-26657.344,24845.318-26656.684z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookWorldM);
export default __webpack_public_path__ + "static/media/book-world-m.6cbb3ef30964d4e6eee1ebaf71915978.svg";
export { ForwardRef as ReactComponent };